const zh_CN = {
  //region 通用翻译
  txt_return: "返回",
  //endregion

  /*region scenes*/
  /*region common*/
  /*region Portal*/
  scenes_common_Portal_home: "主页",
  scenes_common_Portal_login: "登录",
  scenes_common_Portal_register: "注册",
  scenes_common_Portal_components_rapidRegs: "快速注册",
  scenes_common_Portal_components_companion: "合作伙伴",
  scenes_common_Portal_components_appMarket: "应用市场",
  scenes_common_Portal_components_solutions: "解决方案",
  scenes_common_Portal_console: "控制台",
  scenes_common_Portal_logout: "登出",
  scenes_common_Portal_view_details: "查看详情",
  scenes_common_Portal_appMarketPortal: "云市场",
  /*endregion Portal*/

  //region PlatformFrame
  scenes_common_PlatformFrame_home: "主页",
  //endregion

  /*region ConsoleHome*/
  scenes_common_ConsoleHome_VerifyingUserListComponent_userName: "用户名",
  scenes_common_ConsoleHome_VerifyingUserListComponent_registrationTime: "注册时间",
  scenes_common_ConsoleHome_VerifyingUserListComponent_status: "用户状态",
  scenes_common_ConsoleHome_VerifyingUserListComponent_viewAll: "查看全部",
  scenes_common_ConsoleHome_VerifyingUserListComponent_title: "待审核用户列表",
  //region 侧边栏条目
  scenes_common_ConsoleHome_SideBar_Dashboard: "管理控制台",
  scenes_common_ConsoleHome_SideBar_Messages: "消息中心",
  scenes_common_ConsoleHome_SideBar_Space: "租户空间",
  scenes_common_ConsoleHome_SideBar_CustomLogin: "定制化登录",
  scenes_common_ConsoleHome_SideBar_EnterpriseUsers: "企业用户",
  scenes_common_ConsoleHome_SideBar_EnterpriseApps: "企业应用",
  scenes_common_ConsoleHome_SideBar_EnterpriseAppCategoryOneLabel: "企业应用目录1",
  scenes_common_ConsoleHome_SideBar_EnterpriseAppCategoryTwoLabel: "企业应用目录2",
  scenes_common_ConsoleHome_SideBar_AppCatalogManagementLabel: "应用类别管理",
  scenes_common_ConsoleHome_SideBar_AccountInfoLabel: "账户信息",
  scenes_common_ConsoleHome_SideBar_AppMarketLabel: "App Market",
  scenes_common_ConsoleHome_SideBar_AlgorithmRepoLabel: "算法库",
  //endregion

  //region 页首
  scenes_common_ConsoleHome_Header_BasicSetting: "基本信息",
  scenes_common_ConsoleHome_Header_SecuritySetting: "安全设置",
  scenes_common_ConsoleHome_Header_Message: "通知",
  scenes_common_ConsoleHome_Header_Logout: "登出",
  //endregion

  //region 菜单
  scenes_common_ConsoleHome_Menu_console: "控制台",
  scenes_common_ConsoleHome_Menu_message: "通知管理",
  scenes_common_ConsoleHome_Menu_message_sent: "通知发送",
  scenes_common_ConsoleHome_Menu_message_received: "通知接收",
  scenes_common_ConsoleHome_Menu_role_assign: "配置通知发送角色",
  scenes_common_ConsoleHome_Menu_message_type: "通知类型",
  scenes_common_ConsoleHome_Menu_enterprise_account: "企业账户",
  scenes_common_ConsoleHome_Menu_private_account: "个人账户",
  scenes_common_ConsoleHome_Menu_personnel: "个人信息",
  scenes_common_ConsoleHome_Menu_user_details: "基本信息",
  scenes_common_ConsoleHome_Menu_person_account_management: "账户管理",
  scenes_common_ConsoleHome_Menu_modify_user_password: "密码修改",
  scenes_common_ConsoleHome_Menu_apply_privileges: "个人权限修改",
  scenes_common_ConsoleHome_Menu_basic_manage: "基础数据",
  scenes_common_ConsoleHome_Menu_platform_manage: "平台管理",
  scenes_common_ConsoleHome_Menu_enterprise_list_management: "企业审核",
  scenes_common_ConsoleHome_Menu_user_list_management: "用户管理",
  scenes_common_ConsoleHome_Menu_verify_enterprise_auth_list: "企业权限审核",
  scenes_common_ConsoleHome_Menu_verify_user_privileges: "用户权限审核",
  scenes_common_ConsoleHome_Menu_current_users: "在线用户控制",
  scenes_common_ConsoleHome_Menu_history_users: "系统登录日志",
  scenes_common_ConsoleHome_Menu_help_management: "帮助文档管理",
  scenes_common_ConsoleHome_Menu_resource: "平台资源管理",
  scenes_common_ConsoleHome_Menu_resource_monitor: "资源监控",
  scenes_common_ConsoleHome_Menu_apps: "应用管理",
  scenes_common_ConsoleHome_Menu_app_category_management: "应用类别管理",
  scenes_common_ConsoleHome_Menu_app_verify_management: "应用审核管理",
  scenes_common_ConsoleHome_Menu_app_market_management: "应用市场管理",
  scenes_common_ConsoleHome_Menu_app_private_management: "个人应用管理",
  scenes_common_ConsoleHome_Menu_app_private_publish: "个人应用发布",
  scenes_common_ConsoleHome_Menu_app_enterprise_management: "企业应用管理",
  scenes_common_ConsoleHome_Menu_app_enterprise_publish: "企业应用发布",
  scenes_common_ConsoleHome_Menu_enterprise: "企业管理",
  scenes_common_ConsoleHome_Menu_enterprise_account_management: "账户管理",
  scenes_common_ConsoleHome_Menu_enterprise_info_management: "企业信息定制",
  scenes_common_ConsoleHome_Menu_enterprise_privilege_apply: "企业权限申请",
  scenes_common_ConsoleHome_Menu_enterprise_employee_management: "雇员管理",
  scenes_common_ConsoleHome_Menu_role_management: "角色权限管理",
  scenes_common_ConsoleHome_Menu_deployed_apps: "应用管理",
  scenes_common_ConsoleHome_Menu_tenant_app_management: "租户空间应用管理",
  scenes_common_ConsoleHome_Menu_namespace_verify: "租户空间审核",
  scenes_common_ConsoleHome_Menu_initialize_tenant_space: "租户空间",
  scenes_common_ConsoleHome_Menu_show_database_service: "租户数据库",
  scenes_common_ConsoleHome_Menu_increase_quota: "租户资源变更",
  scenes_common_ConsoleHome_Menu_apply_bigdata_quota: "大数据资源申请",
  scenes_common_ConsoleHome_Menu_apply_tsdatabase_space: "时序数据库资源申请",
  scenes_common_ConsoleHome_Menu_algorithm: "算法管理",
  scenes_common_ConsoleHome_Menu_algorithm_category_management: "算法类别",
  scenes_common_ConsoleHome_Menu_algorithm_verification: "算法审核",
  scenes_common_ConsoleHome_Menu_algorithm_list: "算法管理",
  scenes_common_ConsoleHome_Menu_data_analysis_management: "数据分析",
  scenes_common_ConsoleHome_Menu_dataset_management: "数据集管理",
  scenes_common_ConsoleHome_Menu_model_management: "模型管理",
  scenes_common_ConsoleHome_Menu_project_management: "工程管理",
  scenes_common_ConsoleHome_Menu_hub_management: "工作区管理",
  scenes_common_ConsoleHome_Menu_extension_management: "Qlik工程",
  scenes_common_ConsoleHome_Menu_equipments: "数采管理",
  scenes_common_ConsoleHome_Menu_equipment_certify_verify: "设备证书审核",
  scenes_common_ConsoleHome_Menu_equipment_certify_list: "设备证书管理",
  scenes_common_ConsoleHome_Menu_equipment_type_list: "设备类型管理",
  scenes_common_ConsoleHome_Menu_equipment_management: "设备管理",
  scenes_common_ConsoleHome_Menu_equipment_history_data: "历史数据管理",

  scenes_common_ConsoleHome_Menu_resource_price: "资源价格列表",
  scenes_common_ConsoleHome_Menu_resource_discount: "资源折扣率列表",
  scenes_common_ConsoleHome_Menu_portal_verification: "企业门户审核",
  scenes_common_ConsoleHome_Menu_meta_data: "平台主数据管理",
  scenes_common_ConsoleHome_Menu_meta_data_list: "平台主数据列表",
  scenes_common_ConsoleHome_Menu_meta_data_category_verification: "主数据类别管理",
  scenes_common_ConsoleHome_Menu_meta_data_tree: "树状主数据列表",
  scenes_common_ConsoleHome_Menu_log_management: "日志管理",
  scenes_common_ConsoleHome_Menu_apps_list: "应用列表",
  scenes_common_ConsoleHome_Menu_app_market: "应用市场",
  scenes_common_ConsoleHome_Menu_develop_project: "开发项目管理",
  scenes_common_ConsoleHome_Menu_develop_app: "开发应用管理",
  scenes_common_ConsoleHome_Menu_publish_app: "发布新应用",
  scenes_common_ConsoleHome_Menu_algorithm_add: "算法添加",
  scenes_common_ConsoleHome_Menu_algorithm_edit: "算法修改",
  scenes_common_ConsoleHome_Menu_algorithm_view: "算法浏览",
  scenes_common_ConsoleHome_Menu_algorithm_repository_management: "算法库管理",
  scenes_common_ConsoleHome_Menu_private_algorithm_management: "个人算法管理",
  scenes_common_ConsoleHome_Menu_enterprise_info: "企业信息",
  scenes_common_ConsoleHome_Menu_portal_configuration: "企业门户配置",
  scenes_common_ConsoleHome_Menu_portal_logo: "企业Logo配置",
  scenes_common_ConsoleHome_Menu_portal_ad: "广告幻灯片配置",
  scenes_common_ConsoleHome_Menu_portal_service: "服务配置",
  scenes_common_ConsoleHome_Menu_portal_solution: "解决方案配置",
  scenes_common_ConsoleHome_Menu_portal_news: "新闻资讯配置",
  scenes_common_ConsoleHome_Menu_portal_companion: "合作伙伴配置",
  scenes_common_ConsoleHome_Menu_portal_rapid_register: "快速注册配置",
  scenes_common_ConsoleHome_Menu_portal_affix: "浮动条配置",
  scenes_common_ConsoleHome_Menu_portal_footer: "页脚配置",
  scenes_common_ConsoleHome_Menu_enterprise_meta_data: "企业主数据管理",
  scenes_common_ConsoleHome_Menu_role_list: "角色列表",
  scenes_common_ConsoleHome_Menu_department_management: "部门管理",
  scenes_common_ConsoleHome_Menu_tenant_resource: "租户资源管理",
  scenes_common_ConsoleHome_Menu_tenant_resource_monitor: "租户资源监控",
  scenes_common_ConsoleHome_Menu_tenant_resource_list: "租户资源列表",
  scenes_common_ConsoleHome_Menu_tenant_resource_apply: "租户资源申请",
  scenes_common_ConsoleHome_Menu_create_enterprise_details: "新建企业信息",
  scenes_common_ConsoleHome_Menu_edit_enterprise_details: "编辑企业信息",
  scenes_common_ConsoleHome_Menu_company_privilege: "管理企业权限",
  scenes_common_ConsoleHome_Menu_user_management: "用户管理",
  scenes_common_ConsoleHome_Menu_user_invite: "邀请新用户",
  scenes_common_ConsoleHome_Menu_user_verification: "用户审核",
  scenes_common_ConsoleHome_Menu_create_user_certify: "新建用户认证信息",
  scenes_common_ConsoleHome_Menu_edit_user_certify: "编辑用户认证信息",
  scenes_common_ConsoleHome_Menu_edit_user_code: "员工编号",
  scenes_common_ConsoleHome_Menu_edit_user_department: "部门",
  scenes_common_ConsoleHome_Menu_edit_user_job: "岗位",


  //endregion

  //region 资源监控组件
  scenes_common_ConsoleHome_ResourceMonitorComponent_ResourceMonitor: "平台资源监控",
  scenes_common_ConsoleHome_ResourceMonitorComponent_ResourceManagement: "平台资源管理",
  scenes_common_ConsoleHome_ResourceMonitorComponent_CpuUsage: "CPU利用率",
  scenes_common_ConsoleHome_ResourceMonitorComponent_MemoryRatio: "内存利用率",
  scenes_common_ConsoleHome_ResourceMonitorComponent_DiskRatio: "磁盘利用率",
  scenes_common_ConsoleHome_ResourceMonitorComponent_RouteRatio: "路由利用率",
  scenes_common_ConsoleHome_ResourceMonitorComponent_InstanceRatio: "实例利用率",
  scenes_common_ConsoleHome_ResourceMonitorComponent_ServiceRatio: "服务利用率",
  //endregion
  scenes_common_ConsoleHome_ApplicationListComponent_myApplication: "应用列表",
  scenes_common_ConsoleHome_ApplicationListComponent_private_Application: "个人应用列表",
  scenes_common_ConsoleHome_ApplicationListComponent_enterprise_Application: "企业应用列表",
  scenes_common_ConsoleHome_ApplicationListComponent_marketApplication: "市场应用",
  scenes_common_ConsoleHome_ApplicationListComponent_applicationName: "应用名称",
  scenes_common_ConsoleHome_ApplicationListComponent_applicationCategory: "应用类别",
  scenes_common_ConsoleHome_ApplicationListComponent_deploymentCount: "下载次数",
  scenes_common_ConsoleHome_ApplicationListComponent_query: "查询",
  scenes_common_ConsoleHome_ApplicationListComponent_reset: "重置",

  //region 控制台应用显示页面
  scenes_ConsoleApplicationPage_return_console: "返回控制台",
  //endregion

  //region Account Information
  scenes_common_ConsoleHome_Account_AccountBalanceLabel: "账户余额",
  scenes_common_ConsoleHome_Account_Transfer: "充值",
  scenes_common_ConsoleHome_Account_Withdraw: "提现",
  scenes_common_ConsoleHome_Account_AccountDetails: "账户明细",
  scenes_common_ConsoleHome_Account_ChooseTime: "选择时间",
  scenes_common_ConsoleHome_Account_OrderStatus: "订单状态",
  scenes_common_ConsoleHome_Account_IncomeStatistics: "收入统计",
  scenes_common_ConsoleHome_Account_ExpenditureStatisticsNearly12Months: "近12个月支出统计",
  scenes_commom_ConsoleHome_Account_Revenue: "收入额",
  scenes_commom_ConsoleHome_Account_Expenditure: "消费额",
  scenes_commom_ConsoleHome_Account_RMB: "￥",
  scenes_common_ConsoleHome_Account_ExportRunningInfo: "导出流水明细",
  scenes_common_ConsoleHome_Account_BalanceOverview: "收支总览",
  scenes_common_ConsoleHome_Account_ClassificationOverview: "分类总览",
  scenes_common_ConsoleHome_Account_Time: "时间",
  scenes_common_ConsoleHome_Account_Category: "类别",
  scenes_common_ConsoleHome_Account_Content: "操作",
  scenes_common_ConsoleHome_Account_Income: "收入",
  scenes_common_ConsoleHome_Account_Cost: "支出",
  scenes_common_ConsoleHome_Account_SumIncome: "总共收入",
  scenes_common_ConsoleHome_Account_SumCost: "总共支出",
  //endregion
  /*endregion ConsoleHome*/

  /*endregion common*/

  /*region user*/

  /*endregion user*/

  /*region enterprise*/
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_title: "待审核企业列表",
  scenes_common_ConsoleHome_EnterpriseListComponent_submitTime: "申请时间",
  scenes_common_ConsoleHome_EnterpriseListComponent_name: "企业名称",
  scenes_common_ConsoleHome_EnterpriseListComponent_status: "企业状态",
  scenes_common_ConsoleHome_EnterpriseListComponent_lastAuthTime: "最后审核时间",
  scenes_common_ConsoleHome_EnterpriseListComponent_lastAuditor: "审核人",
  scenes_common_ConsoleHome_EnterpriseListComponent_search: "查询",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_viewAll: "查看全部",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_submitTime: "申请时间",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_name: "企业名称",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_status: "企业状态",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_lastAuthTime: "最后审核时间",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_lastAuditor: "审核人",
  scenes_common_ConsoleHome_VerifyingEnterpriseListComponent_search: "查询",
  /*endregion enterprise*/

  /*region role*/
  /*endregion role*/

  /*region application*/
  /*endregion application*/

  /*region algorithm*/
  scenes_common_ConsoleHome_AlgorithmListComponent_name: "算法名称",
  scenes_common_ConsoleHome_AlgorithmListComponent_updateTime: "上传时间",
  scenes_common_ConsoleHome_AlgorithmListComponent_status: "审核状态",
  scenes_common_ConsoleHome_AlgorithmListComponent_developerName: "开发者",
  scenes_common_ConsoleHome_AlgorithmListComponent_verifyAlgorithm: "审核算法",
  scenes_common_ConsoleHome_AlgorithmListComponent_pendingAlgorithm: "待审核算法列表",
  scenes_common_ConsoleHome_AlgorithmListComponent_search: "查询",
  scenes_common_ConsoleHome_AlgorithmListComponent_algorithmList: "算法管理",
  scenes_common_ConsoleHome_AlgorithmListComponent_algorithm: "算法列表",
  scenes_common_ConsoleHome_AlgorithmListComponent_algorithmName: "算法名称",
  scenes_common_ConsoleHome_AlgorithmListComponent_algorithmStatus: "算法状态",
  scenes_common_ConsoleHome_AlgorithmListComponent_reset: "重置",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_name: "算法名称",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_updateTime: "上传时间",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_status: "审核状态",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_developerName: "开发者",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_verifyAlgorithm: "审核算法",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_pendingAlgorithm: "待审核算法列表",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_search: "查询",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_algorithmList: "算法管理",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_algorithmStatus: "算法状态",
  scenes_common_ConsoleHome_VerifyingAlgorithmListComponent_reset: "重置",
  /*endregion algorithm*/

  /*region 企业应用导航*/
  scenes_common_ConsoleHome_ApplicationNavigation_application: "企业应用导航",
  /*endregion 企业应用导航*/

  /*region space*/
  /*region 管理空间应用列表*/
  scenes_SpaceAppsManagement_ApplicationType: "应用类型",
  scenes_SpaceAppsManagement_ApplicationName: "名称",
  scenes_SpaceAppsManagement_InstanceNum: "实例数",
  scenes_SpaceAppsManagement_CPU: "CPU",
  scenes_SpaceAppsManagement_Storage: "存储",
  scenes_SpaceAppsManagement_Memory: "内存",
  scenes_SpaceAppsManagement_URL: "URL",
  scenes_SpaceAppsManagement_State: "状态",
  scenes_SpaceAppsManagement_SearchButton: "搜索",
  scenes_SpaceAppsManagement_SearchPlaceHolder: "搜索应用",
  scenes_SpaceAppsManagement_AllState: "运行状态",
  scenes_SpaceAppsManagement_Category: "应用类型",

  scenes_SpaceAppsManagement_Running: "运行",
  scenes_SpaceAppsManagement_Stopped: "停止",
  scenes_SpaceAppsManagement_Crashed: "宕机",
  scenes_SpaceAppsManagement_Booting: "启动中",
  scenes_SpaceAppsManagement_Third_Party: "第三方",
  scenes_SpaceAppsManagement_state_unknown: "状态未知",

  scenes_SpaceAppsManagement_MarketApplication: "市场应用",
  scenes_SpaceAppsManagement_CustomApplication: "私有应用",
  /*endregion 管理空间应用列表*/
  /*endregion space*/

  /*region 管理空间应用详情页*/
  scenes_AppConfigAndConditionPage_value_can_not_null: "该值不能为空",
  scenes_AppConfigAndConditionPage_app_name: "应用名称",
  scenes_AppConfigAndConditionPage_btn_save: "保存",
  scenes_AppConfigAndConditionPage_btn_reset: "重置",
  scenes_AppConfigAndConditionPage_save_success: "修改成功",
  scenes_AppConfigAndConditionPage_save_fail: "修改失败",
  scenes_ConsoleHome_EnterPrisePermissionComponent_permission: "应用权限",
  scenes_ConsoleHome_EnterPrisePermissionComponent_mannage_permission: "待审核企业权限",
  scenes_ConsoleHome_EnterPrisePermissionComponent_viewAll: "查看全部",
  scenes_AppConfigAndConditionPage_app_scaling: "应用规模",
  scenes_AppConfigAndConditionPage_label_cpu: "CPU上限",
  scenes_AppConfigAndConditionPage_label_memory: "内存上限",
  scenes_AppConfigAndConditionPage_label_diskQuota: "存储上限",
  scenes_AppConfigAndConditionPage_value_should_be_integer: "该值应为整数",
  scenes_AppConfigAndConditionPage_app_instances: "应用实例",
  scenes_AppConfigAndConditionPage_index: "序号",
  scenes_AppConfigAndConditionPage_memory_usage: "内存",
  scenes_AppConfigAndConditionPage_cpu_usage: "CPU",
  scenes_AppConfigAndConditionPage_disk_usage: "存储",
  scenes_AppConfigAndConditionPage_app_event_records: "应用事件记录",
  scenes_AppConfigAndConditionPage_page_size: "显示{num}行",
  scenes_AppConfigAndConditionPage_operation_success: "操作成功",
  scenes_AppConfigAndConditionPage_operation_fail: "操作失败",


  /*endregion*/

  // region UserInvitationPage
  scenes_UserInvitationPage_wrong_format: "格式错误",
  scenes_UserInvitationPage_email_input_placeholder: "请输入邮件地址以进行邀请,格式名字,邮箱。例如: 王小二,wang@test.com",
  scenes_UserInvitationPage_email_input_button_label: "输入邮件地址",
  scenes_UserInvitationPage_file_input_label: "选择csv文件, 文件每行格式为姓名,邮箱",
  scenes_UserInvitationPage_upload_button_label: "导入邮件列表",
  scenes_UserInvitationPage_email_search_placeholder: "通过名字,邮件或者状态查询",
  scenes_UserInvitationPage_username_label: "姓名",
  scenes_UserInvitationPage_email_label: "邮箱",
  scenes_UserInvitationPage_table_status_title: "状态",
  scenes_UserInvitationPage_table_invitation_url_title: "邀请链接",
  scenes_UserInvitationPage_employee_create_time: "邀请创建时间",
  scenes_UserInvitationPage_status_pending_invite: "等待邀请",
  scenes_UserInvitationPage_status_pending_activate: "等待激活",
  scenes_UserInvitationPage_status_failed_to_invite: "邀请失败",
  scenes_UserInvitationPage_status_activated: "已激活",
  scenes_UserInvitationPage_status_timeout_to_activate: "邀请超时",
  scenes_UserInvitationPage_status_disabled: "封存",
  scenes_UserInvitationPage_status_reinvited: "重邀请",
  scenes_UserInvitationPage_status_email_fail: "邮件邀请失败",
  scenes_UserInvitationPage_sending_spinner_label: "发送请求中",
  scenes_UserInvitationPage_loading_spinner_label: "数据加载中",
  scenes_UserInvitationPage_invite_button_label: "邀请",
  scenes_UserInvitationPage_invited_button_label: "已邀请，无法重复邀请",
  scenes_UserInvitationPage_invite_all: "一键邀请",
  scenes_UserInvitationPage_delete_selected_user: "删除邀请",
  scenes_UserInvitationPage_export_invited_invitation_list: "已成功邀请雇员信息表导出",
  scenes_UserInvitationPage_export_uninvited_user_list: "未成功邀请雇员信息表导出",
  scenes_UserInvitationPage_invite_selected_user: "发送邀请",
  scenes_UserInvitationPage_email_existed: "Email已存在",
  scenes_UserInvitationPage_request_success: "请求成功",
  scenes_UserInvitationPage_request_failed: "请求失败",
  scenes_UserInvitationPage_wrong_file_format: "文件格式错误",
  scenes_UserInvitationPage_invite_failed: "邀请失败",
  scenes_UserInvitationPage_invite_success: "邀请成功",
  scenes_UserInvitationPage_some_invite_failed: "部分邀请失败",
  scenes_UserInvitationPage_invite_result: "邀请结果",
  scenes_UserInvitationPage_delete_failed: "删除失败",
  scenes_UserInvitationPage_delete_success: "删除成功",
  scenes_UserInvitationPage_some_delete_failed: "部分删除失败",


  //endregion

  /*endregion scenes*/

  /*region components*/
  /*region HeaderLogo*/
  /*endregion HeaderLogo*/

  /*endregion components*/
  /**** handd CODE START ****/

  /**** region APP MARKET ****/

  //label
  appMarketAppNameLabel: "应用名称",
  appMarketEnterpriseNameLabel: "开发商",
  appMarketAppKeywordLabel: "关键字",
  //placeholder
  appMarketAppNamePlaceholder: "请输入应用名称",
  appMarketEnterpriseNamePlaceholder: "请输入开发商",
  appMarketAppKeywordPlaceholder: "请输入关键字",

  appMarketLoadingModalTitle: "正在加载...",
  /**** APP MARKET END ****/
  /**** endregion APP MARKET END ****/

  /**** USER SERVICE START ****/

  // EnterpriseInfo Start
  user_service_enterprise_logo_customization: "个性化定制",
  user_service_enterprise_verifying_status: "审核中",
  user_service_enterprise_verifying_status_instruction: "请耐心等待审核",
  user_service_enterprise_verified_status: "已审核",
  user_service_enterprise_verified_status_instruction: "已认证，请点击修改",
  user_service_enterprise_verify_fail_status: "审核失败",
  user_service_enterprise_verify_fail_status_instruction: "审核失败，请重新提交审核",
  user_service_enterprise_verify_not_status: "未认证",
  user_service_enterprise_verify_not_status_instruction: "未认证，点击进行认证",
  // EnterpriseInfo End

  // PersonInfo Start
  user_service_person_info_welcome: "您好",
  user_service_person_info_role_label: "角色",
  user_service_person_info_company_label: "所属企业",
  user_service_person_info_create_company_label: "创建新企业",
  user_service_person_info_verifying_status: "审核中",
  user_service_person_info_verifying_status_instruction: "请耐心等待审核",
  user_service_person_info_verified_status: "已审核",
  user_service_person_info_verified_status_instruction: "已认证，点击修改",
  user_service_person_info_verify_fail_status: "审核失败",
  user_service_person_info_verify_fail_status_instruction: "审核失败，请重新认证",
  user_service_person_info_verify_not_status: "未认证",
  user_service_person_info_verify_not_status_instruction: "点击进行认证",
  // PersonInfo End

  // MessageDetail Start
  user_service_message_msg_detail_panel_title: "查看消息内容",
  user_service_message_msg_detail_title: "消息标题",
  user_service_message_msg_detail_type_label: "类型",
  user_service_message_msg_detail_self_type_label: "类别",
  user_service_message_msg_detail_publisher_label: "发布人",
  user_service_message_msg_detail_created_at_label: "时间",
  user_service_message_msg_detail_receivers_label: "接收人",
  user_service_message_msg_detail_confirm_btn_label: "确认",
  user_service_message_msg_detail_back_btn_label: "返回",
  user_service_message_msg_detail_delete_btn_label: "删除",
  user_service_message_msg_detail_mark_as_read_success_notification: "标记已读成功",
  user_service_message_msg_detail_mark_as_read_fail_notification: "标记已读失败",
  user_service_message_msg_detail_delete_success_notification: "删除消息成功",
  user_service_message_msg_detail_delete_fail_notification: "删除消息失败",
  // MessageDetail End

  // MessageNew Start
  user_service_message_msg_new_modal_fail_retry_label: "重试",
  user_service_message_msg_new_modal_fail_back_label: "返回",
  user_service_message_msg_new_modal_fail_header_label: "发布失败",
  user_service_message_msg_new_modal_fail_content: "您的消息发布异常",
  user_service_message_msg_new_modal_success_drawback_label: "撤销",
  user_service_message_msg_new_modal_success_back_label: "返回",
  user_service_message_msg_new_modal_success_header_label: "发布成功",
  user_service_message_msg_new_modal_success_type_label: "类型",
  user_service_message_msg_new_modal_success_created_at_label: "发布时间",
  user_service_message_msg_new_modal_success_content_label: "发布内容",
  user_service_message_msg_new_modal_success_people_label: "相关人员",
  user_service_message_msg_new_modal_success_publisher_label: "发布人",
  user_service_message_msg_new_modal_success_receiver_label: "接收人",
  user_service_message_msg_new_search_placeholder_label: "搜索用户名",
  user_service_message_msg_new_receiver_label: "接收人",
  user_service_message_msg_new_type_label: "类型",
  user_service_message_msg_new_self_type_label: "类别",
  user_service_message_msg_new_title_label: "标题",
  user_service_message_msg_new_title_placeholder_label: "标题",
  user_service_message_msg_new_content_label: "内容",
  user_service_message_msg_new_content_placeholder_label: "正文",
  user_service_message_msg_new_publish_btn_label: "发布",
  user_service_message_msg_new_back_btn_label: "返回",
  user_service_message_msg_new_success_txt: "发布消息成功",
  user_service_message_msg_new_fail_txt: "发布消息失败",
  user_service_message_msg_new_drawback_success_txt: "撤回消息成功",
  user_service_message_msg_new_drawback_fail_txt: "撤回消息失败",
  // MessageNew End

  // MessageSent Start
  user_service_message_sent_title_label: "消息标题",
  user_service_message_sent_type_label: "类型",
  user_service_message_sent_self_type_label: "类别",
  user_service_message_sent_actor_label: "发布人",
  user_service_message_sent_notifiers_label: "接收人",
  user_service_message_sent_postOn_label: "时间",
  user_service_message_sent_new_self_type_placeholder: "输入类别名称",
  user_service_message_sent_panel_title: "管理消息列表",
  user_service_message_sent_publish_btn_label: "发布消息",
  user_service_message_sent_drawback_btn_label: "撤回消息",
  user_service_message_sent_define_type_btn_label: "自定义类别",
  user_service_message_sent_search_placeholder: "类别，类型",
  user_service_message_sent_search_btn_label: "查询",
  user_service_message_sent_drawback_success_txt: "撤回消息成功",
  user_service_message_sent_drawback_fail_txt: "撤回消息失败",
  user_service_message_sent_new_self_type_title: "添加新类别",
  user_service_message_sent_new_self_type_ok_btn: "确定",
  user_service_message_sent_new_self_type_cancel_btn: "取消",
  user_service_message_sent_new_self_type_success_txt: "自定义类别创建成功",
  user_service_message_sent_new_self_type_fail_txt: "自定义类别创建失败",
  // MessageSent End

  // MessageCenter Start
  user_service_message_msg_center_title: "标题",
  user_service_message_msg_center_publisher: "发布人",
  user_service_message_msg_center_createdOn: "时间",
  user_service_message_msg_center_type: "消息类型",
  user_service_message_msg_center_panel_title: "消息中心",
  user_service_message_msg_center_delete_btn: "删除",
  user_service_message_msg_center_mark_btn: "标记已读",
  user_service_message_msg_center_delete_success: "删除消息成功",
  user_service_message_msg_center_delete_fail: "删除消息失败",
  user_service_message_msg_center_read_success: "标记已读成功",
  user_service_message_msg_center_read_fail: "标记已读失败",
  // MessageCenter End

  // PasswordStrength Start
  user_service_password_strength_weakest_txt: "极弱",
  user_service_password_strength_weaker_txt: "较弱",
  user_service_password_strength_normal_txt: "中等",
  user_service_password_strength_stronger_txt: "较强",
  user_service_password_strength_strongest_txt: "极强",
  user_service_password_strength_indicator_txt: "强度",
  user_service_password_strength_requirement_one: "要求输入8-20个字符",
  user_service_password_strength_requirement_two: "只能包含字母、数字以及下划线“_”",
  user_service_password_strength_requirement_three: "字母、数字、下划线至少包含两种",
  user_service_password_strength_requirement_four: "不能与用户名相同",
  // PasswordStrength End

  // Register Start
  user_service_register_password_not_same: "两次输入密码不一致",
  user_service_register_username_not_unique: "该用户名已经注册，请选择其他用户名",
  user_service_register_email_not_unique: "该邮箱已经注册，邮箱必须唯一",
  user_service_register_phone_not_unique: "该手机已经注册，手机必须唯一",
  user_service_register_validation_code_fail: "请输入正确的验证码",
  user_service_register_get_validation_code: "获取验证码",
  user_service_register_validation_code_count_down: "秒后点击重新发送",
  user_service_register_title: "欢迎注册中科云翼互联智造服务云平台账号",
  user_service_register_submit_error: "注册信息有误，请检查后重新提交",
  user_service_register_username_check: "用户名必填，且必须唯一",
  user_service_register_username_placeholder: "用户名",
  user_service_register_email_check: "必须输入有效的email地址",
  user_service_register_email_check_two: "请输入你的email地址",
  user_service_register_email_placeholder: "邮箱",
  user_service_register_phone_check: "必须输入有效的手机号码",
  user_service_register_phone_check_two: "请输入你的手机号码",
  user_service_register_phone_placeholder: "手机号",
  user_service_register_code_check: "请输入验证码",
  user_service_register_code_placeholder: "验证码",
  user_service_register_password_check: "密码至少包含字母、数字以及“_”中的两种，并且在8位与20位之间",
  user_service_register_password_check_two: "请输入你的密码",
  user_service_register_password_placeholder: "密码",
  user_service_register_confirm_check: "请确认你的密码",
  user_service_register_confirm_placeholder: "确认密码",
  user_service_register_submit_btn: "注册",
  user_service_register_password_username_same:"密码不能与用户名相同",
  // Register End

  // RegisterSuccess Start
  user_service_register_success_header_one: "你的账户",
  user_service_register_success_header_two: "注册成功",
  // user_service_register_success_content: "激活邮件已经发送到你的邮箱中，邮件有效期为30分钟。请及时登录邮箱，点击邮件中的链接激活账户。在这30分钟内，您无法再次注册用户，如果30分钟后仍然未收到邮件，请重新注册。",
  user_service_register_success_content: "注册成功，请前往登录页面进行登录",
  user_service_register_success_view_email: "查看邮箱",
  user_service_register_success_back: "返回首页",
  user_service_register_success_login: "前往登录页面",
  // RegisterSuccess End

  // VerifyRegister Start
  user_service_register_verify_success_title: "激活成功，请到平台上登录",
  user_service_register_verify_success_btn: "前往登录页面",
  user_service_register_verify_fail_title: "激活超时，请重新注册",
  user_service_register_verify_fail_register_btn: "注册",
  user_service_register_verify_fail_back_btn: "返回平台主页",
  // VerifyRegister End

  // AssignUserRole Start
  user_service_assign_user_role_role_name: "角色名称",
  user_service_assign_user_role_role_description: "角色描述",
  user_service_assign_user_role_panel_title: "分配用户角色",
  user_service_assign_user_role_save_btn: "保存",
  user_service_assign_user_role_back_btn: "返回",
  user_service_assign_user_role_success_txt: "修改用户角色成功",
  user_service_assign_user_role_fail_txt: "修改用户角色失败",
  // AssignUserRole End

  // CompanyPrivilege Start
  user_service_company_privilege_name_col: "权限名称",
  user_service_company_privilege_description_col: "说明",
  user_service_company_privilege_status_col: "状态",
  user_service_company_privilege_panel: "管理企业权限",
  user_service_company_privilege_apply_btn: "申请权限",
  user_service_company_privilege_request_success_txt: "请求企业权限成功，请耐心等待审核",
  user_service_company_privilege_request_fail_txt: "请求企业权限失败，请稍后重试",
  // CompanyPrivilege End

  // PrivilegeRoleConfig Start
  user_service_privilege_role_config_privilege_name_col: "权限名称",
  user_service_privilege_role_config_privilege_description_col: "说明",
  user_service_privilege_role_config_panel_title: "管理角色权限",
  user_service_privilege_role_config_role_label: "角色名称",
  user_service_privilege_role_config_app_label: "应用列表",
  user_service_privilege_role_config_save_btn: "保存",
  user_service_privilege_role_config_back_btn: "返回",
  user_service_privilege_role_config_modify_success_txt: "修改角色权限成功",
  user_service_privilege_role_config_modify_fail_txt: "修改角色权限失败",
  // PrivilegeRoleConfig End

  // RoleList Start
  user_service_role_list_name_col: "角色名称",
  user_service_role_list_description_col: "角色描述",
  user_service_role_list_add_role_modal_name: "角色名称",
  user_service_role_list_add_role_modal_name_placeholder: "请输入角色名称",
  user_service_role_list_add_role_modal_description: "角色描述",
  user_service_role_list_add_role_modal_description_placeholder: "请输入角色描述",
  user_service_role_list_delete_role_modal_description: "确定删除角色",
  user_service_role_list_panel_title: "管理角色列表",
  user_service_role_list_modal_ok: "确定",
  user_service_role_list_modal_cancel: "取消",
  user_service_role_list_add_btn: "添加",
  user_service_role_list_modify_btn: "修改",
  user_service_role_list_delete_btn: "删除",
  user_service_role_list_config_user_btn: "配置用户",
  user_service_role_list_config_privilege_btn: "配置权限",
  user_service_role_list_add_role_modal_title: "新建角色",
  user_service_role_list_modify_role_modal_title: "修改角色",
  user_service_role_list_acquire_role_modal_fail_txt: "角色获取失败",
  user_service_role_list_delete_role_title: "删除角色",
  user_service_role_list_add_role_modal_success: "角色创建成功",
  user_service_role_list_add_role_modal_fail: "角色创建失败",
  user_service_role_list_delete_role_modal_success: "角色删除成功",
  user_service_role_list_delete_role_modal_fail: "角色删除失败",
  user_service_role_list_modify_role_modal_success: "角色修改成功",
  user_service_role_list_modify_role_modal_fail: "角色修改失败",
  user_service_role_list_unknown_modal: "未知的操作",
  // RoleList End

  // UserRoleAdd Start
  user_service_user_role_add_name_col: "用户名",
  user_service_user_role_add_phone_col: "电话",
  user_service_user_role_add_email_col: "邮箱",
  user_service_user_role_add_panel_title: "添加角色用户",
  user_service_user_role_add_save_btn: "保存",
  user_service_user_role_add_back_btn: "返回",
  user_service_user_role_add_save_success_txt: "将角色配置给用户成功",
  user_service_user_role_add_save_fail_txt: "将角色配置给用户失败",
  // UserRoleAdd End

  // UserRoleConfig Start
  user_service_user_role_config_name_col: "用户名",
  user_service_user_role_config_phone_col: "电话",
  user_service_user_role_config_email_col: "邮箱",
  user_service_user_role_config_delete_modal_title: "删除雇员",
  user_service_user_role_config_delete_modal_ok: "确定",
  user_service_user_role_config_delete_modal_cancel: "取消",
  user_service_user_role_config_delete_modal_content: "确认从该角色中删除雇员",
  user_service_user_role_config_panel_title: "管理角色用户",
  user_service_user_role_config_add_btn: "添加",
  user_service_user_role_config_delete_btn: "删除",
  user_service_user_role_config_back_btn: "返回",
  user_service_user_role_config_search_placeholder: "雇员姓名",
  user_service_user_role_config_search_btn: "查询",
  user_service_user_role_config_fetch_fail: "获取公司角色相应用户失败",
  user_service_user_role_config_config_success: "将雇员移出角色列表成功",
  user_service_user_role_config_config_fail: "将雇员移出角色列表失败",
  // UserRoleConfig End

  //User List Component(common)
  user_service_common_user_list_component_table_username: "姓名",
  user_service_common_user_list_component_table_email: "邮箱",
  user_service_common_user_list_component_table_registerTime: "注册时间",
  user_service_common_user_list_component_button_inviteEmployee: "邀请雇员",
  user_service_common_user_list_component_button_manageEmployee: "雇员管理",
  user_service_common_user_list_component_placeholder_username: "请输入用户名",
  user_service_common_user_list_component_button_search: "查询",
  user_service_common_user_list_component_bar_title: "各部门邀请人数",
  user_service_common_user_list_component_title: "企业用户列表",
  //User List Component(common) End

  //Modify User Password
  user_service_modify_user_password_warning_password_not_equal: "两次输入密码不一致",
  user_service_modify_user_password_warning_info: "旧密码错误或新密码设置不正确，请检查后重新提交",
  user_service_modify_user_password_warning_old_password: "请输入你的旧密码",
  user_service_modify_user_password_placeholder_old_password: "旧密码",
  user_service_modify_user_password_info_new_password: "密码至少包含字母、数字以及“_”中的两种，并且在8位与20位之间",
  user_service_modify_user_password_warning_new_password: "请输入你的密码",
  user_service_modify_user_password_placeholder_new_password: "新密码",
  user_service_modify_user_password_warning_check_password: "请确认你的密码",
  user_service_modify_user_password_placeholder_check_password: "确认密码",
  user_service_modify_user_password_button: "确认",
  user_service_modify_user_password_success: "修改成功",
  user_service_admin_reset_user_password_button: "重置",
  user_service_admin_reset_user_password_back: "返回",
  //Modify User Password End

  //Register With Invitation Code
  user_service_register_with_invitation_code_success: "注册成功",
  user_service_register_with_invitation_code_failure: "注册失败",
  user_service_register_with_invitation_code_username_not_unique: "该用户名已经注册，请选择其他用户名",
  user_service_register_with_invitation_code_department_check: "您还未选择部门，请选择",
  user_service_register_with_invitation_code_position_check: "您还未选择职位，请选择",
  user_service_register_with_invitation_code_phone_not_unique: "该手机已经注册，手机必须唯一",
  user_service_register_with_invitation_code_password_not_same: "两次输入密码不一致",
  user_service_register_with_invitation_code_validation_code_fail: "请输入正确的验证码",
  user_service_register_with_invitation_code_get_validation_code: "获取验证码",
  user_service_register_with_invitation_code_validation_code_count_down: "秒后点击重新发送",
  user_service_register_with_invitation_code_card_title: "雇员注册界面",
  user_service_register_with_invitation_code_submit_error: "注册信息有误，请检查后重新提交",
  user_service_register_with_invitation_code_username_check: "用户名必填，且必须唯一",
  user_service_register_with_invitation_code_username_placeholder: "用户名",
  user_service_register_with_invitation_code_email_placeholder: "邮箱",
  user_service_register_with_invitation_code_phone_check: "必须输入有效的手机号码",
  user_service_register_with_invitation_code_phone_check_two: "请输入你的手机号码",
  user_service_register_with_invitation_code_phone_placeholder: "手机号",
  user_service_register_with_invitation_code_code_check: "请输入验证码",
  user_service_register_with_invitation_code_code_placeholder: "验证码",
  user_service_register_with_invitation_code_invitation_code_placeholder: "邀请码",
  user_service_register_with_invitation_code_department_message: "请选择部门",
  user_service_register_with_invitation_code_department_placeholder: "选择部门",
  user_service_register_with_invitation_code_position_message: "请选择职位",
  user_service_register_with_invitation_code_position_placeholder: "选择职位",
  user_service_register_with_invitation_code_password_check: "密码至少包含字母、数字以及“_”两种，并且在8位与20位之间",
  user_service_register_with_invitation_code_password_check_two: "请输入你的密码",
  user_service_register_with_invitation_code_password_placeholder: "密码",
  user_service_register_with_invitation_code_confirm_check: "请确认你的密码",
  user_service_register_with_invitation_code_confirm_placeholder: "确认密码",
  user_service_register_with_invitation_code_submit_btn: "注册",
  //Register With Invitation Code End

  //User Details
  scenes_UserService_User_UserDetailsComponent_basicInfo: "基本信息",
  scenes_UserService_User_UserDetailsComponent_username: "用 户 名",
  scenes_UserService_User_UserDetailsComponent_avatar: "头像",
  scenes_UserService_User_UserDetailsComponent_email: "邮 箱",
  scenes_UserService_User_UserDetailsComponent_phone: "手 机",
  scenes_UserService_User_UserDetailsComponent_enterpriseAndRole: "所属企业及角色",
  scenes_UserService_User_UserDetailsComponent_enterprise: "所属企业",
  scenes_UserService_User_UserDetailsComponent_role: "角色",
  scenes_UserService_User_UserDetailsComponent_enterpriseStatus: "企业状态",
  scenes_UserService_User_UserDetailsComponent_metadata: "简介",
  scenes_UserService_User_UserDetailsComponent_edit: "编辑",
  scenes_UserService_User_UserDetailsComponent_back: "返回",
  scenes_UserService_User_UserDetailsComponent_verifying_status: "审核中",
  scenes_UserService_User_UserDetailsComponent_verifying_status_instruction: "请耐心等待审核",
  scenes_UserService_User_UserDetailsComponent_verified_status: "已审核",
  scenes_UserService_User_UserDetailsComponent_verified_status_instruction: "已认证，点击修改",
  scenes_UserService_User_UserDetailsComponent_verify_fail_status: "审核失败",
  scenes_UserService_User_UserDetailsComponent_verify_fail_status_instruction: "审核失败，请重新认证",
  scenes_UserService_User_UserDetailsComponent_verify_not_status: "未认证",
  scenes_UserService_User_UserDetailsComponent_verify_not_status_instruction: "点击进行认证",


  //Edit User Details
  scenes_UserService_User_EditUserDetailsComponent_basicInfo: "基本信息",
  scenes_UserService_User_EditUserDetailsComponent_username: "用户名",
  scenes_UserService_User_EditUserDetailsComponent_avatar: "头像",
  scenes_UserService_User_EditUserDetailsComponent_email: "邮箱",
  scenes_UserService_User_EditUserDetailsComponent_phone: "手机",
  scenes_UserService_User_EditUserDetailsComponent_metadata: "简介",
  scenes_UserService_User_EditUserDetailsComponent_save: "保存",
  scenes_UserService_User_EditUserDetailsComponent_back: "返回",
  scenes_UserService_User_EditUserDetailsComponent_confirmModal: "确认",
  scenes_UserService_User_EditUserDetailsComponent_confirm: "确认",
  scenes_UserService_User_EditUserDetailsComponent_cancel: "取消",
  scenes_UserService_User_EditUserDetailsComponent_confirmChange: "确认修改？",
  scenes_UserService_User_EditUserDetailsComponent_emailCheck: "必须输入有效的email地址!",
  scenes_UserService_User_EditUserDetailsComponent_emailRequiredMessage: "请输入你的email地址!",
  scenes_UserService_User_EditUserDetailsComponent_emailUnique: "该邮箱已经注册，邮箱必须唯一!",
  scenes_UserService_User_EditUserDetailsComponent_phoneCheck: "必须输入有效的手机号码!",
  scenes_UserService_User_EditUserDetailsComponent_phoneRequiredMessage: "请输入你的手机号码!",
  scenes_UserService_User_EditUserDetailsComponent_phoneUnique: "该手机已经注册，手机必须唯一!",

  scenes_UserService_User_AdminEditUserComponent_success: "用户编辑成功",

  //Edit User Certify
  scenes_UserService_User_EditUserCertifyComponent_basicInfo: "基本信息",
  scenes_UserService_User_EditUserCertifyComponent_realName: "姓名",
  scenes_UserService_User_EditUserCertifyComponent_licenseLocation: "证件归属地",
  scenes_UserService_User_EditUserCertifyComponent_licenseType: "证件类型",
  scenes_UserService_User_EditUserCertifyComponent_licenseNum: "证件号码",
  scenes_UserService_User_EditUserCertifyComponent_licenseValidTerm: "证件有效期",
  scenes_UserService_User_EditUserCertifyComponent_licenseFrontImage: "扫描证件正面(彩色)",
  scenes_UserService_User_EditUserCertifyComponent_licenseBackImage: "扫描证件背面(彩色)",
  scenes_UserService_User_EditUserCertifyComponent_bankInfo: "银行账户信息",
  scenes_UserService_User_EditUserCertifyComponent_bankAccountName: "姓名",
  scenes_UserService_User_EditUserCertifyComponent_bankName: "开户行",
  scenes_UserService_User_EditUserCertifyComponent_bankAccountNum: "账户",
  scenes_UserService_User_EditUserCertifyComponent_submit: "提交认证",
  scenes_UserService_User_EditUserCertifyComponent_back: "返回",
  scenes_UserService_User_EditUserCertifyComponent_warning: "警告",
  scenes_UserService_User_EditUserCertifyComponent_confirm: "确认",
  scenes_UserService_User_EditUserCertifyComponent_cancel: "取消",
  scenes_UserService_User_EditUserCertifyComponent_modalContent: "修改信息将导致您需要重新进行审核过程，请确定",

  //Create User Certify
  scenes_UserService_User_CreateUserCertifyComponent_basicInfo: "基本信息",
  scenes_UserService_User_CreateUserCertifyComponent_realName: "姓名",
  scenes_UserService_User_CreateUserCertifyComponent_licenseLocation: "证件归属地",
  scenes_UserService_User_CreateUserCertifyComponent_licenseType: "证件类型",
  scenes_UserService_User_CreateUserCertifyComponent_licenseNum: "证件号码",
  scenes_UserService_User_CreateUserCertifyComponent_licenseValidTerm: "证件有效期",
  scenes_UserService_User_CreateUserCertifyComponent_licenseFrontImage: "扫描证件正面(彩色)",
  scenes_UserService_User_CreateUserCertifyComponent_licenseBackImage: "扫描证件背面(彩色)",
  scenes_UserService_User_CreateUserCertifyComponent_bankInfo: "银行账户信息",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountName: "姓名",
  scenes_UserService_User_CreateUserCertifyComponent_bankName: "开户行",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNum: "账户",
  scenes_UserService_User_CreateUserCertifyComponent_submit: "提交认证",
  scenes_UserService_User_CreateUserCertifyComponent_back: "返回",
  scenes_UserService_User_CreateUserCertifyComponent_warning: "警告",
  scenes_UserService_User_CreateUserCertifyComponent_confirm: "确认",
  scenes_UserService_User_CreateUserCertifyComponent_cancel: "取消",
  scenes_UserService_User_CreateUserCertifyComponent_modalContent: "提交后将进入审核过程，请确定",
  scenes_UserService_User_CreateUserCertifyComponent_realNameRequired: "请输入姓名!",
  scenes_UserService_User_CreateUserCertifyComponent_realNamePlaceholder: "请输入姓名",
  scenes_UserService_User_CreateUserCertifyComponent_licenseLocationRequired: "请选择证件归属地!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseLocationPlaceholder: "请选择证件归属地",
  scenes_UserService_User_CreateUserCertifyComponent_licenseTypeRequired: "请选择证件类型!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseTypePlaceholder: "请选择证件类型",
  scenes_UserService_User_CreateUserCertifyComponent_licenseNumRequired: "请输入证件号码!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseNumPlaceholder: "请输入证件号码",
  scenes_UserService_User_CreateUserCertifyComponent_licenseValidTermRequired: "请选择证件有效期!",
  scenes_UserService_User_CreateUserCertifyComponent_licenseValidTermPlaceholder: "请选择证件有效期",
  scenes_UserService_User_CreateUserCertifyComponent_licenseFrontImageRequired: "请上传证件扫描正面",
  scenes_UserService_User_CreateUserCertifyComponent_licenseBackImageRequired: "请上传证件扫描背面",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNameRequired: "请输入姓名!",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNamePlaceholder: "请输入姓名",
  scenes_UserService_User_CreateUserCertifyComponent_bankNameRequired: "请输入开户行!",
  scenes_UserService_User_CreateUserCertifyComponent_bankNamePlaceholder: "请输入开户行",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNumRequired: "请输入账户!",
  scenes_UserService_User_CreateUserCertifyComponent_bankAccountNumPlaceholder: "请输入账户",

  //Add User
  scenes_UserService_User_AddPlatformUserModal_username: "用户名",
  scenes_UserService_User_AddPlatformUserModal_password: "密码",
  scenes_UserService_User_AddPlatformUserModal_check_password: "确认密码",
  scenes_UserService_User_AddPlatformUserModal_email: "邮件地址",
  scenes_UserService_User_AddPlatformUserModal_phone: "联系方式",
  scenes_UserService_User_AddPlatformUserModal_placeholder_username: "请输入用户名",
  scenes_UserService_User_AddPlatformUserModal_placeholder_password: "请输入密码",
  scenes_UserService_User_AddPlatformUserModal_placeholder_check_password: "请确认密码",
  scenes_UserService_User_AddPlatformUserModal_placeholder_email: "请输入邮件地址",
  scenes_UserService_User_AddPlatformUserModal_placeholder_phone: "请输入联系方式",
  scenes_UserService_User_AddPlatformUserModal_submit: "提交",
  scenes_UserService_User_AddPlatformUserModal_cancel: "取消",
  scenes_UserService_User_AddPlatformUserModal_success: "添加用户成功",
  scenes_UserService_User_AddPlatformUserModal_success_commit: "确认",
  scenes_UserService_User_AddPlatformUserModal_usernameUnique: "用户名已存在",

  //Admin Reset User Password
  scenes_UserService_User_AdminResetUserPassword_username: "用户名",
  scenes_UserService_User_AdminResetUserPassword_password: "新密码",
  scenes_UserService_User_AdminResetUserPassword_check_password: "确认密码",
  scenes_UserService_User_AdminResetUserPassword_placeholder_password: "请输入新密码",
  scenes_UserService_User_AdminResetUserPassword_placeholder_check_password: "请确认密码",
  scenes_UserService_User_AdminResetUserPassword_submit: "提交",
  scenes_UserService_User_AdminResetUserPassword_cancel: "取消",
  scenes_UserService_User_AdminResetUserPassword_success: "重置密码成功",
  scenes_UserService_User_AdminResetUserPassword_success_commit: "确认",

  //Create Enterprise Details
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_basicInfo: "基本信息",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_name: "企业名称",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_alias: "英文名称",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_logo: "企业图标",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_region: "企业地区",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_address: "企业地址",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_property: "企业类型",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_profession: "企业所属行业",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_scale: "企业规模",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_metadata: "企业简介",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_unifiedCreditId: "统一社会信用代码",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_businessExpiryDate: "营业期限",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_licenseImage: "企业营业执照(彩色)",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankInfo: "银行账户信息",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountName: "企业账户名称",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_taxpayerNum: "纳税人识别号",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankName: "开户行",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNum: "账户",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreInfo: "法定代表人信息",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseLocation: "法人证件归属地",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreName: "法人姓名",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseType: "法人证件类型",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseNum: "法人证件号码",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseExpiryDate: "法人证件有效期",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseFrontImage: "法人证件扫描正面(彩色)",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseBackImage: "法人证件扫描背面(彩色)",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_submit: "提交认证",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_back: "返回",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_warning: "警告",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_cancel: "取消",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_confirm: "确认",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_modalContent: "提交后将进入审核过程，请确定",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_nameTip: "请填写工商局注册的全称。",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_nameRequired: "请输入企业名称!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_namePlaceholder: "请输入企业名称",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_nameCheck: "该企业名称已经注册，请选择其他企业名称",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_aliasRequired: "请输入企业英文名称!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_aliasPlaceholder: "请输入企业英文名称",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_logoRequired: "请上传企业图标!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_regionRequired: "请选择企业地区!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_regionPlaceholder: "请选择企业地区",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_provinceRequired: "请选择企业省份!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_provincePlaceholder: "请选择企业省份",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_cityRequired: "请选择企业城市!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_cityPlaceholder: "请选择企业城市",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_districtRequired: "请选择企业区县!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_districtPlaceholder: "请选择企业区县",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_addressRequired: "请输入企业地址!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_addressPlaceholder: "请输入企业地址",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_propertyRequired: "请选择企业类型!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_propertyPlaceholder: "请选择企业类型",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_professionRequired: "请选择企业所属行业!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_professionPlaceholder: "请选择企业所属行业",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_scaleRequired: "请选择企业规模!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_scalePlaceholder: "请选择企业规模",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_metadataRequired: "请输入企业简介!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_metadataPlaceholder: "请输入企业简介",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_unifiedCreditIdRequired: "请输入企业统一社会信用代码!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_unifiedCreditIdPlaceholder: "请输入企业统一社会信用代码",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_businessExpiryDateRequired: "请选择企业营业期限!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_businessExpiryDatePlaceholder: "请选择企业营业期限",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_licenseImageRequired: "请上传企业营业执照!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNameRequired: "请输入企业账户名称!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNamePlaceholder: "请输入企业账户名称",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_taxpayerNumRequired: "请输入企业纳税人识别号!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_taxpayerNumPlaceholder: "请输入企业纳税人识别号",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_taxpayerNumCheck: "纳税人识别号格式不正确",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankNameRequired: "请输入企业账户开户行!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankNamePlaceholder: "请输入企业账户开户行",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNumRequired: "请输入企业账户!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNumPlaceholder: "请输入企业账户",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_bankAccountNumCheck: "银行账号格式不正确",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseLocationRequired: "请选择法人证件归属地!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseLocationPlaceholder: "请选择法人证件归属地",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreNameRequired: "请输入法人姓名!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreNamePlaceholder: "请输入法人姓名",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseTypeRequired: "请选择法人证件类型!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseTypePlaceholder: "请选择法人证件类型",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseNumRequired: "请输入法人证件号码!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseNumPlaceholder: "请输入法人证件号码",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseNumCheck: "证件格式不正确",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseExpiryDateRequired: "请选择法人证件有效期!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseExpiryDatePlaceholder: "请选择法人证件有效期",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseFrontImageRequired: "请上传证件扫描正面!",
  scenes_UserService_Enterprise_CreateEnterpriseDetailsComponent_repreLicenseBackImageRequired: "请上传证件扫描背面!",

  //Edit Enterprise Details
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_basicInfo: "基本信息",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_name: "企业名称",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_alias: "英文名称",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_logo: "企业图标",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_region: "企业地区",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_address: "企业地址",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_property: "企业类型",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_profession: "企业所属行业",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_scale: "企业规模",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_metadata: "企业简介",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_unifiedCreditId: "统一社会信用代码",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_businessExpiryDate: "营业期限",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_licenseImage: "企业营业执照(彩色)",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_bankInfo: "银行账户信息",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_bankAccountName: "企业账户名称",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_taxpayerNum: "纳税人识别号",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_bankName: "开户行",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_bankAccountNum: "账户",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreInfo: "法定代表人信息",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseLocation: "法人证件归属地",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreName: "法人姓名",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseType: "法人证件类型",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseNum: "法人证件号码",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseExpiryDate: "法人证件有效期",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseFrontImage: "法人证件扫描正面(彩色)",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_repreLicenseBackImage: "法人证件扫描背面(彩色)",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_submit: "提交认证",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_back: "返回",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_warning: "警告",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_cancel: "取消",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_confirm: "确认",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_modalContent: "修改信息将导致您需要重新进行审核过程，请确定",
  scenes_UserService_Enterprise_EditEnterpriseDetailsComponent_nameTip: "请填写工商局注册的全称。",

  //Initialize Tenant Space
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_title: "初始化租户空间",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainName: "域名",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_platform: "平台",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_month: "租用时长",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_quotaPlan: "资源计划",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_memSize: "内存",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_price: "内存资费",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_description: "套餐说明",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_amount: "合计金额",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_confirm: "确定",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_modalSuccess: "初始化空间成功!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_modalFail: "初始化空间失败!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainNameRequired: "请输入租户空间名!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainNameCheck: "该域名已经注册，域名必须唯一!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainNameCheck2: "空间名只能包含小写字母及数字",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_domainNamePlaceholder: "请输入企业英文名称",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_passwordCheck: "密码只能包含字母及数字",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_passwordRequired: "请输入密码!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_monthRequired: "请输入租用时长!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_monthPlaceholder: "请输入租用时长",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_monthCheck: "月份必须是正整数!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_monthAddon: "个月",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_quotaPlanRequired: "请选择资源计划!",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_quotaPlanPlaceholder: "请选择资源计划",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_memSizePlaceholder: "这里将根据您的选择显示内存信息",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_pricePlaceholder: "这里将根据内存选择显示价格信息",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_priceValueBefore: "您当前选择的内存资费为",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_priceValueAfter: "元/月",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_descriptionPlaceholder: "这里将根据您的选择显示套餐说明",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_amountPlaceholder: "这里将根据您的选择显示金额",
  scenes_Space_InitializeTenantSpace_InitializeTenantSpaceComponent_amountValueAfter: "元",

  //Increase Quota
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_title: "申请租户资源",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_months: "租用时长",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_quotaPlan: "资源计划",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_memSize: "内存",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_price: "资费",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_description: "套餐说明",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_amount: "合计金额",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_upgrade: "立即升级",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_autopay: "自动续费",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_monthRequired: "请输入租用时长!",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_monthPlaceholder: "请输入租用时长",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_monthCheck: "月份必须是正整数!",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_monthAddon: "个月",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_quotaPlanRequired: "请选择资源计划!",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_quotaPlanPlaceholder: "请选择资源计划",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_memSizePlaceholder: "这里将根据您的选择显示内存信息",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_pricePlaceholder: "这里将根据内存选择显示价格信息",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_priceValueBefore: "您当前选择的内存资费为",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_priceValueAfter: "元/月",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_descriptionPlaceholder: "这里将根据您的选择显示套餐说明",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_amountPlaceholder: "这里将根据您的选择显示金额",
  scenes_Space_IncreaseQuota_IncreaseQuotaComponent_amountValueAfter: "元",

  /**** USER SREVICE END ****/

  /**** APPLICATION SERVICE START ****/

  /**** APP MARKET PORTAL ****/
  //label
  scenes_Application_AppMarketPortal_search_label: "搜索应用",
  scenes_Application_AppMarketPortal_recommendApp_label: "推荐应用",
  scenes_Application_AppMarketPortal_appCost_label: "元/月",
  scenes_Application_AppMarketPortal_appFree_label: "免费",
  scenes_Application_AppMarketPortal_algorithmLibrary_label: "算法库",
  scenes_Application_AppMarketPortal_algorithmLibraryMore_label: "更多",
  scenes_Application_AppMarketPortal_appMore_label: "更多",

  //placeholder
  scenes_Application_AppMarketPortal_search_placeholder: "输入你需要的应用名称",
  /**** APP MARKET PORTAL END ****/

  /**** APP MARKET LIST ****/
  //label
  scenes_Application_AppMarketList_search_label: "搜索应用",
  scenes_Application_AppMarketList_searchPrice_confirm_label: "确定",
  scenes_Application_AppMarketList_cost_label: "元起",
  scenes_Application_AppMarketList_costFree_label: "免费",
  scenes_Application_AppMarketList_publishTime_label: "发布时间",
  scenes_Application_AppMarketList_serviceEnterprise_label: "服务商",
  scenes_Application_AppMarketList_buyTimes_label: "购买次数",
  scenes_Application_AppMarketList_boughtTimes_label: "次",
  scenes_Application_AppMarketList_buyNow_label: "立即购买",
  scenes_Application_AppMarketList_categoryTag_category_label: "类别分类",
  scenes_Application_AppMarketList_categoryTag_developSource_label: "开发来源",
  scenes_Application_AppMarketList_categoryTag_enterprise_title: "企业",
  scenes_Application_AppMarketList_categoryTag_developer_title: "个人",
  scenes_Application_AppMarketList_categoryTag_price_label: "产品价格",
  scenes_Application_AppMarketList_categoryTag_priceFree_title: "免费",
  scenes_Application_AppMarketList_categoryTag_all_title: "全部",

  //placeholder
  scenes_Application_AppMarketList_search_placeholder: "输入你需要的应用名称",
  /**** APP MARKET LIST END ****/

  /**** APP MARKET VIEW ****/
  //label
  scenes_Application_AppMarketView_returnToAppMarket_label: "应用市场",
  scenes_Application_AppMarketView_publishTime_label: "发布时间",
  scenes_Application_AppMarketView_serviceEnterprise_label: "服务商",
  scenes_Application_AppMarketView_description_label: "版本简介",
  scenes_Application_AppMarketView_applicationPreview_label: "应用预览",
  scenes_Application_AppMarketView_relatedDocuments_label: "相关文档",
  scenes_Application_AppMarketView_productDetails_label: "产品详情",
  scenes_Application_AppMarketView_mainAppInformation_label: "所属应用",
  scenes_Application_AppMarketView_moduleInformation_label: "应用模块",
  scenes_Application_AppMarketView_price_label: "产品价格",
  scenes_Application_AppMarketView_priceList_spec_label: "规格",
  scenes_Application_AppMarketView_priceList_cycle_label: "周期",
  scenes_Application_AppMarketView_priceList_price_label: "价格",
  scenes_Application_AppMarketView_priceList_cost_label: "元",
  scenes_Application_AppMarketView_priceList_buyNow_label: "立即购买",
  scenes_Application_AppMarketView_priceList_notCompatible_label: "版本不兼容",
  scenes_Application_AppMarketView_recommend_label: "相关推荐",
  /**** APP MARKET VIEW END ****/

  /**** DEPLOY MARKET APP ****/
  //label
  deployMarketAppNameLabel: "应用名称",
  deployMarketAppVersionLabel: "应用版本",
  deployMarketAppAppTypeLabel: "应用类型",
  deployMarketAppSpaceLabel: "租户空间",
  deployMarketAppTitleLabel: "部署标题",
  deployMarketAppVisitLinkLabel: "访问路径",
  deployMarketAppDomainLabel: "域名",
  deployMarketAppSubmitLabel: "部署",
  deployMarketAppConfirmBuyLabel: "确认购买",
  deployMarketAppCancelLabel: "返回",
  deployMarketAppRandomVisitLink: "随机访问路径",

  //placeholder
  deployMarketAppAppTitlePlaceholder: "请输入部署标题",
  deployMarketAppAppTypePlaceholder: "请选择应用类型",
  deployMarketAppSpacePlaceholder: "请选择租户空间",
  deployMarketAppVisitLinkPlaceholder: "请输入访问路径",
  deployMarketAppDomainPlaceholder: "请选择域名",

  // loading modal
  deployMarketAppLoadingModalTitle: "正在加载...",

  // null modal
  deployMarketAppNullModalTitle: "错误",
  deployMarketAppNullModalContentSpace: "租户空间不能为空!",
  deployMarketAppNullModalContentVisitLink: "访问路径不能为空!",
  deployMarketAppNullModalContentDomain: "访问域名不能为空!",
  deployMarketAppNullModalConfirmLabel: "知道了",
  // deployMarketAppNullModalCancelLabel: "返回",

  // success modal
  deployMarketAppSuccessModalTitle: "操作成功",
  deployMarketAppSuccessModalContent: "应用部署成功!",
  deployMarketAppSuccessModalConfirmLabel: "确定",
  deployMarketAppSuccessModalCancelLabel: "返回",

  // fail modal
  deployMarketAppFailModalTitle: "操作失败",
  deployMarketAppFailModalContent: "应用部署失败!",
  deployMarketAppFailModalConfirmLabel: "确定",
  deployMarketAppFailModalCancelLabel: "返回",
  /**** DEPLOY MARKET APP END ****/

  /**** PROJECT DETAIL ****/
  // //label
  // projectDetailOrderNameLabel: "订单名称",
  // projectDetailCodeLabel: "项目编码",
  // projectDetailProjectStatusLabel: "项目状态",
  // projectDetailNameLabel: "项目名称",
  // projectDetailContentLabel: "项目内容",
  // projectDetailValidationDateLabel: "验收日期",
  // projectDetailProjectPriorityLabel: "设置优先级",
  // projectDetailTenderInvitationsLabel: "招标项目",
  // projectDetailTenderSubmissionsLabel: "投标项目",
  // projectDetailSourceTypeLabel: "源代码库类型",
  // projectDetailSourceUriLabel: "源代码库地址",
  // projectDetailProjectDocLabel: "项目文档",
  // projectDetailUploadLabel: "上传",
  // projectDetailModifyLabel: "修改",
  // projectDetailSubmitLabel: "提交",
  // projectDetailCancelLabel: "取消",
  // projectDetailDeleteLabel: "删除",
  //
  // //项目列表
  // projectDetailProjectDocListLabel: "项目文档列表",
  // projectDocTitle: "项目文档名称",
  // projectDocCreateDate: "上传时间",
  // projectDocDeveloperId: "上传人",
  // projectDocSyncToOrder: "同步到订单",
  //
  // //应用列表
  // projectDetailProjectAppListLabel: "应用列表",
  // projectAppButton: "新建应用",
  // projectAppName: "应用名称",
  // projectAppAppStatus: "应用状态",
  // projectAppDescription: "应用概述",
  //
  // //placeholder
  // projectDetailNamePlaceholder: "请输入项目名称",
  // projectDetailContentPlaceholder: "请输入项目内容",
  // projectDetailValidationDatePlaceholder: "请选择验收日期",
  // projectDetailProjectPriorityPlaceholder: "请选择优先级",
  // projectDetailSourceTypePlaceholder: "请选择源代码库类型",
  // projectDetailSourceUriPlaceholder: "请选择源代码库地址",
  //
  // // loading modal
  // projectDetailLoadingModalTitle: "正在加载...",
  //
  // // data error modal
  // projectDetailDataErrorModalTitle: "错误",
  // projectDetailDataErrorModalContent: "该项目的数据已丢失，请返回!",
  // projectDetailDataErrorModalConfirmLabel: "确定",
  // projectDetailDataErrorModalCancelLabel: "返回",
  //
  // // null modal
  // projectDetailNullModalTitle: "错误",
  // projectDetailNullFileModalContent_projectDoc: "未发现项目文档!",
  // projectDetailNullFileModalContent_name: "项目名称不能为空!",
  // projectDetailNullFileModalContent_samename: "项目名称已存在，请重新输入!",
  // projectDetailNullModalConfirmLabel: "知道了",
  // // projectDetailNullModalCancelLabel: "返回",
  //
  // // delete modal
  // projectDetailDeleteModalTitle: "确认",
  // projectDetailDeleteModalContent: "确定删除该项目？",
  // projectDetailDeleteModalConfirmLabel: "删除",
  // projectDetailDeleteModalCancelLabel: "取消",
  //
  // // content
  // projectDetailModalContentCreateProject: "创建项目",
  // projectDetailModalContentUpdateProject: "修改项目",
  // projectDetailModalContentDeleteProject: "删除项目",
  // projectDetailModalContentUploadFile: "上传文件",
  //
  // // success modal
  // projectDetailSuccessModalTitle: "操作成功",
  // projectDetailSuccessModalContent: "成功!",
  // projectDetailSuccessModalConfirmLabel: "确定",
  // projectDetailSuccessModalReturnLabel: "返回",
  //
  // // fail modal
  // projectDetailFailModalTitle: "操作失败",
  // projectDetailFailModalContent: "失败!",
  // projectDetailFailModalConfirmLabel: "确定",
  // projectDetailFailModalReturnLabel: "返回",
  /**** PROJECT DETAIL END ****/

  /**** PUBLISH APPLICATION ****/
  //table
  scenes_Application_PublishApplication_privilegeCode_title: "权限编码",
  scenes_Application_PublishApplication_privilegeName_title: "权限名称",
  scenes_Application_PublishApplication_privilegeDescription_title: "权限说明",
  scenes_Application_PublishApplication_periodMinMonths_title: "最小月数",
  scenes_Application_PublishApplication_periodMaxMonths_title: "最大月数",
  scenes_Application_PublishApplication_periodDiscount_title: "折扣",
  scenes_Application_PublishApplication_periodDescription_title: "说明",
  scenes_Application_PublishApplication_userMinUsers_title: "最小用户数",
  scenes_Application_PublishApplication_userMaxUsers_title: "最大用户数",
  scenes_Application_PublishApplication_userDiscount_title: "折扣",
  scenes_Application_PublishApplication_userDescription_title: "说明",
  scenes_Application_PublishApplication_operation_title: "操作",

  //popconfirm
  scenes_Application_PublishApplication_popconfirm_title: "确认删除吗？",
  scenes_Application_PublishApplication_popconfirmOK_title: "确认",
  scenes_Application_PublishApplication_popconfirmCancel_title: "取消",

  //label
  // scenes_Application_PublishApplication_order_label: "绑定订单",
  scenes_Application_PublishApplication_applicationInfo_label: "应用信息",
  scenes_Application_PublishApplication_applicationName_label: "应用名称",
  scenes_Application_PublishApplication_applicationCode_label: "应用编码",
  scenes_Application_PublishApplication_autoGenerate_label: "自动生成",
  scenes_Application_PublishApplication_version_label: "初始版本",
  scenes_Application_PublishApplication_applicationLogo_label: "应用图标",
  scenes_Application_PublishApplication_terminalType_label: "终端类型",
  scenes_Application_PublishApplication_uploadLogo_label: "上传图标",
  scenes_Application_PublishApplication_applicationCategory_label: "应用类别",
  scenes_Application_PublishApplication_applicationDescription_label: "应用简介",
  scenes_Application_PublishApplication_privilegeAllocation_label: "权限配置",
  scenes_Application_PublishApplication_helpFile_label: "帮助文档",
  scenes_Application_PublishApplication_apiFile_label: "API文档",
  scenes_Application_PublishApplication_testReportFile_label: "测试报告",
  scenes_Application_PublishApplication_applicationType_label: "应用类型",
  scenes_Application_PublishApplication_sourceType_label: "程序语言格式",
  scenes_Application_PublishApplication_versionDescription_label: "版本详情",
  scenes_Application_PublishApplication_screenHeight_label: "屏显高度",
  scenes_Application_PublishApplication_uploadScreenshot_label: "上传截图",
  scenes_Application_PublishApplication_applicationFile_label: "应用程序",
  scenes_Application_PublishApplication_selectFile_label: "选择文件",
  scenes_Application_PublishApplication_applicationPlan_label: "应用计划",
  scenes_Application_PublishApplication_applicationPlanName_label: "资源名称",
  scenes_Application_PublishApplication_applicationPlanCost_label: "资源价格",
  scenes_Application_PublishApplication_applicationUnitRMB_label: "元",
  scenes_Application_PublishApplication_applicationUnitMonths_label: "元/月",
  scenes_Application_PublishApplication_memorySize_label: "GB",
  scenes_Application_PublishApplication_memorySizeUnit_label: "限制使用内存大小(GB)",
  scenes_Application_PublishApplication_diskQuota_label: "限制使用储存空间(MB)",
  scenes_Application_PublishApplication_diskQuotaUnit_label: "MB",
  scenes_Application_PublishApplication_planDescription_label: "计划说明",
  scenes_Application_PublishApplication_chargeDeploymentTime_label: "按部署时长收费",
  scenes_Application_PublishApplication_deploymentTimeDiscounts_label: "部署时长折扣",
  scenes_Application_PublishApplication_chargeUserNum_label: "按并发用户数收费",
  scenes_Application_PublishApplication_userNumCost_label: "并发用户数价格",
  scenes_Application_PublishApplication_applicationPeriod_label: "周期时长折扣",
  scenes_Application_PublishApplication_applicationUserConcurrent_label: "并发用户数折扣",
  scenes_Application_PublishApplication_chargeMode_label: "收费方式",
  scenes_Application_PublishApplication_charge_label: "收费",
  scenes_Application_PublishApplication_byResource_label: "按资源",
  scenes_Application_PublishApplication_deploymentTime_label: "部署时长",
  scenes_Application_PublishApplication_userNum_label: "并发用户数",
  scenes_Application_PublishApplication_submitPublish_label: "发布提交",
  scenes_Application_PublishApplication_submit_label: "发布",
  scenes_Application_PublishApplication_return_label: "返回",
  scenes_Application_PublishApplication_previous_label: "上一步",
  scenes_Application_PublishApplication_next_label: "下一步",

  //helpTip
  scenes_Application_PublishApplication_applicationInfo_helpTip: "应用信息",
  scenes_Application_PublishApplication_applicationName_helpTip: "填写的应用名称必须的是唯一的",
  scenes_Application_PublishApplication_applicationCode_helpTip: "填写的应用编码必须是唯一的",
  scenes_Application_PublishApplication_autoGenerate_helpTip: "自动生成",
  scenes_Application_PublishApplication_version_helpTip: "选择初始的版本号",
  scenes_Application_PublishApplication_applicationLogo_helpTip: "选择应用的图标，大小不超过100M",
  scenes_Application_PublishApplication_terminalType_helpTip: "终端的类型请选择手机端或者web端",
  scenes_Application_PublishApplication_uploadLogo_helpTip: "上传图标",
  scenes_Application_PublishApplication_applicationType_helpTip: "市场应用是发布到应用市场的公共应用，专属应用是私有应用",
  scenes_Application_PublishApplication_applicationCategory_helpTip: "选择唯一的应用类别",
  scenes_Application_PublishApplication_applicationDescription_helpTip: "输入应用详情",
  scenes_Application_PublishApplication_sourceType_helpTip: "程序语言格式为代码来源或文件类型等",
  scenes_Application_PublishApplication_versionDescription_helpTip: "对当前版本的介绍",
  scenes_Application_PublishApplication_screenHeight_helpTip: "屏显高度，默认为320",
  scenes_Application_PublishApplication_uploadScreenshot_helpTip: "上传截图",
  scenes_Application_PublishApplication_applicationFile_helpTip: "选择应用程序文件",
  scenes_Application_PublishApplication_selectFile_helpTip: "选择文件",
  scenes_Application_PublishApplication_applicationPlanName_helpTip: "资源名称是应用计划使用资源的唯一名称",
  scenes_Application_PublishApplication_applicationPlanCost_helpTip: "资源价格是可按月或单价收费",
  scenes_Application_PublishApplication_memoryQuota_helpTip: "若勾选此项",
  scenes_Application_PublishApplication_diskQuota_helpTip: "资源价格是可按月或单价收费",
  scenes_Application_PublishApplication_planDescription_helpTip: "对应用的计划进行总体描述",

  //placeholder
  scenes_Application_PublishApplication_applicationName_placeholder: "请输入应用名称",
  scenes_Application_PublishApplication_applicationCode_placeholder: "请输入应用编码",
  scenes_Application_PublishApplication_applicationVersion_placeholder: "请输入初始版本",
  scenes_Application_PublishApplication_applicationCategory_placeholder: "请选择应用类别",
  scenes_Application_PublishApplication_applicationDescription_placeholder: "请输入应用详情",
  scenes_Application_PublishApplication_screenHeight_placeholder: "请输入屏显高度",
  scenes_Application_PublishApplication_applicationType_placeholder: "请选择应用类型",
  scenes_Application_PublishApplication_sourceType_placeholder: "请选择程序语言格式",
  scenes_Application_PublishApplication_versionDescription_placeholder: "请输入版本简介",
  scenes_Application_PublishApplication_planName_placeholder: "请输入资源名称",
  scenes_Application_PublishApplication_planCost_placeholder: "请输入资源价格",
  scenes_Application_PublishApplication_memorySize_placeholder: "请输入内存大小",
  scenes_Application_PublishApplication_diskQuota_placeholder: "请输入储存空间",
  scenes_Application_PublishApplication_planDescription_placeholder: "请输入计划说明",
  scenes_Application_PublishApplication_userNumCost_placeholder: "请输入并发用户数价格",

  //message
  scenes_Application_PublishApplication_required_message: "必填",
  scenes_Application_PublishApplication_incompletely_message: "未填!",
  scenes_Application_PublishApplication_notUpload_message: "未上传!",
  scenes_Application_PublishApplication_uploadLogo_message: "请上传图标",
  scenes_Application_PublishApplication_uploadAppFile_message: "请上传文件",
  scenes_Application_PublishApplication_promptName_message: "请输入应用名称，且必须唯一",
  scenes_Application_PublishApplication_promptCode_message: "请输入应用编码，且必须唯一",
  scenes_Application_PublishApplication_promptVersion_message: "请输入初始版本",
  scenes_Application_PublishApplication_promptCategory_message: "请选择应用类别",
  scenes_Application_PublishApplication_promptDescription_message: "请输入应用简介",
  scenes_Application_PublishApplication_promptType_message: "请选择应用类型",
  scenes_Application_PublishApplication_promptSourceType_message: "请选择程序语言格式",
  scenes_Application_PublishApplication_promptVersionDescription_message: "请输入版本详情",
  scenes_Application_PublishApplication_promptScreenHeight_message: "请输入屏显高度",
  scenes_Application_PublishApplication_promptTerminalType_message: "请选择终端类型",
  scenes_Application_PublishApplication_lessThan100MB_message: "不可大于100MB",
  scenes_Application_PublishApplication_promptPlanName_message: "请输入资源名称",
  scenes_Application_PublishApplication_promptPlanCost_message: "请输入资源价格",
  scenes_Application_PublishApplication_promptMemorySize_message: "请输入内存大小",
  scenes_Application_PublishApplication_promptDiskQuota_message: "请输入储存空间",
  scenes_Application_PublishApplication_promptPlanDescription_message: "请输入计划说明",
  scenes_Application_PublishApplication_userNumCost_message: "请输入并发用户数价格",
  scenes_Application_PublishApplication_promptNotLimit_message: "不限制",
  scenes_Application_PublishApplication_promptRedWord_message: "红色标记是必填项！",

  //modal
  scenes_Application_PublishApplication_modal_submit_content: "确认发布并提交审核吗？",
  scenes_Application_PublishApplication_modal_save_label: "暂时保存",
  scenes_Application_PublishApplication_modal_submit_label: "发布提交",
  scenes_Application_PublishApplication_modal_success_title: "成功",
  scenes_Application_PublishApplication_modal_fail_title: "失败",
  scenes_Application_PublishApplication_modal_submitSuccess_content: "应用发布成功!",
  scenes_Application_PublishApplication_modal_submitFail_content: "应用发布失败!",
  scenes_Application_PublishApplication_modal_uploadFileSuccess_content: "应用程序上传成功",
  scenes_Application_PublishApplication_modal_uploadFileFail_content: "应用发布成功，但应用程序上传失败！",
  scenes_Application_PublishApplication_modal_OK_label: "确定",
  scenes_Application_PublishApplication_modal_cancel_label: "返回",
  scenes_Application_PublishApplication_modal_yes_label: "是",
  scenes_Application_PublishApplication_modal_no_label: "否",
  scenes_Application_PublishApplication_modal_sameName_content: "应用名称已存在，请重新输入!",
  scenes_Application_PublishApplication_modal_sameCode_content: "应用编码已存在，请重新输入!",
  scenes_Application_PublishApplication_modal_return_content: "有新增内容，是否返回？",
  /**** PUBLISH APPLICATION END ****/

  /**** APPLICATION LIST ****/
  //label
  scenes_Application_ApplicationList_name_label: "应用名称",
  scenes_Application_ApplicationList_code_label: "应用编码",
  scenes_Application_ApplicationList_createDate_label: "创建时间",
  scenes_Application_ApplicationList_status_label: "应用状态",
  scenes_Application_ApplicationList_version_label: "应用版本",
  scenes_Application_ApplicationList_versionStatus_label: "版本状态",
  scenes_Application_ApplicationList_action_label: "操作",
  scenes_Application_ApplicationList_create_label: "创建新应用",
  scenes_Application_ApplicationList_publish_label: "发布新版本",
  scenes_Application_ApplicationList_modify_label: "修改",
  scenes_Application_ApplicationList_view_label: "查看",
  scenes_Application_ApplicationList_audit_label: "提交审核",
  scenes_Application_ApplicationList_detail_label: "明细",
  scenes_Application_ApplicationList_online_label: "上线",
  scenes_Application_ApplicationList_offline_label: "下线",
  scenes_Application_ApplicationList_disabled_label: "封存",
  scenes_Application_ApplicationList_more_label: "更多",

  //placeholder
  scenes_Application_ApplicationList_name_placeholder: "过滤应用名称...",

  // popconfirm
  scenes_Application_ApplicationList_popConfirm_audit_title: "确认审核吗？",
  scenes_Application_ApplicationList_popConfirm_online_title: "确认上线吗？",
  scenes_Application_ApplicationList_popConfirm_offline_title: "确认下线吗？",
  scenes_Application_ApplicationList_popConfirm_disabled_title: "确认封存吗？",
  scenes_Application_ApplicationList_popConfirm_confirm_label: "确认",
  scenes_Application_ApplicationList_popConfirm_cancel_label: "取消",

  // modal
  scenes_Application_ApplicationList_modal_success_title: "成功",
  scenes_Application_ApplicationList_modal_fail_title: "失败",
  scenes_Application_ApplicationList_modal_statusSuccess_content: "更新状态成功！",
  scenes_Application_ApplicationList_modal_statusFail_content: "更新状态失败！",
  scenes_Application_ApplicationList_modal_auditSuccess_content: "提交审核成功！",
  scenes_Application_ApplicationList_modal_auditFail_content: "提交审核失败！",
  scenes_Application_ApplicationList_modal_onlineSuccess_content: "上线成功！",
  scenes_Application_ApplicationList_modal_onlineFail_content: "上线失败！",
  scenes_Application_ApplicationList_modal_offlineSuccess_content: "下线成功！",
  scenes_Application_ApplicationList_modal_offlineFail_content: "下线失败！",
  scenes_Application_ApplicationList_modal_disabledSuccess_content: "封存成功！",
  scenes_Application_ApplicationList_modal_disabledFail_content: "封存失败！",
  scenes_Application_ApplicationList_modal_OK_label: "确定",
  scenes_Application_ApplicationList_modal_cancel_label: "取消",
  /**** APPLICATION LIST END ****/

  /**** APPLICATION MANAGEMENT ENTERPRISE ****/
  //label
  scenes_Application_ApplicationManagementPlatform_name_label: "应用名称",
  scenes_Application_ApplicationManagementPlatform_code_label: "应用编码",
  scenes_Application_ApplicationManagementPlatform_type_label: "应用类型",
  scenes_Application_ApplicationManagementPlatform_createDate_label: "创建时间",
  scenes_Application_ApplicationManagementPlatform_status_label: "应用状态",
  scenes_Application_ApplicationManagementPlatform_version_label: "应用版本",
  scenes_Application_ApplicationManagementPlatform_versionStatus_label: "版本状态",
  scenes_Application_ApplicationManagementPlatform_action_label: "操作",
  scenes_Application_ApplicationManagementPlatform_create_label: "创建新应用",
  scenes_Application_ApplicationManagementPlatform_publish_label: "发布新版本",
  scenes_Application_ApplicationManagementPlatform_modify_label: "修改",
  scenes_Application_ApplicationManagementPlatform_view_label: "查看",
  scenes_Application_ApplicationManagementPlatform_audit_label: "提交审核",
  scenes_Application_ApplicationManagementPlatform_detail_label: "明细",
  scenes_Application_ApplicationManagementPlatform_online_label: "上线",
  scenes_Application_ApplicationManagementPlatform_offline_label: "下线",
  scenes_Application_ApplicationManagementPlatform_disabled_label: "封存",
  scenes_Application_ApplicationManagementPlatform_more_label: "更多",

  //placeholder
  scenes_Application_ApplicationManagementPlatform_name_placeholder: "过滤应用名称...",

  // popconfirm
  scenes_Application_ApplicationManagementPlatform_popConfirm_audit_title: "确认审核吗？",
  scenes_Application_ApplicationManagementPlatform_popConfirm_online_title: "确认上线吗？",
  scenes_Application_ApplicationManagementPlatform_popConfirm_offline_title: "确认下线吗？",
  scenes_Application_ApplicationManagementPlatform_popConfirm_disabled_title: "确认封存吗？",
  scenes_Application_ApplicationManagementPlatform_popConfirm_confirm_label: "确认",
  scenes_Application_ApplicationManagementPlatform_popConfirm_cancel_label: "取消",

  // modal
  scenes_Application_ApplicationManagementPlatform_modal_success_title: "成功",
  scenes_Application_ApplicationManagementPlatform_modal_fail_title: "失败",
  scenes_Application_ApplicationManagementPlatform_modal_statusSuccess_content: "更新状态成功！",
  scenes_Application_ApplicationManagementPlatform_modal_statusFail_content: "更新状态失败！",
  scenes_Application_ApplicationManagementPlatform_modal_auditSuccess_content: "提交审核成功！",
  scenes_Application_ApplicationManagementPlatform_modal_auditFail_content: "提交审核失败！",
  scenes_Application_ApplicationManagementPlatform_modal_onlineSuccess_content: "上线成功！",
  scenes_Application_ApplicationManagementPlatform_modal_onlineFail_content: "上线失败！",
  scenes_Application_ApplicationManagementPlatform_modal_offlineSuccess_content: "下线成功！",
  scenes_Application_ApplicationManagementPlatform_modal_offlineFail_content: "下线失败！",
  scenes_Application_ApplicationManagementPlatform_modal_disabledSuccess_content: "封存成功！",
  scenes_Application_ApplicationManagementPlatform_modal_disabledFail_content: "封存失败！",
  scenes_Application_ApplicationManagementPlatform_modal_OK_label: "确定",
  scenes_Application_ApplicationManagementPlatform_modal_cancel_label: "取消",
  /**** APPLICATION MANAGEMENT ENTERPRISE END ****/

  /**** APPLICATION MANAGEMENT ENTERPRISE ****/
  //label
  scenes_Application_ApplicationManagementEnterprise_name_label: "应用名称",
  scenes_Application_ApplicationManagementEnterprise_code_label: "应用编码",
  scenes_Application_ApplicationManagementEnterprise_type_label: "应用类型",
  scenes_Application_ApplicationManagementEnterprise_createDate_label: "创建时间",
  scenes_Application_ApplicationManagementEnterprise_status_label: "应用状态",
  scenes_Application_ApplicationManagementEnterprise_version_label: "应用版本",
  scenes_Application_ApplicationManagementEnterprise_versionStatus_label: "版本状态",
  scenes_Application_ApplicationManagementEnterprise_action_label: "操作",
  scenes_Application_ApplicationManagementEnterprise_create_label: "创建新应用",
  scenes_Application_ApplicationManagementEnterprise_publish_label: "发布新版本",
  scenes_Application_ApplicationManagementEnterprise_modify_label: "修改",
  scenes_Application_ApplicationManagementEnterprise_view_label: "查看",
  scenes_Application_ApplicationManagementEnterprise_audit_label: "提交审核",
  scenes_Application_ApplicationManagementEnterprise_detail_label: "明细",
  scenes_Application_ApplicationManagementEnterprise_online_label: "上线",
  scenes_Application_ApplicationManagementEnterprise_offline_label: "下线",
  scenes_Application_ApplicationManagementEnterprise_disabled_label: "封存",
  scenes_Application_ApplicationManagementEnterprise_more_label: "更多",

  //placeholder
  scenes_Application_ApplicationManagementEnterprise_name_placeholder: "过滤应用名称...",

  // popconfirm
  scenes_Application_ApplicationManagementEnterprise_popConfirm_audit_title: "确认审核吗？",
  scenes_Application_ApplicationManagementEnterprise_popConfirm_online_title: "确认上线吗？",
  scenes_Application_ApplicationManagementEnterprise_popConfirm_offline_title: "确认下线吗？",
  scenes_Application_ApplicationManagementEnterprise_popConfirm_disabled_title: "确认封存吗？",
  scenes_Application_ApplicationManagementEnterprise_popConfirm_confirm_label: "确认",
  scenes_Application_ApplicationManagementEnterprise_popConfirm_cancel_label: "取消",

  // modal
  scenes_Application_ApplicationManagementEnterprise_modal_success_title: "成功",
  scenes_Application_ApplicationManagementEnterprise_modal_fail_title: "失败",
  scenes_Application_ApplicationManagementEnterprise_modal_statusSuccess_content: "更新状态成功！",
  scenes_Application_ApplicationManagementEnterprise_modal_statusFail_content: "更新状态失败！",
  scenes_Application_ApplicationManagementEnterprise_modal_auditSuccess_content: "提交审核成功！",
  scenes_Application_ApplicationManagementEnterprise_modal_auditFail_content: "提交审核失败！",
  scenes_Application_ApplicationManagementEnterprise_modal_onlineSuccess_content: "上线成功！",
  scenes_Application_ApplicationManagementEnterprise_modal_onlineFail_content: "上线失败！",
  scenes_Application_ApplicationManagementEnterprise_modal_offlineSuccess_content: "下线成功！",
  scenes_Application_ApplicationManagementEnterprise_modal_offlineFail_content: "下线失败！",
  scenes_Application_ApplicationManagementEnterprise_modal_disabledSuccess_content: "封存成功！",
  scenes_Application_ApplicationManagementEnterprise_modal_disabledFail_content: "封存失败！",
  scenes_Application_ApplicationManagementEnterprise_modal_OK_label: "确定",
  scenes_Application_ApplicationManagementEnterprise_modal_cancel_label: "取消",
  /**** APPLICATION MANAGEMENT ENTERPRISE END ****/

  /**** APPLICATION MANAGEMENT PRIVATE ****/
  //label
  scenes_Application_ApplicationManagementPrivate_name_label: "应用名称",
  scenes_Application_ApplicationManagementPrivate_code_label: "应用编码",
  scenes_Application_ApplicationManagementPrivate_type_label: "应用类型",
  scenes_Application_ApplicationManagementPrivate_createDate_label: "创建时间",
  scenes_Application_ApplicationManagementPrivate_status_label: "应用状态",
  scenes_Application_ApplicationManagementPrivate_version_label: "应用版本",
  scenes_Application_ApplicationManagementPrivate_versionStatus_label: "版本状态",
  scenes_Application_ApplicationManagementPrivate_action_label: "操作",
  scenes_Application_ApplicationManagementPrivate_create_label: "创建新应用",
  scenes_Application_ApplicationManagementPrivate_publish_label: "发布新版本",
  scenes_Application_ApplicationManagementPrivate_modify_label: "修改",
  scenes_Application_ApplicationManagementPrivate_view_label: "查看",
  scenes_Application_ApplicationManagementPrivate_audit_label: "提交审核",
  scenes_Application_ApplicationManagementPrivate_detail_label: "明细",
  scenes_Application_ApplicationManagementPrivate_online_label: "上线",
  scenes_Application_ApplicationManagementPrivate_offline_label: "下线",
  scenes_Application_ApplicationManagementPrivate_disabled_label: "封存",
  scenes_Application_ApplicationManagementPrivate_more_label: "更多",

  //placeholder
  scenes_Application_ApplicationManagementPrivate_name_placeholder: "过滤应用名称...",

  // popconfirm
  scenes_Application_ApplicationManagementPrivate_popConfirm_audit_title: "确认审核吗？",
  scenes_Application_ApplicationManagementPrivate_popConfirm_online_title: "确认上线吗？",
  scenes_Application_ApplicationManagementPrivate_popConfirm_offline_title: "确认下线吗？",
  scenes_Application_ApplicationManagementPrivate_popConfirm_disabled_title: "确认封存吗？",
  scenes_Application_ApplicationManagementPrivate_popConfirm_confirm_label: "确认",
  scenes_Application_ApplicationManagementPrivate_popConfirm_cancel_label: "取消",

  // modal
  scenes_Application_ApplicationManagementPrivate_modal_success_title: "成功",
  scenes_Application_ApplicationManagementPrivate_modal_fail_title: "失败",
  scenes_Application_ApplicationManagementPrivate_modal_statusSuccess_content: "更新状态成功！",
  scenes_Application_ApplicationManagementPrivate_modal_statusFail_content: "更新状态失败！",
  scenes_Application_ApplicationManagementPrivate_modal_auditSuccess_content: "提交审核成功！",
  scenes_Application_ApplicationManagementPrivate_modal_auditFail_content: "提交审核失败！",
  scenes_Application_ApplicationManagementPrivate_modal_onlineSuccess_content: "上线成功！",
  scenes_Application_ApplicationManagementPrivate_modal_onlineFail_content: "上线失败！",
  scenes_Application_ApplicationManagementPrivate_modal_offlineSuccess_content: "下线成功！",
  scenes_Application_ApplicationManagementPrivate_modal_offlineFail_content: "下线失败！",
  scenes_Application_ApplicationManagementPrivate_modal_disabledSuccess_content: "封存成功！",
  scenes_Application_ApplicationManagementPrivate_modal_disabledFail_content: "封存失败！",
  scenes_Application_ApplicationManagementPrivate_modal_OK_label: "确定",
  scenes_Application_ApplicationManagementPrivate_modal_cancel_label: "取消",
  /**** APPLICATION MANAGEMENT PRIVATE END ****/

  /**** APPLICATION ADD ****/
  //label
  scenes_Application_ApplicationAdd_applicationInfo_label: "应用信息",
  scenes_Application_ApplicationAdd_applicationName_label: "应用名称",
  scenes_Application_ApplicationAdd_applicationEnName_label: "英文名称",
  scenes_Application_ApplicationAdd_applicationCode_label: "应用编码",
  scenes_Application_ApplicationAdd_autoGenerate_label: "自动生成",
  scenes_Application_ApplicationAdd_applicationTerminal_label: "终端类型",
  scenes_Application_ApplicationAdd_applicationModel_label: "应用模式",
  scenes_Application_ApplicationAdd_applicationType_label: "应用类型",
  scenes_Application_ApplicationAdd_applicationCategory_label: "应用类别",
  scenes_Application_ApplicationAdd_applicationLogo_label: "应用图标",
  scenes_Application_ApplicationAdd_uploadLogo_label: "上传图标",
  scenes_Application_ApplicationAdd_description_label: "应用简介",
  scenes_Application_ApplicationAdd_submit_label: "创建",
  scenes_Application_ApplicationAdd_return_label: "返回",

  //helpTip
  scenes_Application_ApplicationAdd_applicationInfo_helpTip: "应用信息",
  scenes_Application_ApplicationAdd_applicationName_helpTip: "填写的应用名称必须的是唯一的",
  scenes_Application_ApplicationAdd_applicationEnName_helpTip: "填写的英文名称必须的是唯一的",
  scenes_Application_ApplicationAdd_applicationCode_helpTip: "填写的应用编码必须是唯一的",
  scenes_Application_ApplicationAdd_autoGenerate_helpTip: "自动生成",
  scenes_Application_ApplicationAdd_applicationTerminal_helpTip: "终端的类型请选择手机端或者web端",
  scenes_Application_ApplicationAdd_applicationModel_helpTip: "应用模式是选择应用部署的方式",
  scenes_Application_ApplicationAdd_applicationType_helpTip: "市场应用是发布到应用市场的公共应用，专属应用是私有应用",
  scenes_Application_ApplicationAdd_applicationCategory_helpTip: "选择唯一的应用类别",
  scenes_Application_ApplicationAdd_applicationLogo_helpTip: "选择应用的图标，大小不超过100M",
  scenes_Application_ApplicationAdd_uploadLogo_helpTip: "上传图标",
  scenes_Application_ApplicationAdd_description_helpTip: "输入应用详情",

  //placeholder
  scenes_Application_ApplicationAdd_applicationName_placeholder: "请输入应用名称",
  scenes_Application_ApplicationAdd_applicationEnName_placeholder: "请输入英文名称",
  scenes_Application_ApplicationAdd_applicationCode_placeholder: "请输入应用编码",
  scenes_Application_ApplicationAdd_applicationModel_placeholder: "请选择应用模式",
  scenes_Application_ApplicationAdd_applicationType_placeholder: "请选择应用类型",
  scenes_Application_ApplicationAdd_applicationCategory_placeholder: "请选择应用类别",
  scenes_Application_ApplicationAdd_description_placeholder: "请输入应用简介",

  //message
  scenes_Application_ApplicationAdd_notUpload_message: "未上传!",
  scenes_Application_ApplicationAdd_uploadLogo_message: "请上传图标",
  scenes_Application_ApplicationAdd_promptName_message: "请输入应用名称，且必须唯一",
  scenes_Application_ApplicationAdd_promptEnName_message: "请输入英文名称，且必须唯一",
  scenes_Application_ApplicationAdd_promptCode_message: "请输入应用编码，且必须唯一",
  scenes_Application_ApplicationAdd_promptTerminal_message: "请选择终端类型",
  scenes_Application_ApplicationAdd_promptModel_message: "请选择应用模式",
  scenes_Application_ApplicationAdd_promptType_message: "请选择应用类型",
  scenes_Application_ApplicationAdd_promptCategory_message: "请选择应用类别",
  scenes_Application_ApplicationAdd_promptDescription_message: "请输入应用简介",
  scenes_Application_ApplicationAdd_lessThan100MB_message: "不可大于100MB",

  //modal
  scenes_Application_ApplicationAdd_modal_submit_content: "确认发布并提交审核吗？",
  scenes_Application_ApplicationAdd_modal_save_label: "暂时保存",
  scenes_Application_ApplicationAdd_modal_submit_label: "发布提交",
  scenes_Application_ApplicationAdd_modal_success_title: "成功",
  scenes_Application_ApplicationAdd_modal_fail_title: "失败",
  scenes_Application_ApplicationAdd_modal_submitSuccess_content: "应用发布成功!",
  scenes_Application_ApplicationAdd_modal_submitFail_content: "应用发布失败!",
  scenes_Application_ApplicationAdd_modal_uploadFileSuccess_content: "应用程序上传成功",
  scenes_Application_ApplicationAdd_modal_uploadFileFail_content: "应用发布成功，但应用程序上传失败！",
  scenes_Application_ApplicationAdd_modal_OK_label: "确定",
  scenes_Application_ApplicationAdd_modal_cancel_label: "返回",
  scenes_Application_ApplicationAdd_modal_jump_label: "跳转配置",
  scenes_Application_ApplicationAdd_modal_return_label: "返回管理",
  scenes_Application_ApplicationAdd_modal_yes_label: "是",
  scenes_Application_ApplicationAdd_modal_no_label: "否",
  scenes_Application_ApplicationAdd_modal_sameName_content: "应用名称已存在，请重新输入!",
  scenes_Application_ApplicationAdd_modal_sameEnName_content: "英文名称已存在，请重新输入!",
  scenes_Application_ApplicationAdd_modal_sameCode_content: "应用编码已存在，请重新输入!",
  scenes_Application_ApplicationAdd_modal_return_content: "有新增内容，是否返回？",
  /**** APPLICATION ADD END ****/

  /**** APPLICATION EDIT ****/
  //label
  scenes_Application_ApplicationEdit_applicationName_label: "应用名称",
  scenes_Application_ApplicationEdit_applicationEnName_label: "英文名称",
  scenes_Application_ApplicationEdit_applicationVersion_label: "应用版本",
  scenes_Application_ApplicationEdit_namespace_label: "空间名称",
  scenes_Application_ApplicationEdit_pullSecret_label: "空间秘钥",
  scenes_Application_ApplicationEdit_other_label: "其他服务",
  scenes_Application_ApplicationEdit_docker_label: "镜像地址",
  scenes_Application_ApplicationEdit_noDocker_label: "未找到，请重新检查或联系云平台管理员！",
  scenes_Application_ApplicationEdit_containerPort_label: "端口号",
  scenes_Application_ApplicationEdit_applicationMenu_label: "菜单名称",
  scenes_Application_ApplicationEdit_applicationUrl_label: "应用地址",
  scenes_Application_ApplicationEdit_resource_label: "资源规格",
  scenes_Application_ApplicationEdit_months_label: "服务时长(月)",
  scenes_Application_ApplicationEdit_cpuLimit_label: "CPU核数",
  scenes_Application_ApplicationEdit_memoryLimit_label: "内存(MB)",
  scenes_Application_ApplicationEdit_applicationInfo1_label: "该应用由",
  scenes_Application_ApplicationEdit_applicationInfo2_label: "于",
  scenes_Application_ApplicationEdit_applicationInfo3_label: "发布",
  scenes_Application_ApplicationEdit_returnAppMarket_label: "返回应用市场",
  scenes_Application_ApplicationEdit_returnAppManagement_label: "返回应用管理",
  scenes_Application_ApplicationEdit_audit_label: "提交审核",
  scenes_Application_ApplicationEdit_onlineApplication_label: "上线应用",
  scenes_Application_ApplicationEdit_offlineApplication_label: "下线应用",
  scenes_Application_ApplicationEdit_closeApplication_label: "封存应用",
  scenes_Application_ApplicationEdit_applicationCode_label: "应用编码",
  scenes_Application_ApplicationEdit_applicationTerminal_label: "终端类型",
  scenes_Application_ApplicationEdit_applicationModel_label: "应用模式",
  scenes_Application_ApplicationEdit_applicationType_label: "应用类型",
  scenes_Application_ApplicationEdit_applicationCategory_label: "应用类别",
  scenes_Application_ApplicationEdit_applicationDescription_label: "应用简介",
  scenes_Application_ApplicationEdit_applicationLogo_label: "应用图标",
  scenes_Application_ApplicationEdit_uploadLogo_label: "上传图标",
  scenes_Application_ApplicationEdit_applicationModify_label: "修改",
  scenes_Application_ApplicationEdit_applicationSubmit_label: "提交",
  scenes_Application_ApplicationEdit_applicationCancel_label: "取消",
  scenes_Application_ApplicationEdit_versionedList_label: "版本列表",
  scenes_Application_ApplicationEdit_publishNewVersionedApp_label: "发布新版本",
  scenes_Application_ApplicationEdit_plans_label: "计划选项",
  scenes_Application_ApplicationEdit_createPlan_label: "新建计划",
  scenes_Application_ApplicationEdit_modifyPlan_label: "修改计划",
  scenes_Application_ApplicationEdit_deletePlan_label: "删除计划",

  //placeholder
  scenes_Application_ApplicationEdit_applicationName_placeholder: "请输入应用名称",
  scenes_Application_ApplicationEdit_applicationEnName_placeholder: "请输入英文名称",
  scenes_Application_ApplicationEdit_applicationCode_placeholder: "请输入应用编码",
  scenes_Application_ApplicationEdit_applicationCategory_placeholder: "请输入应用类别",
  scenes_Application_ApplicationEdit_applicationDescription_placeholder: "请输入应用简介",
  scenes_Application_ApplicationEdit_resource_placeholder: "请选择资源规格",
  scenes_Application_ApplicationEdit_months_placeholder: "请输入服务时长",
  scenes_Application_ApplicationEdit_cpuLimit_placeholder: "请输入CPU核数",
  scenes_Application_ApplicationEdit_memoryLimit_placeholder: "请输入内存",
  scenes_Application_ApplicationEdit_namespace_placeholder: "请输入空间名称",
  scenes_Application_ApplicationEdit_pullSecret_placeholder: "请输入空间秘钥",
  scenes_Application_ApplicationEdit_other_placeholder: "可选择其他服务",

  //message
  scenes_Application_ApplicationEdit_applicationName_message: "请输入应用名称",
  scenes_Application_ApplicationEdit_applicationEnName_message: "请输入英文名称",
  scenes_Application_ApplicationEdit_applicationCode_message: "请输入应用编码，且必须唯一",
  scenes_Application_ApplicationEdit_applicationCategory_message: "请输入应用类别",
  scenes_Application_ApplicationEdit_applicationDescription_message: "请输入应用简介",
  scenes_Application_ApplicationEdit_cpuLimit_message: "请输入CPU核数",
  scenes_Application_ApplicationEdit_memoryLimit_message: "请输入内存",
  scenes_Application_ApplicationEdit_namespace_message: "请输入空间名称",
  scenes_Application_ApplicationEdit_pullSecret_message: "请输入空间秘钥",
  scenes_Application_ApplicationEdit_pullSecret_error_message: "空间秘钥错误",

  // modal
  scenes_Application_ApplicationEdit_modal_success_title: "成功",
  scenes_Application_ApplicationEdit_modal_fail_title: "失败",
  scenes_Application_ApplicationEdit_modal_submitAudit_content: "是否提交审核？",
  scenes_Application_ApplicationEdit_modal_updateSuccess_content: "保存更新成功，是否提交审核？",
  scenes_Application_ApplicationEdit_modal_updateFail_content: "保存更新失败!",
  scenes_Application_ApplicationEdit_modal_updateStatusSuccess_content1: "提交审核成功！",
  scenes_Application_ApplicationEdit_modal_updateStatusFail_content1: "提交审核失败!",
  scenes_Application_ApplicationEdit_modal_updateStatusSuccess_content3: "上线成功！",
  scenes_Application_ApplicationEdit_modal_updateStatusFail_content3: "上线失败!",
  scenes_Application_ApplicationEdit_modal_updateStatusSuccess_content4: "下线成功！",
  scenes_Application_ApplicationEdit_modal_updateStatusFail_content4: "下线失败!",
  scenes_Application_ApplicationEdit_modal_updateStatusSuccess_content5: "封存成功！",
  scenes_Application_ApplicationEdit_modal_updateStatusFail_content5: "封存失败!",
  scenes_Application_ApplicationEdit_modal_deletePlanSuccess_content: "删除资源配置成功！",
  scenes_Application_ApplicationEdit_modal_deletePlanFail_content: "删除资源配置失败！",
  scenes_Application_ApplicationEdit_modal_deploySuccess_content: "应用部署成功！",
  scenes_Application_ApplicationEdit_modal_deployFail_content: "应用部署失败！",

  scenes_Application_ApplicationEdit_modal_visitUrl_content: "部署标识码为{visitUrl}",
  scenes_Application_ApplicationEdit_modal_OK_label: "确定",
  scenes_Application_ApplicationEdit_modal_return_label: "返回",
  scenes_Application_ApplicationEdit_modal_yes_label: "是",
  scenes_Application_ApplicationEdit_modal_no_label: "否",

  //confirm modal
  scenes_Application_ApplicationEdit_modal_confirm_title: "确认",
  scenes_Application_ApplicationEdit_modal_online_content: "确认上线该应用吗？",
  scenes_Application_ApplicationEdit_modal_offline_content: "确认下线该应用吗？",
  scenes_Application_ApplicationEdit_modal_close_content: "确认封存该应用吗？",
  scenes_Application_ApplicationEdit_modal_deletePlan_content: "确认删除该计划吗？",
  scenes_Application_ApplicationEdit_modal_confirm_label: "确认",
  scenes_Application_ApplicationEdit_modal_cancel_label: "取消",
  /**** APPLICATION EDIT END ****/

  /**** MODULE ADD ****/
  //label
  scenes_Application_ModuleAdd_applicationInfo_label: "应用信息",
  scenes_Application_ModuleAdd_applicationName_label: "应用名称",
  scenes_Application_ModuleAdd_applicationEnName_label: "英文名称",
  scenes_Application_ModuleAdd_applicationCode_label: "应用编码",
  scenes_Application_ModuleAdd_autoGenerate_label: "自动生成",
  scenes_Application_ModuleAdd_applicationTerminal_label: "终端类型",
  scenes_Application_ModuleAdd_applicationModel_label: "应用模式",
  scenes_Application_ModuleAdd_applicationType_label: "应用类型",
  scenes_Application_ModuleAdd_applicationCategory_label: "应用类别",
  scenes_Application_ModuleAdd_applicationLogo_label: "应用图标",
  scenes_Application_ModuleAdd_uploadLogo_label: "上传图标",
  scenes_Application_ModuleAdd_description_label: "应用简介",
  scenes_Application_ModuleAdd_submit_label: "创建",
  scenes_Application_ModuleAdd_return_label: "返回",

  //helpTip
  scenes_Application_ModuleAdd_applicationInfo_helpTip: "应用信息",
  scenes_Application_ModuleAdd_applicationName_helpTip: "填写的应用名称必须的是唯一的",
  scenes_Application_ModuleAdd_applicationEnName_helpTip: "填写的英文名称必须的是唯一的",
  scenes_Application_ModuleAdd_applicationCode_helpTip: "填写的应用编码必须是唯一的",
  scenes_Application_ModuleAdd_autoGenerate_helpTip: "自动生成",
  scenes_Application_ModuleAdd_applicationTerminal_helpTip: "终端的类型请选择手机端或者web端",
  scenes_Application_ModuleAdd_applicationModel_helpTip: "应用模式是选择应用部署的方式",
  scenes_Application_ModuleAdd_applicationType_helpTip: "市场应用是发布到应用市场的公共应用，专属应用是私有应用",
  scenes_Application_ModuleAdd_applicationCategory_helpTip: "选择唯一的应用类别",
  scenes_Application_ModuleAdd_applicationLogo_helpTip: "选择应用的图标，大小不超过100M",
  scenes_Application_ModuleAdd_uploadLogo_helpTip: "上传图标",
  scenes_Application_ModuleAdd_description_helpTip: "输入应用详情",

  //placeholder
  scenes_Application_ModuleAdd_applicationName_placeholder: "请输入应用名称",
  scenes_Application_ModuleAdd_applicationEnName_placeholder: "请输入英文名称",
  scenes_Application_ModuleAdd_applicationCode_placeholder: "请输入应用编码",
  scenes_Application_ModuleAdd_applicationModel_placeholder: "请选择应用模式",
  scenes_Application_ModuleAdd_applicationType_placeholder: "请选择应用类型",
  scenes_Application_ModuleAdd_applicationCategory_placeholder: "请选择应用类别",
  scenes_Application_ModuleAdd_description_placeholder: "请输入应用简介",

  //message
  scenes_Application_ModuleAdd_notUpload_message: "未上传!",
  scenes_Application_ModuleAdd_uploadLogo_message: "请上传图标",
  scenes_Application_ModuleAdd_promptName_message: "请输入应用名称，且必须唯一",
  scenes_Application_ModuleAdd_promptEnName_message: "请输入英文名称，且必须唯一",
  scenes_Application_ModuleAdd_promptCode_message: "请输入应用编码，且必须唯一",
  scenes_Application_ModuleAdd_promptTerminal_message: "请选择终端类型",
  scenes_Application_ModuleAdd_promptModel_message: "请选择应用模式",
  scenes_Application_ModuleAdd_promptType_message: "请选择应用类型",
  scenes_Application_ModuleAdd_promptCategory_message: "请选择应用类别",
  scenes_Application_ModuleAdd_promptDescription_message: "请输入应用简介",
  scenes_Application_ModuleAdd_lessThan100MB_message: "不可大于100MB",

  //modal
  scenes_Application_ModuleAdd_modal_submit_content: "确认发布并提交审核吗？",
  scenes_Application_ModuleAdd_modal_save_label: "暂时保存",
  scenes_Application_ModuleAdd_modal_submit_label: "发布提交",
  scenes_Application_ModuleAdd_modal_success_title: "成功",
  scenes_Application_ModuleAdd_modal_fail_title: "失败",
  scenes_Application_ModuleAdd_modal_submitSuccess_content: "应用发布成功!",
  scenes_Application_ModuleAdd_modal_submitFail_content: "应用发布失败!",
  scenes_Application_ModuleAdd_modal_uploadFileSuccess_content: "应用程序上传成功",
  scenes_Application_ModuleAdd_modal_uploadFileFail_content: "应用发布成功，但应用程序上传失败！",
  scenes_Application_ModuleAdd_modal_OK_label: "确定",
  scenes_Application_ModuleAdd_modal_cancel_label: "返回",
  scenes_Application_ModuleAdd_modal_jump_label: "跳转配置",
  scenes_Application_ModuleAdd_modal_return_label: "返回管理",
  scenes_Application_ModuleAdd_modal_yes_label: "是",
  scenes_Application_ModuleAdd_modal_no_label: "否",
  scenes_Application_ModuleAdd_modal_sameName_content: "应用名称已存在，请重新输入!",
  scenes_Application_ModuleAdd_modal_sameEnName_content: "英文名称已存在，请重新输入!",
  scenes_Application_ModuleAdd_modal_sameCode_content: "应用编码已存在，请重新输入!",
  scenes_Application_ModuleAdd_modal_return_content: "有新增内容，是否返回？",
  /**** MODULE ADD END ****/

  /**** MODULE EDIT ****/
  //label
  scenes_Application_ModuleEdit_applicationName_label: "应用名称",
  scenes_Application_ModuleEdit_applicationEnName_label: "英文名称",
  scenes_Application_ModuleEdit_applicationVersion_label: "应用版本",
  scenes_Application_ModuleEdit_namespace_label: "空间名称",
  scenes_Application_ModuleEdit_pullSecret_label: "空间秘钥",
  scenes_Application_ModuleEdit_other_label: "其他服务",
  scenes_Application_ModuleEdit_docker_label: "镜像地址",
  scenes_Application_ModuleEdit_noDocker_label: "未找到，请重新检查或联系云平台管理员！",
  scenes_Application_ModuleEdit_containerPort_label: "端口号",
  scenes_Application_ModuleEdit_resource_label: "资源规格",
  scenes_Application_ModuleEdit_months_label: "服务时长(月)",
  scenes_Application_ModuleEdit_cpuLimit_label: "CPU核数",
  scenes_Application_ModuleEdit_memoryLimit_label: "内存(MB)",
  scenes_Application_ModuleEdit_applicationInfo1_label: "该应用由",
  scenes_Application_ModuleEdit_applicationInfo2_label: "于",
  scenes_Application_ModuleEdit_applicationInfo3_label: "发布",
  scenes_Application_ModuleEdit_returnAppMain_label: "返回应用配置",
  scenes_Application_ModuleEdit_returnAppManagement_label: "返回应用管理",
  scenes_Application_ModuleEdit_audit_label: "提交审核",
  scenes_Application_ModuleEdit_onlineApplication_label: "上线应用",
  scenes_Application_ModuleEdit_offlineApplication_label: "下线应用",
  scenes_Application_ModuleEdit_closeApplication_label: "封存应用",
  scenes_Application_ModuleEdit_applicationCode_label: "应用编码",
  scenes_Application_ModuleEdit_applicationTerminal_label: "终端类型",
  scenes_Application_ModuleEdit_applicationModel_label: "应用模式",
  scenes_Application_ModuleEdit_applicationType_label: "应用类型",
  scenes_Application_ModuleEdit_applicationCategory_label: "应用类别",
  scenes_Application_ModuleEdit_applicationDescription_label: "应用简介",
  scenes_Application_ModuleEdit_applicationLogo_label: "应用图标",
  scenes_Application_ModuleEdit_uploadLogo_label: "上传图标",
  scenes_Application_ModuleEdit_applicationModify_label: "修改",
  scenes_Application_ModuleEdit_applicationSubmit_label: "提交",
  scenes_Application_ModuleEdit_applicationCancel_label: "取消",
  scenes_Application_ModuleEdit_versionedList_label: "版本列表",
  scenes_Application_ModuleEdit_publishNewVersionedApp_label: "发布新版本",
  scenes_Application_ModuleEdit_plans_label: "计划选项",
  scenes_Application_ModuleEdit_createPlan_label: "新建计划",
  scenes_Application_ModuleEdit_modifyPlan_label: "修改计划",
  scenes_Application_ModuleEdit_deletePlan_label: "删除计划",

  //placeholder
  scenes_Application_ModuleEdit_applicationName_placeholder: "请输入应用名称",
  scenes_Application_ModuleEdit_applicationEnName_placeholder: "请输入英文名称",
  scenes_Application_ModuleEdit_applicationCode_placeholder: "请输入应用编码",
  scenes_Application_ModuleEdit_applicationCategory_placeholder: "请输入应用类别",
  scenes_Application_ModuleEdit_applicationDescription_placeholder: "请输入应用简介",
  scenes_Application_ModuleEdit_resource_placeholder: "请选择资源规格",
  scenes_Application_ModuleEdit_months_placeholder: "请输入服务时长",
  scenes_Application_ModuleEdit_cpuLimit_placeholder: "请输入CPU核数",
  scenes_Application_ModuleEdit_memoryLimit_placeholder: "请输入内存",
  scenes_Application_ModuleEdit_namespace_placeholder: "请输入空间名称",
  scenes_Application_ModuleEdit_pullSecret_placeholder: "请输入空间秘钥",
  scenes_Application_ModuleEdit_other_placeholder: "可选择其他服务",

  //message
  scenes_Application_ModuleEdit_applicationName_message: "请输入应用名称",
  scenes_Application_ModuleEdit_applicationEnName_message: "请输入英文名称",
  scenes_Application_ModuleEdit_applicationCode_message: "请输入应用编码，且必须唯一",
  scenes_Application_ModuleEdit_applicationCategory_message: "请输入应用类别",
  scenes_Application_ModuleEdit_applicationDescription_message: "请输入应用简介",
  scenes_Application_ModuleEdit_cpuLimit_message: "请输入CPU核数",
  scenes_Application_ModuleEdit_memoryLimit_message: "请输入内存",
  scenes_Application_ModuleEdit_namespace_message: "请输入空间名称",
  scenes_Application_ModuleEdit_pullSecret_message: "请输入空间秘钥",
  scenes_Application_ModuleEdit_pullSecret_error_message: "空间秘钥错误",

  // modal
  scenes_Application_ModuleEdit_modal_success_title: "成功",
  scenes_Application_ModuleEdit_modal_fail_title: "失败",
  scenes_Application_ModuleEdit_modal_submitAudit_content: "是否提交审核？",
  scenes_Application_ModuleEdit_modal_updateSuccess_content: "保存更新成功，是否提交审核？",
  scenes_Application_ModuleEdit_modal_updateFail_content: "保存更新失败!",
  scenes_Application_ModuleEdit_modal_updateStatusSuccess_content1: "提交审核成功！",
  scenes_Application_ModuleEdit_modal_updateStatusFail_content1: "提交审核失败!",
  scenes_Application_ModuleEdit_modal_updateStatusSuccess_content3: "上线成功！",
  scenes_Application_ModuleEdit_modal_updateStatusFail_content3: "上线失败!",
  scenes_Application_ModuleEdit_modal_updateStatusSuccess_content4: "下线成功！",
  scenes_Application_ModuleEdit_modal_updateStatusFail_content4: "下线失败!",
  scenes_Application_ModuleEdit_modal_updateStatusSuccess_content5: "封存成功！",
  scenes_Application_ModuleEdit_modal_updateStatusFail_content5: "封存失败!",
  scenes_Application_ModuleEdit_modal_deletePlanSuccess_content: "删除资源配置成功！",
  scenes_Application_ModuleEdit_modal_deletePlanFail_content: "删除资源配置失败！",
  scenes_Application_ModuleEdit_modal_deploySuccess_content: "应用部署成功！",
  scenes_Application_ModuleEdit_modal_deployFail_content: "应用部署失败！",

  scenes_Application_ModuleEdit_modal_visitUrl_content: "访问地址为{visitUrl}",
  scenes_Application_ModuleEdit_modal_OK_label: "确定",
  scenes_Application_ModuleEdit_modal_return_label: "返回",
  scenes_Application_ModuleEdit_modal_yes_label: "是",
  scenes_Application_ModuleEdit_modal_no_label: "否",

  //confirm modal
  scenes_Application_ModuleEdit_modal_confirm_title: "确认",
  scenes_Application_ModuleEdit_modal_online_content: "确认上线该应用吗？",
  scenes_Application_ModuleEdit_modal_offline_content: "确认下线该应用吗？",
  scenes_Application_ModuleEdit_modal_close_content: "确认封存该应用吗？",
  scenes_Application_ModuleEdit_modal_deletePlan_content: "确认删除该计划吗？",
  scenes_Application_ModuleEdit_modal_confirm_label: "确认",
  scenes_Application_ModuleEdit_modal_cancel_label: "取消",
  /**** MODULE EDIT END ****/

  /**** APPLICATION VERIFY ****/
  //table
  scenes_Application_ApplicationVerify_name_label: "应用名称",
  scenes_Application_ApplicationVerify_code_label: "应用编码",
  scenes_Application_ApplicationVerify_type_label: "应用类型",
  scenes_Application_ApplicationVerify_category_label: "应用类别",
  scenes_Application_ApplicationVerify_version_label: "版本号",
  scenes_Application_ApplicationVerify_sourceType_label: "代码格式",
  scenes_Application_ApplicationVerify_date_label: "创建日期",
  scenes_Application_ApplicationVerify_user_label: "开发者",
  scenes_Application_ApplicationVerify_company_label: "开发商",

  //popconfirm
  scenes_Application_ApplicationVerify_popConfirm_audit_title: "确认通过吗？",
  scenes_Application_ApplicationVerify_popConfirm_confirm_label: "确认",
  scenes_Application_ApplicationVerify_popConfirm_cancel_label: "取消",

  //label
  // scenes_Application_ApplicationVerify_applicationName_label: "应用名称",
  // scenes_Application_ApplicationVerify_applicationEnName_label: "英文名称",
  // scenes_Application_ApplicationVerify_majorVersion_label: "主版本号",
  // scenes_Application_ApplicationVerify_minorVersion_label: "子版本号",
  // scenes_Application_ApplicationVerify_sourceType_label: "源码格式",
  // scenes_Application_ApplicationVerify_description_label: "版本详情",
  // scenes_Application_ApplicationVerify_screenHeight_label: "屏显高度",
  // scenes_Application_ApplicationVerify_screenshots_label: "上传截图",
  // scenes_Application_ApplicationVerify_applicationFile_label: "应用程序",
  // scenes_Application_ApplicationVerify_helpFile_label: "帮助文档",
  // scenes_Application_ApplicationVerify_apiFile_label: "API文档",
  // scenes_Application_ApplicationVerify_testReportFile_label: "测试报告",
  // scenes_Application_ApplicationVerify_selectFile_label: "选择文件",
  // scenes_Application_ApplicationVerify_privilegeAllocation_label: "权限配置",
  scenes_Application_ApplicationVerify_pass_label: "通过",
  scenes_Application_ApplicationVerify_noPass_label: "不通过",

  //placeholder
  scenes_Application_ApplicationVerify_name_placeholder: "搜索应用名称",
  // scenes_Application_ApplicationVerify_newMajor_placeholder: "请输入主版本号",
  // scenes_Application_ApplicationVerify_minorVersion_placeholder: "请输入子版本号",
  // scenes_Application_ApplicationVerify_SourceType_placeholder: "请选择程序语言格式",
  // scenes_Application_ApplicationVerify_description_placeholder: "请输入版本详情",
  // scenes_Application_ApplicationVerify_screenHeight_placeholder: "请输入屏显高度",

  //  modal
  scenes_Application_ApplicationVerify_modal_success_title: "成功",
  scenes_Application_ApplicationVerify_modal_fail_title: "失败",
  scenes_Application_ApplicationVerify_modal_auditSuccess_content: "审核成功!",
  scenes_Application_ApplicationVerify_modal_auditFail_content: "审核失败!",
  scenes_Application_ApplicationVerify_modal_OK_label: "确定",
  scenes_Application_ApplicationVerify_modal_cancel_label: "返回",
  /**** APPLICATION VERIFY END ****/

  /**** VERSION ADD ****/
  //table
  scenes_Application_VersionAdd_privilegeCode_title: "权限编码",
  scenes_Application_VersionAdd_privilegeName_title: "权限名称",
  scenes_Application_VersionAdd_privilegeDescription_title: "权限说明",
  scenes_Application_VersionAdd_operation_title: "操作",

  //popconfirm
  scenes_Application_VersionAdd_popconfirm_title: "确认删除吗？",
  scenes_Application_VersionAdd_popconfirmOK_title: "确认",
  scenes_Application_VersionAdd_popconfirmCancel_title: "取消",

  //label
  scenes_Application_VersionAdd_applicationName_label: "应用名称",
  scenes_Application_VersionAdd_applicationEnName_label: "英文名称",
  scenes_Application_VersionAdd_majorVersion_label: "主版本号",
  scenes_Application_VersionAdd_minorVersion_label: "子版本号",
  scenes_Application_VersionAdd_sourceType_label: "源码格式",
  scenes_Application_VersionAdd_description_label: "版本详情",
  scenes_Application_VersionAdd_screenHeight_label: "屏显高度",
  scenes_Application_VersionAdd_screenshots_label: "上传截图",
  scenes_Application_VersionAdd_release_label: "部署方式",
  scenes_Application_VersionAdd_releaseJar_label: "上云部署",
  scenes_Application_VersionAdd_releaseUrl_label: "外网应用",
  scenes_Application_VersionAdd_releaseJenkins_label: "镜像发布",
  scenes_Application_VersionAdd_applicationFile_label: "应用程序",
  scenes_Application_VersionAdd_containerPort_label: "端口号",
  scenes_Application_VersionAdd_url_label: "访问地址",
  scenes_Application_VersionAdd_menu_label: "菜单名称",
  scenes_Application_VersionAdd_helpFile_label: "帮助文档",
  scenes_Application_VersionAdd_apiFile_label: "API文档",
  scenes_Application_VersionAdd_testReportFile_label: "测试报告",
  scenes_Application_VersionAdd_selectFile_label: "选择文件",
  scenes_Application_VersionAdd_privilegeAllocation_label: "权限配置",
  scenes_Application_VersionAdd_privilegeTrue_label: "使用",
  scenes_Application_VersionAdd_privilegeFalse_label: "不使用",
  scenes_Application_VersionAdd_submit_label: "提交",
  scenes_Application_VersionAdd_cancel_label: "返回",
  scenes_Application_VersionAdd_jenkins_label: "镜像地址",
  scenes_Application_VersionAdd_gitlab_label: "gitlab项目名",

  //helpTip
  scenes_Application_VersionAdd_applicationName_helpTip: "应用名称",
  scenes_Application_VersionAdd_applicationEnName_helpTip: "英文名称",
  scenes_Application_VersionAdd_majorVersion_helpTip: "选择需要发布的主版本，也可新建",
  scenes_Application_VersionAdd_minorVersion_helpTip: "输入需要发布的子版本，不可重复",
  scenes_Application_VersionAdd_sourceType_helpTip: "程序语言格式为gitlab，github等",
  scenes_Application_VersionAdd_description_helpTip: "输入该版本的详细信息",
  scenes_Application_VersionAdd_screenHeight_helpTip: "屏显高度为应用程序显示的高度，默认为320",
  scenes_Application_VersionAdd_screenshots_helpTip: "上传截图",
  scenes_Application_VersionAdd_applicationFile_helpTip: "发布应用程序文件",
  scenes_Application_VersionAdd_language_helpTip: "请选择编程语言，默认为Java8，前端应用请选择Nginx",
  scenes_Application_VersionAdd_helpFile_helpTip: "帮助文档",
  scenes_Application_VersionAdd_apiFile_helpTip: "API文档",
  scenes_Application_VersionAdd_testReportFile_helpTip: "测试报告",
  scenes_Application_VersionAdd_selectFile_helpTip: "选择文件",
  scenes_Application_VersionAdd_privilegeAllocation_helpTip: "权限配置是开发者设置的唯一字符串，用于标识应用者的特定权限，具体权限控制逻辑由开发者在代码中定义",
  scenes_Application_VersionAdd_release_helpTip: "选择部署方式：阿里云部署需本地上传jar包；外网已部署的应用录入有效的访问地址。",
  scenes_Application_VersionAdd_url_helpTip: "输入有效的访问地址，只支持https://为开头。(如果仅作为主菜单，地址可为空)",
  scenes_Application_VersionAdd_menu_helpTip: "菜单名称不可与应用名称重名",
  //placeholder
  scenes_Application_VersionAdd_majorVersion_placeholder: "请选择主版本号",
  scenes_Application_VersionAdd_newMajor_placeholder: "请输入主版本号",
  scenes_Application_VersionAdd_minorVersion_placeholder: "请输入子版本号",
  scenes_Application_VersionAdd_containerPort_placeholder: "请输入端口号",
  scenes_Application_VersionAdd_url_placeholder: "请输入访问地址",
  scenes_Application_VersionAdd_menu_placeholder: "请输入菜单名称",
  scenes_Application_VersionAdd_SourceType_placeholder: "请选择程序语言格式",
  scenes_Application_VersionAdd_description_placeholder: "请输入版本详情",
  scenes_Application_VersionAdd_screenHeight_placeholder: "请输入屏显高度",
  scenes_Application_VersionAdd_jenkins_placeholder: "请输入镜像地址",
  scenes_Application_VersionAdd_gitlab_placeholder: "请输入项目名称",

  //message
  scenes_Application_VersionAdd_required_message: "必填",
  scenes_Application_VersionAdd_checkVersion_message: "该版本号已存在，请重新输入！",
  scenes_Application_VersionAdd_promptMajorVersion_message: "请选择主版本号",
  scenes_Application_VersionAdd_promptNewMajor_message: "请输入主版本号",
  scenes_Application_VersionAdd_promptMinorVersion_message: "请输入子版本号",
  scenes_Application_VersionAdd_promptSourceType_message: "请选择程序语言格式",
  scenes_Application_VersionAdd_promptVersionDescription_message: "请输入版本详情",
  scenes_Application_VersionAdd_promptScreenHeight_message: "请输入屏显高度",
  scenes_Application_VersionAdd_release_message: "请选择发布方式",
  scenes_Application_VersionAdd_applicationFile_message: "请上传应用程序",
  scenes_Application_VersionAdd_lessThan100MB_message: "不可大于100MB",
  scenes_Application_VersionAdd_containerPort_message: "请输入端口号",
  scenes_Application_VersionAdd_url_message: "请输入访问地址",
  scenes_Application_VersionAdd_menu_message: "请输入菜单名称",
  scenes_Application_VersionAdd_checkMenu_message: "与应用名称重名，请重输入！",
  scenes_Application_VersionAdd_jenkins_message: "请输入镜像地址",
  scenes_Application_VersionAdd_gitlab_message: "请输入项目名称",

  //  modal
  scenes_Application_VersionAdd_modal_submit_content: "确认发布并提交审核吗？",
  scenes_Application_VersionAdd_modal_return_content: "有新增内容，是否返回？",
  scenes_Application_VersionAdd_modal_save_label: "暂时保存",
  scenes_Application_VersionAdd_modal_submit_label: "发布提交",
  scenes_Application_VersionAdd_modal_success_title: "成功",
  scenes_Application_VersionAdd_modal_fail_title: "失败",
  scenes_Application_VersionAdd_modal_submitSuccess_content: "版本发布成功!",
  scenes_Application_VersionAdd_modal_submitFail_content: "版本发布失败!",
  scenes_Application_VersionAdd_modal_uploadFileSuccess_content: "应用程序上传成功",
  scenes_Application_VersionAdd_modal_uploadFileFail_content: "版本发布成功，但应用程序上传失败！",
  scenes_Application_VersionAdd_modal_OK_label: "确定",
  scenes_Application_VersionAdd_modal_cancel_label: "返回",
  scenes_Application_VersionAdd_modal_yes_label: "是",
  scenes_Application_VersionAdd_modal_no_label: "否",
  /**** VERSION ADD END ****/

  /**** VERSION EDIT ****/
  //table
  scenes_Application_VersionEdit_privilegeCode_title: "权限编码",
  scenes_Application_VersionEdit_privilegeName_title: "权限名称",
  scenes_Application_VersionEdit_privilegeDescription_title: "权限说明",
  scenes_Application_VersionEdit_operation_title: "操作",

  //popconfirm
  scenes_Application_VersionEdit_popconfirmDelete_title: "确认删除吗？",
  scenes_Application_VersionEdit_popconfirmOK_title: "确认",
  scenes_Application_VersionEdit_popconfirmCancel_title: "取消",

  //label
  scenes_Application_VersionEdit_version_label: "应用版本",
  scenes_Application_VersionEdit_sourceType_label: "程序格式",
  scenes_Application_VersionEdit_applicationType_label: "应用类型",
  scenes_Application_VersionEdit_versionInfo1_label: "该版本由",
  scenes_Application_VersionEdit_versionInfo2_label: "于",
  scenes_Application_VersionEdit_versionInfo3_label: "更新",
  scenes_Application_VersionEdit_description_label: "版本详情",
  scenes_Application_VersionEdit_screenshot_label: "界面预览",
  scenes_Application_VersionEdit_screenHeight_label: "屏显高度",
  scenes_Application_VersionEdit_screenshots_label: "上传截图",
  scenes_Application_VersionEdit_deploymentFile_label: "应用程序",
  scenes_Application_VersionEdit_helpFile_label: "帮助文档",
  scenes_Application_VersionEdit_apiFile_label: "API文档",
  scenes_Application_VersionEdit_testReportFile_label: "测试报告",
  scenes_Application_VersionEdit_replaceFile_label: "替换文件",
  scenes_Application_VersionEdit_selectFile_label: "选择文件",
  scenes_Application_VersionEdit_privilegeAllocation_label: "权限配置",
  scenes_Application_VersionEdit_download_label: "下载",
  scenes_Application_VersionEdit_notUpload_label: "未上传",
  scenes_Application_VersionEdit_uploaded_label: "已上传",
  scenes_Application_VersionEdit_audit_label: "提交审核",
  scenes_Application_VersionEdit_online_label: "版本上线",
  scenes_Application_VersionEdit_disabled_label: "版本封存",
  scenes_Application_VersionEdit_modify_label: "修改",
  scenes_Application_VersionEdit_save_label: "保存",
  scenes_Application_VersionEdit_cancel_label: "取消",
  scenes_Application_VersionEdit_return_label: "返回",

  //helpTip
  scenes_Application_VersionEdit_privilegeAllocation_helpTip: "权限配置",

  //placeholder
  scenes_Application_VersionEdit_description_placeholder: "请输入版本详情",
  scenes_Application_VersionEdit_screenHeight_placeholder: "请输入屏显高度",
  scenes_Application_VersionEdit_sourceType_placeholder: "请选择程序语言格式",

  //message
  scenes_Application_VersionEdit_required_message: "必填",
  scenes_Application_VersionEdit_sourceType_message: "请选择程序语言格式",
  scenes_Application_VersionEdit_description_message: "请输入版本详情",
  scenes_Application_VersionEdit_screenHeight_message: "请输入屏显高度",
  scenes_Application_VersionEdit_lessThan100MB_message: "不可大于100MB",
  scenes_Application_VersionEdit_firstPage_message: "已经是第一张",
  scenes_Application_VersionEdit_lastPage_message: "已经是最后一张",

  //modal
  scenes_Application_VersionEdit_modal_audit_content: "确认提交审核吗？",
  scenes_Application_VersionEdit_modal_online_content: "确认上线该版本吗？",
  scenes_Application_VersionEdit_modal_disabled_content: "确认封存该版本吗？",
  scenes_Application_VersionEdit_modal_confirm_label: "确认",
  scenes_Application_VersionEdit_modal_cancel_label: "取消",

  scenes_Application_VersionEdit_modal_success_title: "成功",
  scenes_Application_VersionEdit_modal_fail_title: "失败",
  scenes_Application_VersionEdit_modal_updateSuccess_content: "保存更新成功，是否提交审核？",
  scenes_Application_VersionEdit_modal_updateFail_content: "保存更新失败!",
  scenes_Application_VersionEdit_modal_updateStatusSuccess_content1: "提交审核成功！",
  scenes_Application_VersionEdit_modal_updateStatusFail_content1: "提交审核失败!",
  scenes_Application_VersionEdit_modal_updateStatusSuccess_content3: "版本上线成功！",
  scenes_Application_VersionEdit_modal_updateStatusFail_content3: "版本上线失败!",
  scenes_Application_VersionEdit_modal_updateStatusSuccess_content5: "版本封存成功！",
  scenes_Application_VersionEdit_modal_updateStatusFail_content5: "版本封存失败!",
  scenes_Application_VersionEdit_modal_OK_label: "确定",
  scenes_Application_VersionEdit_modal_return_label: "返回",
  scenes_Application_VersionEdit_modal_yes_label: "是",
  scenes_Application_VersionEdit_modal_no_label: "否",
  /**** VERSION EDIT END ****/

  /**** PUBLISH APP VERSION ****/
  //table
  scenes_Application_PublishAppVersion_privilegeCode_title: "权限编码",
  scenes_Application_PublishAppVersion_privilegeName_title: "权限名称",
  scenes_Application_PublishAppVersion_privilegeDescription_title: "权限说明",
  scenes_Application_PublishAppVersion_operation_title: "操作",

  //popconfirm
  scenes_Application_PublishAppVersion_popconfirm_title: "确认删除吗？",
  scenes_Application_PublishAppVersion_popconfirmOK_title: "确认",
  scenes_Application_PublishAppVersion_popconfirmCancel_title: "取消",

  //label
  scenes_Application_PublishAppVersion_applicationName_label: "应用名称",
  scenes_Application_PublishAppVersion_version_label: "应用版本",
  scenes_Application_PublishAppVersion_sourceType_label: "程序语言格式",
  scenes_Application_PublishAppVersion_description_label: "版本详情",
  scenes_Application_PublishAppVersion_screenHeight_label: "屏显高度",
  scenes_Application_PublishAppVersion_screenshots_label: "上传截图",
  scenes_Application_PublishAppVersion_applicationFile_label: "应用程序",
  scenes_Application_PublishAppVersion_helpFile_label: "帮助文档",
  scenes_Application_PublishAppVersion_apiFile_label: "API文档",
  scenes_Application_PublishAppVersion_testReportFile_label: "测试报告",
  scenes_Application_PublishAppVersion_selectFile_label: "选择文件",
  scenes_Application_PublishAppVersion_privilegeAllocation_label: "权限配置",
  scenes_Application_PublishAppVersion_submit_label: "提交",
  scenes_Application_PublishAppVersion_cancel_label: "返回",

  //helpTip
  scenes_Application_PublishAppVersion_applicationName_helpTip: "应用名称",
  scenes_Application_PublishAppVersion_version_helpTip: "选择需要发布的应用版本",
  scenes_Application_PublishAppVersion_sourceType_helpTip: "程序语言格式为gitlab，github等",
  scenes_Application_PublishAppVersion_description_helpTip: "输入该版本的详细信息",
  scenes_Application_PublishAppVersion_screenHeight_helpTip: "屏显高度为应用程序显示的高度，默认为320",
  scenes_Application_PublishAppVersion_screenshots_helpTip: "上传截图",
  scenes_Application_PublishAppVersion_applicationFile_helpTip: "发布应用程序文件",
  scenes_Application_PublishAppVersion_helpFile_helpTip: "帮助文档",
  scenes_Application_PublishAppVersion_apiFile_helpTip: "API文档",
  scenes_Application_PublishAppVersion_testReportFile_helpTip: "测试报告",
  scenes_Application_PublishAppVersion_selectFile_helpTip: "选择文件",
  scenes_Application_PublishAppVersion_privilegeAllocation_helpTip: "权限配置是开发者设置的唯一字符串，用于标识应用者的特定权限，具体权限控制逻辑由开发者在代码中定义",
  //placeholder
  scenes_Application_PublishAppVersion_applicationVersion_placeholder: "请输入应用版本",
  scenes_Application_PublishAppVersion_SourceType_placeholder: "请选择程序语言格式",
  scenes_Application_PublishAppVersion_description_placeholder: "请输入版本详情",
  scenes_Application_PublishAppVersion_screenHeight_placeholder: "请输入屏显高度",

  //message
  scenes_Application_PublishAppVersion_required_message: "必填",
  scenes_Application_PublishAppVersion_checkVersion_message: "该版本号已存在，请重新输入！",
  scenes_Application_PublishAppVersion_promptVersion_message: "请输入应用版本",
  scenes_Application_PublishAppVersion_promptSourceType_message: "请选择程序语言格式",
  scenes_Application_PublishAppVersion_promptVersionDescription_message: "请输入版本详情",
  scenes_Application_PublishAppVersion_promptScreenHeight_message: "请输入屏显高度",
  scenes_Application_PublishAppVersion_applicationFile_message: "请上传应用程序",
  scenes_Application_PublishAppVersion_lessThan100MB_message: "不可大于100MB",

  //  modal
  scenes_Application_PublishAppVersion_modal_submit_content: "确认发布并提交审核吗？",
  scenes_Application_PublishAppVersion_modal_return_content: "有新增内容，是否返回？",
  scenes_Application_PublishAppVersion_modal_save_label: "暂时保存",
  scenes_Application_PublishAppVersion_modal_submit_label: "发布提交",
  scenes_Application_PublishAppVersion_modal_success_title: "成功",
  scenes_Application_PublishAppVersion_modal_fail_title: "失败",
  scenes_Application_PublishAppVersion_modal_submitSuccess_content: "版本发布成功!",
  scenes_Application_PublishAppVersion_modal_submitFail_content: "版本发布失败!",
  scenes_Application_PublishAppVersion_modal_uploadFileSuccess_content: "应用程序上传成功",
  scenes_Application_PublishAppVersion_modal_uploadFileFail_content: "版本发布成功，但应用程序上传失败！",
  scenes_Application_PublishAppVersion_modal_OK_label: "确定",
  scenes_Application_PublishAppVersion_modal_cancel_label: "返回",
  scenes_Application_PublishAppVersion_modal_yes_label: "是",
  scenes_Application_PublishAppVersion_modal_no_label: "否",
  /**** PUBLISH APP VERSION END ****/

  /**** APP MAIN EDIT ****/
  //label
  scenes_Application_AppMainEdit_applicationCode_label: "应用编码:",
  scenes_Application_AppMainEdit_applicationType_label: "应用类型:",
  scenes_Application_AppMainEdit_applicationInfo1_label: "该应用由",
  scenes_Application_AppMainEdit_applicationInfo2_label: "于",
  scenes_Application_AppMainEdit_applicationInfo3_label: "发布",
  scenes_Application_AppMainEdit_returnAppMarket_label: "返回应用市场",
  scenes_Application_AppMainEdit_returnAppManagement_label: "返回个人应用管理",
  scenes_Application_AppMainEdit_audit_label: "提交审核",
  scenes_Application_AppMainEdit_onlineApplication_label: "上线应用",
  scenes_Application_AppMainEdit_offlineApplication_label: "下线应用",
  scenes_Application_AppMainEdit_closeApplication_label: "封存应用",
  scenes_Application_AppMainEdit_applicationCategory_label: "应用类别:",
  scenes_Application_AppMainEdit_applicationDescription_label: "应用简介:",
  scenes_Application_AppMainEdit_applicationLogo_label: "应用图标",
  scenes_Application_AppMainEdit_uploadLogo_label: "上传图标",
  scenes_Application_AppMainEdit_applicationName_label: "应用名称",
  scenes_Application_AppMainEdit_applicationModify_label: "修改",
  scenes_Application_AppMainEdit_applicationSubmit_label: "提交",
  scenes_Application_AppMainEdit_applicationCancel_label: "取消",
  scenes_Application_AppMainEdit_versionedList_label: "版本列表",
  scenes_Application_AppMainEdit_publishNewVersionedApp_label: "发布新版本",
  scenes_Application_AppMainEdit_plans_label: "计划选项",
  scenes_Application_AppMainEdit_createPlan_label: "新建计划",
  scenes_Application_AppMainEdit_modifyPlan_label: "修改计划",
  scenes_Application_AppMainEdit_deletePlan_label: "删除计划",

  //placeholder
  scenes_Application_AppMainEdit_applicationName_placeholder: "请输入应用名称",
  scenes_Application_AppMainEdit_applicationCategory_placeholder: "请输入应用类别",
  scenes_Application_AppMainEdit_applicationDescription_placeholder: "请输入应用简介",

  //message
  scenes_Application_AppMainEdit_applicationName_message: "请输入应用名称",
  scenes_Application_AppMainEdit_applicationCategory_message: "请输入应用类别",
  scenes_Application_AppMainEdit_applicationDescription_message: "请输入应用简介",
  scenes_Application_AppMainEdit_deploy_message: "需要上线后才可执行部署上云",

  // modal
  scenes_Application_AppMainEdit_modal_success_title: "成功",
  scenes_Application_AppMainEdit_modal_fail_title: "失败",
  scenes_Application_AppMainEdit_modal_submitAudit_content: "是否提交审核？",
  scenes_Application_AppMainEdit_modal_updateSuccess_content: "保存更新成功，是否提交审核？",
  scenes_Application_AppMainEdit_modal_updateFail_content: "保存更新失败!",
  scenes_Application_AppMainEdit_modal_updateStatusSuccess_content1: "提交审核成功！",
  scenes_Application_AppMainEdit_modal_updateStatusFail_content1: "提交审核失败!",
  scenes_Application_AppMainEdit_modal_updateStatusSuccess_content2: "版本下线线成功！",
  scenes_Application_AppMainEdit_modal_updateStatusFail_content2: "版本下线失败!",
  scenes_Application_AppMainEdit_modal_updateStatusSuccess_content3: "版本上线成功！",
  scenes_Application_AppMainEdit_modal_updateStatusFail_content3: "版本上线失败!",
  scenes_Application_AppMainEdit_modal_updateStatusSuccess_content5: "版本封存成功！",
  scenes_Application_AppMainEdit_modal_updateStatusFail_content5: "版本封存失败!",
  scenes_Application_AppMainEdit_modal_deletePlanSuccess_content: "删除应用计划成功",
  scenes_Application_AppMainEdit_modal_deletePlanFail_content: "删除应用计划失败",
  scenes_Application_AppMainEdit_modal_OK_label: "确定",
  scenes_Application_AppMainEdit_modal_return_label: "返回",
  scenes_Application_AppMainEdit_modal_yes_label: "是",
  scenes_Application_AppMainEdit_modal_no_label: "否",

  //confirm modal
  scenes_Application_AppMainEdit_modal_confirm_title: "确认",
  scenes_Application_AppMainEdit_modal_online_content: "确认上线该应用吗？",
  scenes_Application_AppMainEdit_modal_offline_content: "确认下线该应用吗？",
  scenes_Application_AppMainEdit_modal_close_content: "确认封存该应用吗？",
  scenes_Application_AppMainEdit_modal_deletePlan_content: "确认删除该计划吗？",
  scenes_Application_AppMainEdit_modal_confirm_label: "确认",
  scenes_Application_AppMainEdit_modal_cancel_label: "取消",

  /**** APP MAIN EDIT END ****/

  /**** APP MAIN VIEW ****/
  //label
  scenes_Application_AppMainView_applicationCode_label: "应用编码：",
  scenes_Application_AppMainView_applicationType_label: "应用类型:",
  scenes_Application_AppMainView_applicationInfo1_label: "该应用由",
  scenes_Application_AppMainView_applicationInfo2_label: "于",
  scenes_Application_AppMainView_applicationInfo3_label: "发布",
  scenes_Application_AppMainView_return_label: "返回",
  scenes_Application_AppMainView_applicationCategory_label: "应用类别:",
  scenes_Application_AppMainView_applicationDescription_label: "应用简介:",
  scenes_Application_AppMainView_versionedList_label: "版本列表",
  scenes_Application_AppMainView_plans_label: "计划选项",
  /**** APP MAIN VIEW END ****/

  /**** APP VERSION EDIT ****/
  //table
  scenes_Application_AppVersionEdit_privilegeCode_title: "权限编码",
  scenes_Application_AppVersionEdit_privilegeName_title: "权限名称",
  scenes_Application_AppVersionEdit_privilegeDescription_title: "权限说明",
  scenes_Application_AppVersionEdit_operation_title: "操作",

  //popconfirm
  scenes_Application_AppVersionEdit_popconfirmDelete_title: "确认删除吗？",
  scenes_Application_AppVersionEdit_popconfirmOK_title: "确认",
  scenes_Application_AppVersionEdit_popconfirmCancel_title: "取消",

  //label
  scenes_Application_AppVersionEdit_version_label: "应用版本",
  scenes_Application_AppVersionEdit_applicationType_label: "应用类型",
  scenes_Application_AppVersionEdit_versionInfo1_label: "该版本由",
  scenes_Application_AppVersionEdit_versionInfo2_label: "于",
  scenes_Application_AppVersionEdit_versionInfo3_label: "更新",
  scenes_Application_AppVersionEdit_description_label: "版本详情",
  scenes_Application_AppVersionEdit_screenshot_label: "应用预览(屏显高度{num}px)",
  scenes_Application_AppVersionEdit_screenHeight_label: "屏显高度",
  scenes_Application_AppVersionEdit_screenshots_label: "上传截图",
  scenes_Application_AppVersionEdit_sourceType_label: "程序语言格式",
  scenes_Application_AppVersionEdit_deploymentFile_label: "应用程序",
  scenes_Application_AppVersionEdit_helpFile_label: "帮助文档",
  scenes_Application_AppVersionEdit_apiFile_label: "API文档",
  scenes_Application_AppVersionEdit_testReportFile_label: "测试报告",
  scenes_Application_AppVersionEdit_replaceFile_label: "替换文件",
  scenes_Application_AppVersionEdit_selectFile_label: "选择文件",
  scenes_Application_AppVersionEdit_privilegeAllocation_label: "权限配置",
  scenes_Application_AppVersionEdit_download_label: "下载",
  scenes_Application_AppVersionEdit_notUpload_label: "未上传",
  scenes_Application_AppVersionEdit_uploaded_label: "已上传",
  scenes_Application_AppVersionEdit_audit_label: "提交审核",
  scenes_Application_AppVersionEdit_online_label: "版本上线",
  scenes_Application_AppVersionEdit_disabled_label: "版本封存",
  scenes_Application_AppVersionEdit_modify_label: "修改",
  scenes_Application_AppVersionEdit_save_label: "保存",
  scenes_Application_AppVersionEdit_cancel_label: "取消",
  scenes_Application_AppVersionEdit_return_label: "返回",

  //helpTip
  scenes_Application_AppVersionEdit_privilegeAllocation_helpTip: "权限配置",

  //placeholder
  scenes_Application_AppVersionEdit_description_placeholder: "请输入版本详情",
  scenes_Application_AppVersionEdit_screenHeight_placeholder: "请输入屏显高度",
  scenes_Application_AppVersionEdit_sourceType_placeholder: "请选择程序语言格式",

  //message
  scenes_Application_AppVersionEdit_required_message: "必填",
  scenes_Application_AppVersionEdit_sourceType_message: "请选择程序语言格式",
  scenes_Application_AppVersionEdit_description_message: "请输入版本详情",
  scenes_Application_AppVersionEdit_screenHeight_message: "请输入屏显高度",
  scenes_Application_AppVersionEdit_lessThan100MB_message: "不可大于100MB",
  scenes_Application_AppVersionEdit_firstPage_message: "已经是第一张",
  scenes_Application_AppVersionEdit_lastPage_message: "已经是最后一张",

  //modal
  scenes_Application_AppVersionEdit_modal_audit_content: "确认提交审核吗？",
  scenes_Application_AppVersionEdit_modal_online_content: "确认上线该版本吗？",
  scenes_Application_AppVersionEdit_modal_disabled_content: "确认封存该版本吗？",
  scenes_Application_AppVersionEdit_modal_confirm_label: "确认",
  scenes_Application_AppVersionEdit_modal_cancel_label: "取消",

  scenes_Application_AppVersionEdit_modal_success_title: "成功",
  scenes_Application_AppVersionEdit_modal_fail_title: "失败",
  scenes_Application_AppVersionEdit_modal_updateSuccess_content: "保存更新成功，是否提交审核？",
  scenes_Application_AppVersionEdit_modal_updateFail_content: "保存更新失败!",
  scenes_Application_AppVersionEdit_modal_updateStatusSuccess_content1: "提交审核成功！",
  scenes_Application_AppVersionEdit_modal_updateStatusFail_content1: "提交审核失败!",
  scenes_Application_AppVersionEdit_modal_updateStatusSuccess_content3: "版本上线成功！",
  scenes_Application_AppVersionEdit_modal_updateStatusFail_content3: "版本上线失败!",
  scenes_Application_AppVersionEdit_modal_updateStatusSuccess_content5: "版本封存成功！",
  scenes_Application_AppVersionEdit_modal_updateStatusFail_content5: "版本封存失败!",
  scenes_Application_AppVersionEdit_modal_OK_label: "确定",
  scenes_Application_AppVersionEdit_modal_return_label: "返回",
  scenes_Application_AppVersionEdit_modal_yes_label: "是",
  scenes_Application_AppVersionEdit_modal_no_label: "否",
  /**** APP VERSION EDIT END ****/

  /**** APP VERSION VIEW ****/
  //table
  scenes_Application_AppVersionView_privilegeCode_title: "权限编码",
  scenes_Application_AppVersionView_privilegeName_title: "权限名称",
  scenes_Application_AppVersionView_privilegeDescription_title: "权限说明",
  scenes_Application_AppVersionView_operation_title: "操作",

  //label
  scenes_Application_AppVersionView_version_label: "应用版本",
  scenes_Application_AppVersionView_applicationType_label: "应用类型",
  scenes_Application_AppVersionView_versionInfo1_label: "该版本由",
  scenes_Application_AppVersionView_versionInfo2_label: "于",
  scenes_Application_AppVersionView_versionInfo3_label: "更新",
  scenes_Application_AppVersionView_description_label: "版本详情",
  scenes_Application_AppVersionView_screenshot_label: "应用预览(屏显高度{num}px)",
  scenes_Application_AppVersionView_screenHeight_label: "屏显高度",
  scenes_Application_AppVersionView_screenshots_label: "上传截图",
  scenes_Application_AppVersionView_sourceType_label: "程序语言格式",
  scenes_Application_AppVersionView_deploymentFile_label: "应用程序",
  scenes_Application_AppVersionView_helpFile_label: "帮助文档",
  scenes_Application_AppVersionView_apiFile_label: "API文档",
  scenes_Application_AppVersionView_testReportFile_label: "测试报告",
  scenes_Application_AppVersionView_replaceFile_label: "替换文件",
  scenes_Application_AppVersionView_selectFile_label: "选择文件",
  scenes_Application_AppVersionView_privilegeAllocation_label: "权限配置",
  scenes_Application_AppVersionView_download_label: "下载",
  scenes_Application_AppVersionView_notUpload_label: "未上传",
  scenes_Application_AppVersionView_uploaded_label: "已上传",
  scenes_Application_AppVersionView_return_label: "返回应用主页",

  //message
  scenes_Application_AppVersionView_firstPage_message: "已经是第一张",
  scenes_Application_AppVersionView_lastPage_message: "已经是最后一张",


  /**** APP VERSION VIEW END ****/

  /**** RESOURCE ADD ****/
  //table
  scenes_Application_ResourceAdd_period_name_title: "周期名称",
  scenes_Application_ResourceAdd_period_number_title: "周期数量",
  scenes_Application_ResourceAdd_period_unit_title: "周期单位",
  scenes_Application_ResourceAdd_period_limit_title: "限购数量",
  scenes_Application_ResourceAdd_period_discount_title: "折扣",
  scenes_Application_ResourceAdd_period_remark_title: "备注",
  scenes_Application_ResourceAdd_operation_title: "操作",
  scenes_Application_ResourceAdd_period_unit_month: "月",
  scenes_Application_ResourceAdd_period_unit_quarter: "季",
  scenes_Application_ResourceAdd_period_unit_year: "年",

  //confirm
  scenes_Application_ResourceAdd_confirm_return_title: "确认",
  scenes_Application_ResourceAdd_confirm_return_content: "当前内容有变化，确认放弃吗？",
  scenes_Application_ResourceAdd_confirm_delete_title: "确认删除吗？",
  scenes_Application_ResourceAdd_confirm_OK_title: "确认",
  scenes_Application_ResourceAdd_confirm_cancel_title: "取消",

  //label
  scenes_Application_ResourceAdd_name_label: "资源名称",
  scenes_Application_ResourceAdd_code_label: "资源编码",
  scenes_Application_ResourceAdd_description_label: "资源说明",
  scenes_Application_ResourceAdd_price_label: "资源单价(元/月)",
  scenes_Application_ResourceAdd_cpuCores_label: "推荐使用CPU核数(核)",
  scenes_Application_ResourceAdd_memoryQuota_label: "推荐使用内存大小(MB)",
  scenes_Application_ResourceAdd_diskQuota_label: "推荐使用储存空间(MB)",
  scenes_Application_ResourceAdd_concurrentUser_label: "推荐最大并发用户数(位)",
  scenes_Application_ResourceAdd_permanentPrice_label: "是否配置永久价格(元)",
  scenes_Application_ResourceAdd_period_label: "周期规则",
  scenes_Application_ResourceAdd_submit_label: "提交",
  scenes_Application_ResourceAdd_cancel_label: "返回",

  //helpTip
  scenes_Application_ResourceAdd_name_helpTip: "显示在购买应用选择位置，由用户进行选择",
  scenes_Application_ResourceAdd_code_helpTip: "必须唯一，用于系统类应用绑定资源",
  scenes_Application_ResourceAdd_price_helpTip: "资源的购买单价，结合周期规则计算总价格",
  scenes_Application_ResourceAdd_cpuCores_helpTip: "限制该资源所使用CPU核数，不能少于0.5核，默认值为1核",
  scenes_Application_ResourceAdd_memoryQuota_helpTip: "限制该资源所使用内存，不能低于1000MB，默认值为1024MB",
  scenes_Application_ResourceAdd_diskQuota_helpTip: "限制储存空间大小，默认值为512MB",
  scenes_Application_ResourceAdd_concurrentUser_helpTip: "限制该资源并发用户数量，默认不限制",
  scenes_Application_ResourceAdd_permanentPrice_helpTip: "选配是否永久版卖出，如选中是必须输入价格",

  //placeholder
  scenes_Application_ResourceAdd_name_placeholder: "请输入资源名称",
  scenes_Application_ResourceAdd_code_placeholder: "请输入资源编码",
  scenes_Application_ResourceAdd_price_placeholder: "请输入资源价格",
  scenes_Application_ResourceAdd_description_placeholder: "请输入资源说明",
  scenes_Application_ResourceAdd_cpuCores_placeholder: "请输入CPU核数",
  scenes_Application_ResourceAdd_memoryQuota_placeholder: "请输入内存大小",
  scenes_Application_ResourceAdd_diskQuota_placeholder: "请输入储存空间",
  scenes_Application_ResourceAdd_concurrentUser_placeholder: "请输入最大并发用户数",
  scenes_Application_ResourceAdd_permanentPrice_placeholder: "请输入永久价格",

  //message
  scenes_Application_ResourceAdd_notFound_message: "未找到应用信息，无法创建资源配置!",
  scenes_Application_ResourceAdd_sameName_message: "资源名称已存在，请重新输入!",
  scenes_Application_ResourceAdd_sameCode_message: "资源编码已存在，请重新输入!",
  scenes_Application_ResourceAdd_required_message: "必填",
  scenes_Application_ResourceAdd_promptName_message: "请输入资源名称",
  scenes_Application_ResourceAdd_promptCode_message: "请输入资源编码",
  scenes_Application_ResourceAdd_promptPrice_message: "请输入资源价格",
  scenes_Application_ResourceAdd_promptDescription_message: "请输入资源说明",
  scenes_Application_ResourceAdd_promptCpuCores_message: "请输入CPU核数",
  scenes_Application_ResourceAdd_promptMemoryQuota_message: "请输入内存大小",
  scenes_Application_ResourceAdd_promptDiskQuota_message: "请输入储存空间",
  scenes_Application_ResourceAdd_promptConcurrentUser_message: "请输入最大并发用户数",
  scenes_Application_ResourceAdd_promptPermanentPrice_message: "请输入永久价格",

  //  modal
  scenes_Application_ResourceAdd_modal_success_title: "成功",
  scenes_Application_ResourceAdd_modal_fail_title: "失败",
  scenes_Application_ResourceAdd_modal_submitSuccess_content: "新建资源配置成功!",
  scenes_Application_ResourceAdd_modal_submitFail_content: "新建资源配置失败!",
  scenes_Application_ResourceAdd_modal_OK_label: "确定",
  scenes_Application_ResourceAdd_modal_cancel_label: "返回",
  scenes_Application_ResourceAdd_modal_yes_label: "是",
  scenes_Application_ResourceAdd_modal_no_label: "否",
  /**** RESOURCE ADD END ****/

  /**** RESOURCE EDIT ****/
  //table
  scenes_Application_ResourceEdit_periodMinMonths_title: "最小月数",
  scenes_Application_ResourceEdit_periodMaxMonths_title: "最大月数",
  scenes_Application_ResourceEdit_periodDiscount_title: "折扣",
  scenes_Application_ResourceEdit_periodDescription_title: "说明",
  scenes_Application_ResourceEdit_userMinUsers_title: "最小用户数",
  scenes_Application_ResourceEdit_userMaxUsers_title: "最大用户数",
  scenes_Application_ResourceEdit_userDiscount_title: "折扣",
  scenes_Application_ResourceEdit_userDescription_title: "说明",
  scenes_Application_ResourceEdit_operation_title: "操作",

  //popconfirm
  scenes_Application_ResourceEdit_popconfirm_delete_title: "确认删除吗？",
  scenes_Application_ResourceEdit_popconfirm_OK_label: "确认",
  scenes_Application_ResourceEdit_popconfirm_cancel_label: "取消",

  //label
  scenes_Application_ResourceEdit_name_label: "资源名称",
  scenes_Application_ResourceEdit_price_label: "资源价格",
  scenes_Application_ResourceEdit_unitRMB_label: "(元)",
  scenes_Application_ResourceEdit_unitMonths_label: "(元/月)",
  scenes_Application_ResourceEdit_memoryQuota_label: "限制使用内存大小(GB)",
  scenes_Application_ResourceEdit_diskQuota_label: "限制使用储存空间(MB)",
  scenes_Application_ResourceEdit_description_label: "计划说明",
  scenes_Application_ResourceEdit_isPeriod_label: "按部署时长收费",
  scenes_Application_ResourceEdit_period_label: "周期时长折扣",
  scenes_Application_ResourceEdit_isUserConcurrent_label: "按并发用户数收费",
  scenes_Application_ResourceEdit_userConcurrentCost_label: "并发用户数价格(元/人)",
  scenes_Application_ResourceEdit_userConcurrent_label: "并发用户数折扣",
  scenes_Application_ResourceEdit_submit_label: "提交",
  scenes_Application_ResourceEdit_cancel_label: "返回",

  //placeholder
  scenes_Application_ResourceEdit_name_placeholder: "请输入资源名称",
  scenes_Application_ResourceEdit_price_placeholder: "请输入资源价格",
  scenes_Application_ResourceEdit_memoryQuota_placeholder: "请输入内存大小",
  scenes_Application_ResourceEdit_diskQuota_placeholder: "请输入储存空间",
  scenes_Application_ResourceEdit_description_placeholder: "请输入计划说明",
  scenes_Application_ResourceEdit_userConcurrentCost_placeholder: "请输入并发用户数价格",

  //message
  scenes_Application_ResourceEdit_sameName_message: "资源名称已存在，请重新输入!",
  scenes_Application_ResourceEdit_required_message: "必填",
  scenes_Application_ResourceEdit_promptName_message: "请输入资源名称",
  scenes_Application_ResourceEdit_promptCost_message: "请输入资源价格",
  scenes_Application_ResourceEdit_promptMemoryQuota_message: "请输入内存大小",
  scenes_Application_ResourceEdit_promptDiskQuota_message: "请输入储存空间",
  scenes_Application_ResourceEdit_promptDescription_message: "请输入计划说明",
  scenes_Application_ResourceEdit_promptUserConcurrentCost_message: "请输入并发用户数价格",

  //  modal
  scenes_Application_ResourceEdit_modal_return_title: "确认",
  scenes_Application_ResourceEdit_modal_return_content: "当前内容有变化，确认放弃吗？",
  scenes_Application_ResourceEdit_modal_return_OK_label: "确认",
  scenes_Application_ResourceEdit_modal_return_cancel_label: "取消",
  scenes_Application_ResourceEdit_modal_success_title: "成功",
  scenes_Application_ResourceEdit_modal_fail_title: "失败",
  scenes_Application_ResourceEdit_modal_submitSuccess_content: "修改应用计划成功!",
  scenes_Application_ResourceEdit_modal_submitFail_content: "修改应用计划失败!",
  scenes_Application_ResourceEdit_modal_OK_label: "确定",
  scenes_Application_ResourceEdit_modal_cancel_label: "返回",
  scenes_Application_ResourceEdit_modal_yes_label: "是",
  scenes_Application_ResourceEdit_modal_no_label: "否",
  /**** RESOURCE EDIT END ****/

  /**** APPLICATION SERVICE END ****/

  /**** ALGORITHM SERVICE START ****/

  /**** ALGORITHM CATEGORY ****/
  //label
  scenes_Algorithm_AlgorithmCategory_add_label: "添加",
  scenes_Algorithm_AlgorithmCategory_save_label: "保存",
  scenes_Algorithm_AlgorithmCategory_delete_label: "删除",
  scenes_Algorithm_AlgorithmCategory_reset_label: "重置",
  scenes_Algorithm_AlgorithmCategory_logo_label: "类别图标",
  scenes_Algorithm_AlgorithmCategory_name_label: "类别名称",
  scenes_Algorithm_AlgorithmCategory_remark_label: "备注说明",
  scenes_Algorithm_AlgorithmCategory_new_label: "新类别",

  // popconfirm
  scenes_Algorithm_AlgorithmCategory_popConfirm_delete_title: "确认删除选中节点吗？",
  scenes_Algorithm_AlgorithmCategory_popConfirm_reset_title: "确认恢复初始数据吗？",
  scenes_Algorithm_AlgorithmCategory_popConfirm_confirm_label: "确认",
  scenes_Algorithm_AlgorithmCategory_popConfirm_cancel_label: "取消",

  // modal
  scenes_Algorithm_AlgorithmCategory_modal_success_title: "成功",
  scenes_Algorithm_AlgorithmCategory_modal_fail_title: "失败",
  scenes_Algorithm_AlgorithmCategory_modal_saveSuccess_content: "保存成功！",
  scenes_Algorithm_AlgorithmCategory_modal_saveFail_content: "保存失败！",
  scenes_Algorithm_AlgorithmCategory_modal_deleteSuccess_content: "删除成功！",
  scenes_Algorithm_AlgorithmCategory_modal_deleteFail_content: "删除失败！",
  scenes_Algorithm_AlgorithmCategory_modal_OK_label: "确定",
  scenes_Algorithm_AlgorithmCategory_modal_cancel_label: "取消",
  /**** ALGORITHM CATEGORY END ****/

  /**** ALGORITHM LIST ****/
  //label
  scenes_Algorithm_AlgorithmList_name_label: "算法名称",
  scenes_Algorithm_AlgorithmList_createDate_label: "上传时间",
  scenes_Algorithm_AlgorithmList_status_label: "算法状态",
  scenes_Algorithm_AlgorithmList_add_label: "添加",
  scenes_Algorithm_AlgorithmList_modify_label: "修改",
  scenes_Algorithm_AlgorithmList_delete_label: "删除",
  scenes_Algorithm_AlgorithmList_detail_label: "明细",

  //placeholder
  scenes_Algorithm_AlgorithmList_name_placeholder: "过滤算法名称...",

  // popconfirm
  scenes_Algorithm_AlgorithmList_popConfirm_delete_title: "确认删除吗？",
  scenes_Algorithm_AlgorithmList_popConfirm_confirm_label: "确认",
  scenes_Algorithm_AlgorithmList_popConfirm_cancel_label: "取消",

  // modal
  scenes_Algorithm_AlgorithmList_modal_success_title: "成功",
  scenes_Algorithm_AlgorithmList_modal_fail_title: "失败",
  scenes_Algorithm_AlgorithmList_modal_deleteSuccess_content: "删除成功！",
  scenes_Algorithm_AlgorithmList_modal_deleteFail_content: "删除失败！",
  scenes_Algorithm_AlgorithmList_modal_offlineSuccess_content: "下线成功！",
  scenes_Algorithm_AlgorithmList_modal_offlineFail_content: "下线失败！",
  scenes_Algorithm_AlgorithmList_modal_OK_label: "确定",
  scenes_Algorithm_AlgorithmList_modal_cancel_label: "取消",
  /**** ALGORITHM LIST END ****/

  /**** ALGORITHM ADD ****/
  // table
  scenes_Algorithm_AlgorithmAdd_parameterName_title: "参数名称",
  scenes_Algorithm_AlgorithmAdd_parameterType_title: "参数类型",
  scenes_Algorithm_AlgorithmAdd_parameterDefaultValue_title: "默认值",
  scenes_Algorithm_AlgorithmAdd_parameterScope_title: "参数范围",
  scenes_Algorithm_AlgorithmAdd_parameterDescription_title: "参数说明",
  scenes_Algorithm_AlgorithmAdd_operation_title: "操作",
  scenes_Algorithm_AlgorithmAdd_parameterAdd_label: "添加参数",
  scenes_Algorithm_AlgorithmAdd_confirmDelete_title: "确认删除吗？",
  scenes_Algorithm_AlgorithmAdd_confirm_label: "确认",
  scenes_Algorithm_AlgorithmAdd_cancel_label: "取消",
  scenes_Algorithm_AlgorithmAdd_delete_label: "删除",

  // label
  scenes_Algorithm_AlgorithmAdd_description_label: "算法描述",
  scenes_Algorithm_AlgorithmAdd_algorithmParameter_label: "算法参数",
  scenes_Algorithm_AlgorithmAdd_name_label: "算法名称",
  scenes_Algorithm_AlgorithmAdd_category_label: "算法类别",
  scenes_Algorithm_AlgorithmAdd_type_label: "开发语言",
  scenes_Algorithm_AlgorithmAdd_file_label: "算法文件",
  scenes_Algorithm_AlgorithmAdd_selectFile_label: "选择文件",
  scenes_Algorithm_AlgorithmAdd_upload_label: "上传",
  scenes_Algorithm_AlgorithmAdd_uploaded_label: "已上传",
  scenes_Algorithm_AlgorithmAdd_uploading_label: "上传中",
  scenes_Algorithm_AlgorithmAdd_submit_label: "保存",
  scenes_Algorithm_AlgorithmAdd_return_label: "返回",
  scenes_Algorithm_AlgorithmAdd_card_label: "算法添加",

  // helpTip
  scenes_Algorithm_AlgorithmAdd_description_helpTip: "对算法作用等进行说明",
  scenes_Algorithm_AlgorithmAdd_algorithmParameter_helpTip: "算法参数需要填写参数名称，参数类型等",
  scenes_Algorithm_AlgorithmAdd_name_helpTip: "填写的算法名称必须是唯一的",
  scenes_Algorithm_AlgorithmAdd_category_helpTip: "请从以下的类别中选择算法类别",
  scenes_Algorithm_AlgorithmAdd_type_helpTip: "选择算法的开发语言",
  scenes_Algorithm_AlgorithmAdd_file_helpTip: "上传算法文件，大小不超过100M",


  // placeholder
  scenes_Algorithm_AlgorithmAdd_description_placeholder: "请输入算法描述",
  scenes_Algorithm_AlgorithmAdd_name_placeholder: "请输入算法名称",
  scenes_Algorithm_AlgorithmAdd_category_placeholder: "请选择算法类别",
  scenes_Algorithm_AlgorithmAdd_type_placeholder: "请选择开发语言",

  // message
  scenes_Algorithm_AlgorithmAdd_description_message: "请输入算法描述",
  scenes_Algorithm_AlgorithmAdd_name_message: "请输入算法名称，且必须唯一",
  scenes_Algorithm_AlgorithmAdd_sameName_message: "该算法名称已存在，请重新输入",
  scenes_Algorithm_AlgorithmAdd_category_message: "请选择算法类别",
  scenes_Algorithm_AlgorithmAdd_type_message: "请选择开发语言",
  scenes_Algorithm_AlgorithmAdd_upload_file_message: "请上传文件",
  scenes_Algorithm_AlgorithmAdd_upload_algorithmFile_message: "请上传算法文件",
  scenes_Algorithm_AlgorithmAdd_required_message: "必填",
  scenes_Algorithm_AlgorithmAdd_fileThan_message: "文件大小不可大于100MB！",
  scenes_Algorithm_AlgorithmAdd_upload_success_message: "上传成功！",
  scenes_Algorithm_AlgorithmAdd_upload_fail_message: "上传失败！",

  // modal
  scenes_Algorithm_AlgorithmAdd_modal_success_title: "成功",
  scenes_Algorithm_AlgorithmAdd_modal_fail_title: "失败",
  scenes_Algorithm_AlgorithmAdd_modal_submit_success_content: "保存成功，是否提交管理员审核？",
  scenes_Algorithm_AlgorithmAdd_modal_submit_fail_content: "保存失败！",
  scenes_Algorithm_AlgorithmAdd_modal_audit_success_content: "提交审核成功，请返回算法列表主页。",
  scenes_Algorithm_AlgorithmAdd_modal_audit_fail_content: "提交审核失败！",
  scenes_Algorithm_AlgorithmAdd_modal_OK_label: "确定",
  scenes_Algorithm_AlgorithmAdd_modal_cancel_label: "取消",
  scenes_Algorithm_AlgorithmAdd_modal_yes_label: "是",
  scenes_Algorithm_AlgorithmAdd_modal_no_label: "否",
  scenes_Algorithm_AlgorithmAdd_modal_return_title: "确认",
  scenes_Algorithm_AlgorithmAdd_modal_return_content: "您有新增内容，是否返回前一页",
  scenes_Algorithm_AlgorithmAdd_modal_return_OK_label: "确定",
  scenes_Algorithm_AlgorithmAdd_modal_return_cancel_label: "取消",
  /**** ALGORITHM ADD END ****/

  /**** ALGORITHM EDIT ****/
  // table
  scenes_Algorithm_AlgorithmEdit_parameterName_title: "参数名称",
  scenes_Algorithm_AlgorithmEdit_parameterType_title: "参数类型",
  scenes_Algorithm_AlgorithmEdit_defaultValue_title: "默认值",
  scenes_Algorithm_AlgorithmEdit_parameterScope_title: "参数范围",
  scenes_Algorithm_AlgorithmEdit_parameterDescription_title: "参数说明",
  scenes_Algorithm_AlgorithmEdit_operation_title: "操作",
  scenes_Algorithm_AlgorithmEdit_add_label: "添加参数",
  scenes_Algorithm_AlgorithmEdit_algorithmParameter_label: "算法参数：",
  scenes_Algorithm_AlgorithmEdit_confirmDelete_title: "确认删除吗？",
  scenes_Algorithm_AlgorithmEdit_confirm_title: "确认",
  scenes_Algorithm_AlgorithmEdit_cancel_title: "取消",
  scenes_Algorithm_AlgorithmEdit_delete_title: "删除",

  // label
  scenes_Algorithm_AlgorithmEdit_description_label: "算法描述",
  scenes_Algorithm_AlgorithmEdit_name_label: "算法名称",
  scenes_Algorithm_AlgorithmEdit_category_label: "算法类别",
  scenes_Algorithm_AlgorithmEdit_type_label: "开发语言",
  scenes_Algorithm_AlgorithmEdit_file_label: "算法文件",
  scenes_Algorithm_AlgorithmEdit_selectFile_label: "选择文件",
  scenes_Algorithm_AlgorithmEdit_changeFile_label: "替换文件",
  scenes_Algorithm_AlgorithmEdit_upload_label: "上传",
  scenes_Algorithm_AlgorithmEdit_uploaded_label: "已上传",
  scenes_Algorithm_AlgorithmEdit_uploading_label: "上传中",
  scenes_Algorithm_AlgorithmEdit_audit_label: "提交审核",
  scenes_Algorithm_AlgorithmEdit_submit_label: "保存",
  scenes_Algorithm_AlgorithmEdit_return_label: "返回",
  scenes_Algorithm_AlgorithmEdit_card_label: "算法修改",

  // placeholder
  scenes_Algorithm_AlgorithmEdit_description_placeholder: "请输入算法描述",
  scenes_Algorithm_AlgorithmEdit_name_placeholder: "请输入算法名称",
  scenes_Algorithm_AlgorithmEdit_category_placeholder: "请选择算法类别",
  scenes_Algorithm_AlgorithmEdit_type_placeholder: "请选择开发语言",

  // message
  scenes_Algorithm_AlgorithmEdit_name_message: "请输入算法名称，且必须唯一",
  scenes_Algorithm_AlgorithmEdit_sameName_message: "该算法名称已存在，请重新输入",
  scenes_Algorithm_AlgorithmEdit_category_message: "请选择算法类别",
  scenes_Algorithm_AlgorithmEdit_type_message: "请选择开发语言",
  scenes_Algorithm_AlgorithmEdit_uploadFile_message: "请上传文件",
  scenes_Algorithm_AlgorithmEdit_required_message: "必填",
  scenes_Algorithm_AlgorithmEdit_fileThan_message: "文件大小不可大于100MB！",
  scenes_Algorithm_AlgorithmEdit_uploadSuccess_message: "上传成功！",
  scenes_Algorithm_AlgorithmEdit_uploadFail_message: "上传失败！",

  // modal
  scenes_Algorithm_AlgorithmEdit_modal_success_title: "成功",
  scenes_Algorithm_AlgorithmEdit_modal_fail_title: "失败",
  scenes_Algorithm_AlgorithmEdit_modal_submitSuccess_content: "保存成功，是否提交管理员审核？",
  scenes_Algorithm_AlgorithmEdit_modal_submitFail_content: "保存失败！",
  scenes_Algorithm_AlgorithmEdit_modal_auditSuccess_content: "提交审核成功，请返回算法列表主页。",
  scenes_Algorithm_AlgorithmEdit_modal_auditFail_content: "提交审核失败！",
  scenes_Algorithm_AlgorithmEdit_modal_OK_label: "确定",
  scenes_Algorithm_AlgorithmEdit_modal_cancel_label: "取消",
  scenes_Algorithm_AlgorithmEdit_modal_return_label: "返回",
  scenes_Algorithm_AlgorithmEdit_modal_yes_label: "是",
  scenes_Algorithm_AlgorithmEdit_modal_no_label: "否",
  scenes_Algorithm_AlgorithmEdit_modal_returnConfirm_label: "确认",
  scenes_Algorithm_AlgorithmEdit_modal_return_content: "您有更改内容，是否返回前一页",
  scenes_Algorithm_AlgorithmEdit_modal_returnOK_label: "确定",
  scenes_Algorithm_AlgorithmEdit_modal_returnCancel_label: "取消",
  /**** ALGORITHM EDIT END ****/

  /**** ALGORITHM VIEW ****/
  // table
  scenes_Algorithm_AlgorithmView_parameterName_title: "参数名称",
  scenes_Algorithm_AlgorithmView_parameterType_title: "参数类型",
  scenes_Algorithm_AlgorithmView_defaultValue_title: "默认值",
  scenes_Algorithm_AlgorithmView_parameterScope_title: "参数范围",
  scenes_Algorithm_AlgorithmView_parameterDescription_title: "参数说明",

  // label
  scenes_Algorithm_AlgorithmView_description_label: "算法描述",
  scenes_Algorithm_AlgorithmView_name_label: "算法名称",
  scenes_Algorithm_AlgorithmView_category_label: "算法类别",
  scenes_Algorithm_AlgorithmView_type_label: "开发语言",
  scenes_Algorithm_AlgorithmView_file_label: "算法文件",
  scenes_Algorithm_AlgorithmView_notUpload_label: "未上传",
  scenes_Algorithm_AlgorithmView_download_label: "下载",
  scenes_Algorithm_AlgorithmView_downloaded_label: "已下载",
  scenes_Algorithm_AlgorithmView_downloading_label: "下载中",
  scenes_Algorithm_AlgorithmView_return_label: "返回",

  //message
  scenes_Algorithm_AlgorithmView_downloadSuccess_message: "下载成功",
  scenes_Algorithm_AlgorithmView_downloadFail_message: "下载失败",
  /**** ALGORITHM VIEW END ****/

  /**** ALGORITHM LIBRARY ****/
  // table
  scenes_Algorithm_AlgorithmLibrary_parameterName_title: "参数名称",
  scenes_Algorithm_AlgorithmLibrary_parameterType_title: "参数类型",
  scenes_Algorithm_AlgorithmLibrary_parameterDefaultValue_title: "默认值",
  scenes_Algorithm_AlgorithmLibrary_parameterScope_title: "参数范围",
  scenes_Algorithm_AlgorithmLibrary_parameterDescription_title: "参数说明",

  // label
  scenes_Algorithm_AlgorithmLibrary_name_label: "算法名称",
  scenes_Algorithm_AlgorithmLibrary_developer_label: "开发者",
  scenes_Algorithm_AlgorithmLibrary_description_label: "算法描述",
  scenes_Algorithm_AlgorithmLibrary_parameter_label: "算法参数",

  // placeholder
  scenes_Algorithm_AlgorithmLibrary_search_placeholder: "搜索算法名称",
  /**** ALGORITHM LIBRARY END ****/

  /**** ALGORITHM MANAGEMENT ****/
  // table
  scenes_Algorithm_AlgorithmManagement_algorithmName_title: "算法名称",
  scenes_Algorithm_AlgorithmManagement_algorithmDate_title: "上传时间",

  // label
  scenes_Algorithm_AlgorithmManagement_algorithmCategory_label: "算法类别：",
  scenes_Algorithm_AlgorithmManagement_modifyCategory_label: "修改类别",
  scenes_Algorithm_AlgorithmManagement_offlineAlgorithm_label: "下线算法",
  scenes_Algorithm_AlgorithmManagement_parameter_label: "算法参数",

  // placeholder
  scenes_Algorithm_AlgorithmManagement_search_placeholder: "搜索算法名称",

  //confirm modal
  scenes_Algorithm_AlgorithmManagement_modal_modifyCategory_title: "修改类别",
  scenes_Algorithm_AlgorithmManagement_modal_offlineAlgorithm_content: "确认将已选的算法下线吗？",
  scenes_Algorithm_AlgorithmManagement_modal_submit_label: "提交",
  scenes_Algorithm_AlgorithmManagement_modal_confirm_label: "确认",
  scenes_Algorithm_AlgorithmManagement_modal_cancel_label: "取消",

  // modal
  scenes_Algorithm_AlgorithmManagement_modal_success_title: "成功",
  scenes_Algorithm_AlgorithmManagement_modal_fail_title: "失败",
  scenes_Algorithm_AlgorithmManagement_modal_updateSuccess_content: "修改类别成功！",
  scenes_Algorithm_AlgorithmManagement_modal_updateFail_content: "修改类别失败！",
  scenes_Algorithm_AlgorithmManagement_modal_offlineSuccess_content: "下线算法成功！",
  scenes_Algorithm_AlgorithmManagement_modal_offlineFail_content: "下线算法失败！",
  scenes_Algorithm_AlgorithmManagement_modal_OK_label: "确定",
  scenes_Algorithm_AlgorithmManagement_modal_return_label: "返回",
  /**** ALGORITHM MANAGEMENT END ****/

  /**** ALGORITHM SERVICE END ****/

  /**** zqy CODE START ****/

  /**** EQUIPMENT VERIFY DESTROY ****/
  //label
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_destroyCertify_label: "证书注销",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_return_label: "返回",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_confirmDestroy_label: "注销确认",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_id_label: "GUID",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_description_label: "简介",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_destroyDescription_label: "注销说明",

  //modal
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_success_title: "成功",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_fail_title: "失败",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_submitSuccess_content: "提交成功",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_submitFail_content: "提交失败",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_OK_label: "确定",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_return_title: "内容有变化，确认返回？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_confirm_label: "确认",

  //message
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_destroyDescription_message: "请输入注销说明",

  //placeholder
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_destroyDescription_placeholder: "请输入注销说明",

  /**** EQUIPMENT VERIFY DESTROY  END ****/

  /**** EQUIPMENT CERTIFY LIST ****/
  //label
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_id_label: "GUID",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_description_label: "简介",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_registerCompanyName_label: "租户",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_registerUserName_label: "申请人",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_validityTerm_label: "有效期",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_certifyStatus_label: "状态",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_certify_label: "申请",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_destroy_label: "注销",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_delete_label: "删除",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_copy_label: "复制",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_download_label: "下载",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_return_label: "返回",

  //popconfirm
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_popconfirm_destroy_title: "确认注销吗？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_popconfirm_delete_title: "确认删除吗？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_popconfirm_OK_label: "确认",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_popconfirm_cancel_label: "取消",

  //modal
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_success_title: "成功",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_fail_title: "失败",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_deleteSuccess_content: "删除成功",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_deleteFail_content: "删除失败",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_OK_label: "确定",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_return_title: "内容有变化，确认返回？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_confirm_label: "确认",

  //message
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_copyId_message: "认证 GUID 已复制！",

  /**** EQUIPMENT CERTIFY LIST END****/

  /**** EQUIPMENT CERTIFY REGISTER ****/
  //label
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_certifyRegister_label: "证书申请",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_return_label: "返回",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_submitRegister_label: "提交申请",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_validityTerm_label: "有效期",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_description_label: "简介",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_registerDescription_label: "申请说明",

  //modal
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_success_title: "成功",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_fail_title: "失败",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_submitSuccess_content: "提交成功",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_submitFail_content: "提交失败",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_OK_label: "确定",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_return_title: "内容有变化，确认返回？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_confirm_label: "确认",

  //message
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_validityTerm_message: "请选择有效期",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_description_message: "请输入简介",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_registerDescription_message: "请输入申请说明",

  //placeholder
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_beginDate_placeholder: "开始日期",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_endData_placeholder: "结束日期",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_description_placeholder: "请输入简介",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_registerDescription_placeholder: "请输入申请说明",

  /**** EQUIPMENT CERTIFY REGISTER END****/

  /**** CERTIFY VERIFY LIST ****/

  //label
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_destroyCertify_label: "证书注销",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_return_label: "返回",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_confirmDestroy_label: "注销确认",

  //modal
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_success_title: "成功",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_fail_title: "失败",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_deleteSuccess_content: "删除成功",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_deleteFail_content: "删除失败",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentCertifyVerify_CertifyVerifyList_modal_OK_label: "确定",
  /**** CERTIFY VERIFY LIST END ****/

  /**** EQUIPMENT CERTIFY VERIFY ****/
  //title
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_id_title: "GUID",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_description_title: "简介",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_registerCompanyName_title: "租户",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_registerUserName_title: "申请人",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_registerTime_title: "申请时间",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_validityTerm_title: "有效期",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_verifyCategory_title: "审核类别",

  //label
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_verifyCategory_label: "审核类别",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_registerTime_label: "申请时间",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_all_label: "全部",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_pass_label: "通过",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_noPass_label: "不通过",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_viewDescription_label: "查看说明",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_query_label: "查询",

  //placeholder
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_startTime_placeholder: "开始时间",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_endTime_placeholder: "结束时间",

  //confirm
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_verify_title: "确认通过审核吗？",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_reason_title: "点击确认，会将不通过的原因发送给申请人",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_reason_placeholder: "请输入不通过的原因",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_registerDescription_title: "申请说明",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_OK_label: "确认",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_cancel_label: "取消",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_confirm_off_label: "关闭",

  //modal
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_success_title: "成功",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_fail_title: "失败",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_verifySuccess_content: "审核成功",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_verifyFail_content: "审核失败",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_OK_label: "确定",
  scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_cancel_label: "取消",
  /**** EQUIPMENT CERTIFY VERIFY END****/

  /**** EQUIPMENT TYPE LIST ****/

  //label
  scenes_Equipment_EquipmentType_EquipmentTypeList_add_label: "添加",
  scenes_Equipment_EquipmentType_EquipmentTypeList_edit_label: "编辑",
  scenes_Equipment_EquipmentType_EquipmentTypeList_delete_label: "删除",

  //modal
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_success_title: "成功",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_fail_title: "失败",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_deleteSuccess_content: "删除成功",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_deleteFail_content: "删除失败",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentType_EquipmentTypeList_modal_OK_label: "确定",

  //table
  scenes_Equipment_EquipmentType_EquipmentTypeList_id_title: "类型GUID",
  scenes_Equipment_EquipmentType_EquipmentTypeList_code_title: "类型编码",
  scenes_Equipment_EquipmentType_EquipmentTypeList_name_title: "类型名称",
  scenes_Equipment_EquipmentType_EquipmentTypeList_description_title: "描述",
  scenes_Equipment_EquipmentType_EquipmentTypeList_ifDynamic_title: "动态配置",
  scenes_Equipment_EquipmentType_EquipmentTypeList_ifDynamicYes_title: "是",
  scenes_Equipment_EquipmentType_EquipmentTypeList_ifDynamicNo_title: "否",

  //popconfirm
  scenes_Equipment_EquipmentType_EquipmentTypeList_popconfirm_delete_title: "确认删除吗？",
  scenes_Equipment_EquipmentType_EquipmentTypeList_popconfirm_OK_label: "确认",
  scenes_Equipment_EquipmentType_EquipmentTypeList_popconfirm_cancel_label: "取消",
  //placeholder
  scenes_Equipment_EquipmentType_EquipmentTypeList_filterEquipmentTypeName_placeholder: "过滤网关类型名称",

  /**** EQUIPMENT TYPE LIST END ****/

  /**** EQUIPMENT TYPE ADD ****/
  //label
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_equipmentTypeAdd_label: "添加网关类型",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_return_label: "返回",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_submit_label: "提交",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_name_label: "类别名称",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_code_label: "类别编码",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_ifDynamic_label: "是否动态配置",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_description_label: "类别描述",

  //message
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_name_message: "请输入类别名称",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_code_message: "请输入类别编码",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_description_message: "请输入类别描述",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_checkName_message: "类别名称已存在，请重新输入",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_checkCode_message: "类别编码已存在，请重新输入",
  //modal
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_success_title: "成功",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_fail_title: "失败",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_return_title: "内容有变化，确认返回？",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_addSuccess_content: "添加成功",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_addFail_content: "添加失败",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_OK_label: "确定",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_confirm_label: "确认",

  // placeholder
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_name_placeholder: "请输入类别名称",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_code_placeholder: "请输入类别编码",
  scenes_Equipment_EquipmentType_EquipmentTypeAdd_description_placeholder: "请输入类别描述",

  /**** EQUIPMENT TYPE ADD END ****/
  /**** EQUIPMENT TYPE EDIT ****/
  //label
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_equipmentTypeEdit_label: "编辑网关类型",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_return_label: "返回",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_submit_label: "提交",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_name_label: "类别名称",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_code_label: "类别编码",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_ifDynamic_label: "是否动态配置",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_description_label: "类别描述",

  //message
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_name_message: "请输入类别名称",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_code_message: "请输入类别编码",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_description_message: "请输入类别描述",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_checkName_message: "类别名称已存在，请重新输入",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_checkCode_message: "类别编码已存在，请重新输入",

  //modal
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_success_title: "成功",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_fail_title: "失败",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_return_title: "内容有变化，确认返回？",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_editSuccess_content: "提交成功",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_editFail_content: "提交失败",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_OK_label: "确定",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_confirm_label: "确认",

  // placeholder
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_name_placeholder: "请输入类别名称",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_code_placeholder: "请输入类别编码",
  scenes_Equipment_EquipmentType_EquipmentTypeEdit_description_placeholder: "请输入类别描述",

  /**** EQUIPMENT TYPE EDIT END ****/

  /**** EQUIPMENT LIST ****/

  //table
  scenes_Equipment_EquipmentManagement_EquipmentList_id_title: "网关GUID",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentType_title: "网关类型",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentId_title: "硬件ID",
  scenes_Equipment_EquipmentManagement_EquipmentList_registerCompanyName_title: "租户",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentIp_title: "IP",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentPort_title: "端口",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentCertify_title: "证书",
  scenes_Equipment_EquipmentManagement_EquipmentList_equipmentStatus_title: "状态",

  //modal
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_success_title: "成功",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_fail_title: "失败",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_stopSuccess_content: "停用成功",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_stopFail_content: "停用失败",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_cancel_label: "取消",
  scenes_Equipment_EquipmentManagement_EquipmentList_modal_OK_label: "确定",
  //label
  scenes_Equipment_EquipmentManagement_EquipmentList_add_label: "添加",
  scenes_Equipment_EquipmentManagement_EquipmentList_edit_label: "修改",
  scenes_Equipment_EquipmentManagement_EquipmentList_config_label: "配置",
  scenes_Equipment_EquipmentManagement_EquipmentList_checkData_label: "查看数据",
  scenes_Equipment_EquipmentManagement_EquipmentList_log_label: "查看日志",
  scenes_Equipment_EquipmentManagement_EquipmentList_commandGive_label: "下达命令",
  scenes_Equipment_EquipmentManagement_EquipmentList_stopEquipment_label: "网关停用",

  //placeholder
  scenes_Equipment_EquipmentManagement_EquipmentList_filterEquipmentType_placeholder: "过滤网关类型",

  /**** EQUIPMENT LIST END ****/

  /**** EQUIPMENT CONFIG ****/
  //table
  scenes_Equipment_EquipmentManagement_EquipmentConfig_name_title: "节点名称",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_alias_title: "别名",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_description_title: "描述",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataType_title: "数据类型",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataUnit_title: "数据单位",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_sampleMode_title: "采集方式",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_period_title: "采集周期",

  //label
  scenes_Equipment_EquipmentManagement_EquipmentConfig_equipmentGuid_label: "网关GUID：",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_generalConfig_label: "通用配置",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_transferProtocol_label: "数据传输协议",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_compressMethod_label: "数据压缩方式",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataTransferUrl_label: "数据传输服务url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_fileTransferUrl_label: "文件传输服务url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_period_label: "数据传输周期",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_buffer_label: "数据缓存大小",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_nodeConfig_label: "节点配置",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_return_label: "返回",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_next_label: "下一步",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_previous_label: "上一步",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_submit_label: "完成",

  //message
  scenes_Equipment_EquipmentManagement_EquipmentConfig_required_message: "必填",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_transferProtocol_message: "请选择数据传输协议",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_compressMethod_message: "请选择数据压缩方式",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataTransferUrl_message: "请输入数据传输服务url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_fileTransferUrl_message: "请输入文件传输服务url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_period_message: "请输入数据传输周期",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_buffer_message: "请输入数据缓存大小",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_checkAlias_message: "别名已存在，请重新输入",

  //placeholder
  scenes_Equipment_EquipmentManagement_EquipmentConfig_transferProtocol_placeholder: "请选择数据传输协议",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_compressMethod_placeholder: "请选择数据压缩方式",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_dataTransferUrl_placeholder: "请输入数据传输服务url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_fileTransferUrl_placeholder: "请输入文件传输服务url",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_period_placeholder: "请输入数据传输周期",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_buffer_placeholder: "请输入数据缓存大小",

  //  modal
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_return_title: "确认",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_return_content: "当前内容有变化，确认放弃吗？",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_return_OK_label: "确认",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_return_cancel_label: "取消",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_success_title: "成功",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_fail_title: "失败",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_submitSuccess_content: "网关配置保存成功!",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_submitFail_content: "网关配置保存失败!",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_OK_label: "确定",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_cancel_label: "返回",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_yes_label: "是",
  scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_no_label: "否",
  /**** EQUIPMENT CONFIG END ****/

  /**** EQUIPMENT DATA VIEW ****/
  // table
  scenes_Equipment_EquipmentManagement_EquipmentDataView_nodeName_title: "节点名称",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_alias_title: "别名",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_description_title: "描述",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_dataType_title: "数据类型",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_dataUnit_title: "数据单位",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_value_title: "值",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_timeStamp_title: "时间",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_receive_ts_title: "接收时间",
  scenes_Equipment_EquipmentManagement_EquipmentDataView_timeStamp_error: "时间错误",

  //label
  scenes_Equipment_EquipmentManagement_EquipmentDataView_return_label: "返回",

  /**** EQUIPMENT DATA VIEW END ****/

  /**** EQUIPMENT DETAIL ****/
  //table
  scenes_Equipment_EquipmentManagement_EquipmentDetail_name_title: "节点名称",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_alias_title: "别名",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_description_title: "描述",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_dataType_title: "数据类型",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_dataUnit_title: "数据单位",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_sampleMode_title: "采集方式",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_period_title: "采集周期",

  //label
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentInfo_label: "网关信息",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentType_label: "网关类型",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentId_label: "硬件ID",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentIp_label: "IP",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentPort_label: "端口",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentCertify_label: "证书",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentStatus_label: "状态",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_equipmentConfig_label: "设备配置",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_transferProtocol_label: "数据传输协议",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_compressMethod_label: "数据压缩方式",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_dataTransferUrl_label: "数据传输服务url",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_fileTransferUrl_label: "文件传输服务url",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_period_label: "数据传输周期",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_buffer_label: "数据缓存大小",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_collectNodeConfig_label: "采集节点配置",
  scenes_Equipment_EquipmentManagement_EquipmentDetail_return_label: "返回",
  /**** EQUIPMENT DETAIL END ****/

  /**** EQUIPMENT LOG ****/
  //table
  scenes_Equipment_EquipmentManagement_EquipmentLog_time_title: "日志时间",
  scenes_Equipment_EquipmentManagement_EquipmentLog_logType_title: "日志类型",
  scenes_Equipment_EquipmentManagement_EquipmentLog_content_title: "日志内容",

  //label
  scenes_Equipment_EquipmentManagement_EquipmentLog_search_label: "查询",
  scenes_Equipment_EquipmentManagement_EquipmentLog_reset_label: "重置",

  //placeholder
  scenes_Equipment_EquipmentManagement_EquipmentLog_beginDate_placeholder: "开始日期",
  scenes_Equipment_EquipmentManagement_EquipmentLog_endData_placeholder: "结束日期",
  scenes_Equipment_EquipmentManagement_EquipmentLog_types_placeholder: "日志类型",
  /**** EQUIPMENT LOG END ****/

  /**** EQUIPMENT BACKUP LIST ****/
  //table
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_id_title: "网关GUID",
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_equipmentType_title: "网关类型",
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_equipmentId_title: "硬件ID",
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_registerCompanyName_title: "租户",
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_equipmentIp_title: "IP",
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_equipmentPort_title: "端口",

  //modal
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_modal_success_title: "成功",
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_modal_fail_title: "失败",
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_modal_OK_label: "确定",
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_modal_cancel_label: "取消",
  //label
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_config_label: "设置",

  //placeholder
  scenes_Equipment_EquipmentBackup_EquipmentBackupList_filterEquipmentType_placeholder: "过滤网关类型",
  /**** EQUIPMENT BACKUP LIST END ****/

  /**** EQUIPMENT BACKUP CONFIG ****/
  //table
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_name_title: "节点名称",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_alias_title: "别名",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_description_title: "描述",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_dataType_title: "数据类型",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_dataUnit_title: "数据单位",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_sampleMode_title: "采集方式",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_period_title: "采集周期",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_ifBackup_title: "数据备份",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_on_label: "开",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_off_label: "关",

  //label
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_equipmentGuid_label: "网关GUID：{equipmentId}",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_return_label: "返回",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_submit_label: "保存",

  //  modal
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_success_title: "成功",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_fail_title: "失败",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_submitSuccess_content: "数据备份设置成功!",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_submitFail_content: "数据备份设置失败!",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_OK_label: "确定",
  scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_cancel_label: "返回",
  /**** EQUIPMENT BACKUP CONFIG END ****/

  /**** EQUIPMENT BACKUP DETAIL ****/
  //table
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_name_title: "节点名称",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_alias_title: "别名",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_description_title: "描述",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_dataType_title: "数据类型",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_dataUnit_title: "数据单位",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_sampleMode_title: "采集方式",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_period_title: "采集周期",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_ifBackup_title: "数据备份",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_value_title: "值",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_time_title: "采集时间",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_recvtime_title: "接收时间",

  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_time_error: "时间错误",
  //label
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_equipmentGuid_label: "网关GUID：{equipmentId}",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_name_label: "节点名称",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_alias_label: "节点别名",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_time_label: "采集时间（单位：毫秒）",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_return_label: "返回",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_dataView_label: "查询历史数据",

  //placeholder
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_name_placeholder: "请选择节点名称",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_alias_placeholder: "请输入节点别名",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_start_time_placeholder: "请输入开始时间",
  scenes_Equipment_EquipmentBackup_EquipmentBackupDetail_end_time_placeholder: "请输入结束时间",

  /**** EQUIPMENT BACKUP DETAIL END ****/

  /**** BIG DATA SERVICE START ****/
  scenes_bigData_dataSet_list_title: "数据集列表",
  scenes_bigData_model_list_title: "模型列表",
  scenes_bigData_project_list_title: "大数据工程列表",
  /**** BIG DATA SERVICE END ****/

  /**** BIG DATA DATASET MANAGEMENT START ****/
  scenes_dataset_management_upload_failed_message: "上传失败，请重试",
  scenes_dataset_management_modal_ok: "确定",
  scenes_dataset_management_upload_success_modal_title: "上传数据集成功",
  scenes_dataset_management_upload_failed_modal_title: "上传数据集失败",
  scenes_dataset_management_delete_success_modal_title: "删除数据集成功",
  scenes_dataset_management_delete_failed_modal_title: "删除数据集失败",
  scenes_dataset_management_upload_type_message: "请选择正确的文件类型！",
  scenes_dataset_management_upload_size_message: "文件必须小于2MB!",
  scenes_dataset_management_upload_check: "请上传文件！",
  scenes_dataset_management_form_file_label: "上传新数据",
  scenes_dataset_management_form_file_required: "请上传文件",
  scenes_dataset_management_form_name_label: "数据集名称",
  scenes_dataset_management_form_name_required: "请输入数据集名称",
  scenes_dataset_management_form_name_placeholder: "请输入数据集名称",
  scenes_dataset_management_form_type_label: "数据集类型",
  scenes_dataset_management_form_type_required: "请选择数据集类型",
  scenes_dataset_management_form_type_placeholder: "请选择数据集类型",
  scenes_dataset_management_form_category_label: "数据集类别",
  scenes_dataset_management_form_category_required: "请选择类别",
  scenes_dataset_management_form_category_placeholder: "请选择类别",
  scenes_dataset_management_form_description_label: "数据集描述",
  scenes_dataset_management_form_description_required: "请输入数据集描述",
  scenes_dataset_management_form_description_placeholder: "请输入数据集描述",
  scenes_dataset_management_button_submit: "上传",
  scenes_dataset_management_button_cancel: "取消",
  scenes_dataset_management_table_title_name: "名称",
  scenes_dataset_management_table_title_description: "说明",
  scenes_dataset_management_table_title_dataType: "数据类型",
  scenes_dataset_management_table_title_category: "数据集类别",
  scenes_dataset_management_table_title_createdAt: "创建时间",
  scenes_dataset_management_table_title_size: "数据大小",
  scenes_dataset_management_table_title_projectFileName: "工程",
  scenes_dataset_management_user_tab: "我的数据集",
  scenes_dataset_management_user_upload_button: "上传",
  scenes_dataset_management_user_save_button: "保存",
  scenes_dataset_management_user_delete_button: "删除",
  scenes_dataset_management_user_search_placeholder: "请输入数据集名称",
  scenes_dataset_management_system_tab: "系统数据集",
  scenes_dataset_management_system_search_placeholder: "请输入数据集名称",
  scenes_dataset_management_delete_modal_title: "删除用户",
  scenes_dataset_management_delete_modal_cancel: "取消",
  scenes_dataset_management_delete_modal_ok: "确认",
  scenes_dataset_management_delete_modal_message: "是否删除",
  /**** BIG DATA DATASET MANAGEMENT END ****/



  /**** FEEDBACK ****/
  scense_Feedback_submit_successfully: "您的反馈已提交",
  scense_Feedback_submit_failed: "您的反馈提交失败",
  scense_Feedback_card: "咨询反馈",
  scense_Feedback_username_required_message: "请输入用户名",
  scense_Feedback_username_placeholder: "姓名",
  scense_Feedback_email_required_message: "请输入邮箱",
  scense_Feedback_email_placeholder: "邮箱",
  scense_Feedback_phone_required_message: "请输入手机号",
  scense_Feedback_phone_placeholder: "手机号",
  scense_Feedback_content_required_message: "请输入内容",
  scense_Feedback_content_placeholder: "咨询内容",
  scense_Feedback_submit_button: "提交",
  scense_Feedback_return_button: "返回",
  /**** FEEDBACK END ****/

  /**** ENTERPRISE APPS COMPONENT ****/
  scense_enterprise_apps_component_state_running: "运行",
  scense_enterprise_apps_component_state_crashed: "宕机",
  scense_enterprise_apps_component_state_stopped: "停止",
  scense_enterprise_apps_component_table_appName: "应用名称",
  scense_enterprise_apps_component_table_state: "运行状态",
  scense_enterprise_apps_component_table_instances: "实例个数",
  scense_enterprise_apps_component_table_memory: "内存大小",
  scense_enterprise_apps_component_table_diskQuota: "硬盘大小",
  scense_enterprise_apps_component_card_title: "企业部署应用列表",
  scense_enterprise_apps_component_ringChart_running_label: "运行率",
  scense_enterprise_apps_component_ringChart_crashed_label: "宕机率",
  scense_enterprise_apps_component_ringChart_stopped_label: "停止率",
  scense_enterprise_apps_component_button: "应用管理",
  /**** ENTERPRISE APPS COMPONENT END ****/

  //  namespace租户空间
  scenes_Namespace_Verify_modal_success_title: "成功",
  scenes_Namespace_NamespaceVerify_modal_fail_title: "失败",
  scenes_Namespace_NamespaceVerify_modal_auditSuccess_title: "审核成功!",
  scenes_Namespace_NamespaceVerify_modal_auditFail_title: "审核失败!",
  scenes_Namespace_NamespaceVerify_modal_OK_title: "确定",
  scenes_Namespace_NamespaceVerify_modal_cancel_title: "返回",
  //  租户空间modal
  scenes_Namespace_NamespaceVerify_modal_success_title: "成功",
  scenes_Namespace_NamespaceVerify_modal_auditSuccess_content: "审核成功!",
  scenes_Namespace_NamespaceVerify_modal_auditFail_content: "审核失败!",
  scenes_Namespace_NamespaceVerify_modal_OK_label: "确定",
  scenes_Namespace_NamespaceVerify_modal_cancel_label: "返回",
  // modal
  scenes_Namespace_NamespaceList_modal_success_title: "成功",
  scenes_Namespace_NamespaceList_modal_fail_title: "失败",
  scenes_Namespace_NamespaceList_modal_statusSuccess_content: "更新状态成功！",
  scenes_Namespace_NamespaceList_modal_statusFail_content: "更新状态失败！",
  scenes_Namespace_NamespaceList_modal_auditSuccess_content: "提交审核成功！",
  scenes_Namespace_NamespaceList_modal_auditFail_content: "提交审核失败！",
  scenes_Namespace_NamespaceList_modal_onlineSuccess_content: "上线成功！",
  scenes_Namespace_NamespaceList_modal_onlineFail_content: "上线失败！",
  scenes_Namespace_NamespaceList_modal_offlineSuccess_content: "下线成功！",
  scenes_Namespace_NamespaceList_modal_offlineFail_content: "下线失败！",
  scenes_Namespace_NamespaceList_modal_disabledSuccess_content: "封存成功！",
  scenes_Namespace_NamespaceList_modal_disabledFail_content: "封存失败！",
  scenes_Namespace_NamespaceList_modal_OK_label: "确定",
  scenes_Namespace_NamespaceList_modal_cancel_label: "取消",

  scenes_Namespace_NamespaceVerify_name_placeholder: "搜索租户空间"
};



export default zh_CN
